module.exports = {
	"pt": {
		"moet-core": {
			"select_language": {
				"title": "Selecione o seu idioma",
				"paragraph": "Este será o seu idioma predefinido.",
				"submit": "OK"
			},
			"products": {
				"mandatory": "Sempre incluído",
				"kco": {
					"name": {
						"default": "Finalização de compra"
					},
					"description": {
						"default": "Oferecer todas as nossas formas de pagamento."
					},
					"options": {
						"kco-pay-now": {
							"name": {
								"default": "Pagar agora"
							},
							"description": {
								"default": "Oferecer pagamentos instantâneos por cartão ou transferência bancária."
							}
						},
						"kco-pay-later": {
							"name": {
								"default": "Pagar em 30 dias"
							},
							"description": {
								"default": "Oferecer 30 dias para pagar. Sem juros."
							}
						},
						"kco-slice-it": {
							"name": {
								"default": "Financiamento"
							},
							"description": {
								"default": "Oferecer para pagar ao longo de 6 a 36 meses.",
								"DE": "Oferecer para pagar ao longo de 6 a 24 meses",
								"AT": "Oferecer para pagar ao longo de 6 a 24 meses."
							}
						},
						"kco-slice-it-in-3": {
							"name": {
								"default": "Prestações"
							},
							"description": {
								"default": "Oferecer 3 prestações sem juros.",
								"GB": "Oferecer 3 prestações sem juros."
							}
						},
						"kco-slice-it-in-4": {
							"name": {
								"default": "Dividir em 4",
								"US": "Prestações",
								"AU": "Pagar em 4 prestações"
							},
							"description": {
								"default": "Oferecer 4 prestações sem juros.",
								"GB": "Oferecer 4 prestações sem juros."
							}
						}
					}
				},
				"kp": {
					"name": {
						"default": "Formas de pagamento"
					},
					"description": {
						"default": "Escolher entre as nossas soluções de pagamento independente. Escolher uma ou combinar várias. Integração simples, numa vez, independentemente do que escolher."
					},
					"options": {
						"kp-pay-now": {
							"name": {
								"default": "Pagar agora"
							},
							"description": {
								"default": "Oferecer pagamentos instantâneos por cartão ou transferência bancária."
							}
						},
						"kp-pay-later": {
							"name": {
								"default": "Pagar em 30 dias"
							},
							"description": {
								"default": "Oferecer 30 dias para pagar. Sem juros."
							}
						},
						"kp-slice-it": {
							"name": {
								"default": "Financiamento"
							},
							"description": {
								"default": "Oferecer para pagar ao longo de 6 a 36 meses.",
								"DE": "Oferecer para pagar ao longo de 6 a 24 meses",
								"AT": "Oferecer para pagar ao longo de 6 a 24 meses."
							}
						},
						"kp-slice-it-in-3": {
							"name": {
								"default": "Prestações"
							},
							"description": {
								"default": "Oferecer 3 prestações sem juros.",
								"GB": "Oferecer 3 prestações sem juros."
							}
						},
						"kp-slice-it-in-4": {
							"name": {
								"default": "Dividir em 4",
								"US": "4 pagamentos",
								"CA": "4 pagamentos",
								"AU": "Pagar em 4 prestações"
							},
							"description": {
								"default": "Oferecer 4 prestações sem juros.",
								"GB": "Oferecer 4 prestações sem juros.",
								"US": "Encomendas entre 35 USD e 1000 USD podem ser divididas em 4 pagamentos sem juros, a serem feitos a cada 2 semanas.",
								"CA": "Encomendas entre 35 USD e 1000 USD podem ser divididas em 4 pagamentos sem juros, a serem feitos a cada 2 semanas."
							}
						}
					}
				},
				"kco_one": {
					"name": {
						"default": "Finalização de compra"
					},
					"description": {
						"default": "Substituir a sua finalização de compra da loja pelos serviços completos de finalização de compra da Klarna."
					},
					"description_expanded": {
						"default": "Substituir a sua finalização de compra da loja pelos serviços completos de finalização de compra da Klarna."
					}
				},
				"kp_one": {
					"name": {
						"default": "Forma de pagamento"
					},
					"description": {
						"default": "Adicione formas de pagamento Klarna à sua finalização de compra existente."
					},
					"description_expanded": {
						"default": "Oferecer formas de pagamento Klarna leva a um aumento médio de 30% na conversão, de 41% no valor médio de encomendas (AOV) e 36% na frequência de compras."
					}
				}
			}
		},
		"products-fe": {
			"error_messages": {
				"validation": {
					"required": "Este campo é obrigatório para continuar",
					"generic": "O valor fornecido é inválido",
					"required_suffix": "é obrigatório para continuar",
					"generic_suffix": "é inválido",
					"min_one": "Tem de selecionar pelo menos um elemento",
					"min": "Tem de selecionar pelo menos {min} elementos",
					"max": "Não pode selecionar mais do que {min} elementos",
					"given_name": "Nome próprio em falta",
					"family_name": {
						"general": "Apelido em falta",
						"too_short": "Introduza um apelido válido"
					},
					"date_of_birth": {
						"general": {
							"default": "Introduza uma data de nascimento válida (DD/MM/AAAA)",
							"US": "Introduza uma data de nascimento válida (MM/DD/AAAA)"
						},
						"too_young": "Todas as partes interessadas têm de ter mais de 16 anos",
						"too_young_eighteen": "Tem de ter mais de 18 anos"
					},
					"street_address": "Introduza um endereço",
					"street_address2": "Introduza uma linha de endereço 2 válida",
					"postal_code": "Introduza um código postal",
					"country": "Introduza um país",
					"region": "Introduza uma região",
					"state": "Introduza um estado",
					"iban": "Introduza um número de conta (IBAN)",
					"companyName": "Introduza um nome de empresa",
					"email": "Introduza um e-mail válido",
					"contact_email": "Introduza um e-mail de contacto válido",
					"support_email": "Introduza um e-mail de apoio ao cliente válido",
					"support_phone": "Introduza um número de telefone de apoio válido",
					"selling_countries": "Tem de selecionar pelo menos um país",
					"store_category": "Precisa de selecionar uma das opções",
					"name": "Introduza um nome de loja",
					"legal_form": "Escolha um dos tipos de negócio indicados",
					"generic_toggle_undefined": "Selecione uma das opções",
					"website": "Introduza um url de website válido",
					"bankAccounts": "Introduza pelo menos uma conta bancária",
					"product": "Selecione um produto",
					"platform": "Selecione uma plataforma",
					"password": "Crie uma palavra-passe forte",
					"currency_code": "Introduza um código de moeda",
					"account_holder": "Introduza um titular de conta bancária",
					"account_type": "Introduza um tipo de conta bancária",
					"routing_number": "Introduza um número de encaminhamento válido",
					"account_number": {
						"first": "Introduza um número de conta válido para a conta bancária predefinida",
						"second": "Introduza um número de conta válido para a primeira conta bancária adicional",
						"third": "Introduza um número de conta válido para a segunda conta bancária adicional",
						"fourth": "Introduza um número de conta válido para a terceira conta bancária adicional",
						"general": "Introduza um número de conta válido"
					},
					"role": "Introduza um cargo",
					"address": "Introduza um endereço",
					"political_exposed_person": "Introduza uma informação de PPE",
					"pep_position": "Introduza uma informação de posição",
					"pep_relationship": "Introduza uma informação de relação com a pessoa PPE",
					"goodsCategory": "Introduza uma categoria de mercadorias",
					"registered": "Introduza informação sobre o registo da sua empresa",
					"subjectToVat": "Introduza um número de IVA",
					"registrationCourt": "Introduza um tribunal de registo",
					"registrationId": {
						"general": {
							"default": "Introduza um número de registo válido",
							"AT": "Introduza um número de registo válido",
							"AU": "Introduza um ACN válido",
							"ES": "Introduza um NIF/NIE/DNI de empresa válido",
							"GB": "Introduza um número de organização válido",
							"GR": "Introduza um número G.E.MI. válido (Γ.Ε.ΜΗ.)",
							"CA": "Introduza um número de empresa válido",
							"NZ": "Introduza um número de empresa válido",
							"US": "Introduza um número de identificação de empregador válido"
						},
						"missing_leading_0_GB": "Introduza um número de organização de 8 dígitos. Pode estar a faltar um 0 no início do número da sua organização (ex., 03452678)",
						"invalid": {
							"default": "Introduza um número de registo válido",
							"AT": "O número de registo deve ter entre 5 e 11 caracteres. Entenda que este não é o seu IVA nem a sua ID de comerciante.",
							"AU": "O ACN deve ter 9 dígitos sem espaços. Ex.: 123456789",
							"BE": "O número de registo deve ter 10 dígitos. Ex.: 1234567890",
							"CA": "O número da empresa deve ter 9 dígitos. Ex.: 123456789",
							"CZ": "O número de registo deve ter 8 dígitos. Ex.: 12345678",
							"DE": "O número de registo deve ter 6 a 11 caracteres e tem de começar por HRA, HRB, GnR, VR ou PR seguido por um espaço. Entenda que este não é o seu IVA nem a sua ID de comerciante.",
							"ES": "O NIF/NIE/DNI deve ter 8 ou 9 caracteres começando por 1 letra/dígito seguido por 6 ou 7 dígitos e 1 letra/dígito",
							"FI": "O número de registo deve ter 8 dígitos com um travessão antes do último, sem espaços. Ex.: 1234567-8",
							"FR": "O número de registo deve ter 9 dígitos, por ex., 123 456 789 ou 123456789 (SIREN), ou 14 dígitos, ex., 123 456 789 12345 ou 12345678912345 (SIRET).",
							"IE": "O número de registo deve ter duas letras seguidas por 6 dígitos ou apenas 6 dígitos, se for um comerciante independente (por ex., AB123456).",
							"IT": "O número de registo deve ter 11 dígitos (ex., 01234567890) ou uma combinação de 16 números e letras maiúsculas (ex., ABCABC12A12A123A)",
							"GB": "O número de organização deve ter 8 dígitos. Ex.: 12345678, ou duas letras seguidas de 6 dígitos (SC123456), ou uma letra seguida de 7 dígitos (S1234567)",
							"GR": "O número G.E.MI. deve ter 12 dígitos, por exemplo, 012345678901",
							"NL": "O número de registo deve ter 8 dígitos. Ex.: 12345678",
							"NO": "O número de registo deve ter 9 dígitos, sem espaços. Ex.: 123456789",
							"NZ": "O número da empresa deve ter 13 dígitos. Ex.: 1234567890123",
							"PL": "O número de registo deve ter 10 dígitos, sem espaços. Ex.: 1234561234",
							"PT": "O número de registo deve ter 9 dígitos, sem espaços. Ex.: 123123123",
							"SE": "O número de registo deve ter 10 dígitos com um travessão, sem espaços. Ex.: 123456-1234",
							"US": "O número de identificação de empregador deve ter 9 dígitos com um \"-\" depois dos primeiros dois. Ex.: 12-3456789",
							"MX": "O RFC deve ter 12 caracteres, começando pelas iniciais da empresa, a data de incorporação de 6 dígitos e o valor de verificação. P. ex., ABC921010H20"
						}
					},
					"tocLink": "Ocorreu um erro com os termos e condições. Tente novamente mais tarde ou contacte o nosso apoio ao cliente através do e-mail {supportEmail}",
					"vat": {
						"general": {
							"default": "Introduza um número de IVA válido",
							"AU": "Introduza um ABN válido",
							"ES": "Introduza um NIF/NIE/DNI de empresa válido",
							"NZ": "Introduza um número GST válido"
						},
						"invalid": {
							"default": "Número de IVA inválido",
							"AT": "O número de IVA deve ser ATU seguido de 8 dígitos. Ex.: ATU12345678",
							"AU": "O ABN deve ter 11 dígitos.",
							"CZ": "O número de IVA deve ser CZ seguido de 8, 9 ou 10 dígitos. Ex.: CZ123456789",
							"GR": "O número de IVA deve ter 9 dígitos e deve começar por EL. Ex.: EL123456789",
							"DE": "O número de IVA deve ser DE seguido de 9 dígitos. Ex.: DE123456789",
							"ES": "O NIF/NIE/DNI deve ter 8 ou 9 caracteres começando por 1 letra/dígito seguido por 6 ou 7 dígitos e 1 letra/dígito",
							"FR": "O número de IVA deve ser FR seguido de 2 letras/dígitos e 9 dígitos (SIREN), por ex., FRXX123456789",
							"GB": "O número de IVA deve ter entre 6 e 15 caracteres.",
							"IE": "O número de IVA tem de ser IE seguido por 8 ou 9 caracteres que incluam 1 ou 2 letras. P. ex.: IE1234567WA, IE1234567A",
							"IT": "O número de IVA deve ser IT seguido de 11 dígitos. Ex.: IT12345678912",
							"NL": "O número de IVA deve ser NL seguido de 9 dígitos, seguidos de B e 2 dígitos. Ex.: NL123456789B12",
							"NZ": "O número GST deve ter 8 dígitos (12345678) ou 9 dígitos, com ou sem hifenes a cada 3 dígitos (123-123-123 ou 123123123)",
							"PL": "O número de IVA deve ser PL seguido de 10 dígitos. Ex.: PL1234567890",
							"PT": "O número de IVA deve ser PT seguido de 9 dígitos. Ex.: PT123123123",
							"MX": "O RFC deve começar pelas iniciais da empresa, a data de incorporação de 6 dígitos e o valor de verificação. P. ex., ABC921010H20"
						}
					},
					"personal_id": {
						"US": {
							"general": "Introduza os últimos 4 dígitos do seu SSN",
							"format": "Introduza os últimos 4 dígitos do seu SSN"
						},
						"US_FULL_SSN": {
							"general": "Forneça todo o SSN (9 dígitos)",
							"format": "Forneça todo o seu SSN (9 dígitos)"
						},
						"CA": {
							"general": "Introduza um SIN ou um número de passaporte válido",
							"format": "SIN: XXX-XXX-XXX / Número do passaporte: ABXXXXXX"
						},
						"SE": {
							"general": "Introduza um número de identificação pessoal válido (PNO)",
							"format": "Introduza o PNO no formato: AAAAMMDD-XXXX"
						},
						"FI": {
							"general": "Introduza um código de identificação pessoal válido (HETU)",
							"format": "Introduza o HETU no formato: DDMMAASXXXX"
						},
						"NO": {
							"general": "Introduza um número de identidade nacional válido",
							"format": "Introduza no formato: DDMMAAXXXXX"
						},
						"DK": {
							"general": "Introduza um número de identificação pessoal válido (CPR)",
							"format": "Introduza o CPR no formato: DDMMAA-XXXX"
						},
						"IT": {
							"general": "Introduza um código fiscal válido",
							"format": "Introduza o código fiscal no formato: CLDNRG84L58H501R"
						},
						"ES": {
							"general": "Introduza um número de identificação pessoal válido (DNI ou NIE)",
							"format": "Introduza o DNI ou o NIE, por ex., 12345678A"
						},
						"PL": {
							"general": "Introduza um código de identificação pessoal válido (PESEL)",
							"format": "Introduza o PESEL no formato: AAMMDDZZZXQ"
						},
						"default": {
							"general": "Introduza um número de passaporte válido"
						}
					},
					"store_name": "Introduza um nome de loja"
				},
				"errors_keys": {
					"correlationIdLabel": "ID de correlação: {correlationId}",
					"decisionTaken": "Decisão de pré-avaliação já tomada. Recarregue a página.",
					"maintenanceMode": "A nossa aplicação está atualmente inativa devido a manutenção. Verifique novamente em breve",
					"validation": {
						"storeName": {
							"invalidType": "Introduza um nome de loja válido."
						},
						"email": {
							"invalidType": "Introduza um e-mail válido."
						},
						"goodsCategory": {
							"invalidType": "Introduza uma categoria de mercadorias."
						},
						"website": {
							"invalidType": "Introduza um website válido."
						}
					}
				}
			},
			"general": {
				"yes": "Sim",
				"no": "Não",
				"encrypted_text": "*******",
				"pricing_link_eu": "Ver todos os preços por país",
				"pricing_link_us": "Ver preços",
				"formFieldOptional": "opcional",
				"buttons": {
					"next": "Seguinte",
					"back": "Voltar",
					"continue": "Continuar",
					"submit_application": {
						"default": "Começar",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Começar"
					},
					"add_aditional_item": "+ Adicionar item adicional"
				},
				"unknown_step_title": "Forneça as informações obrigatórias",
				"selected": "Selecionado",
				"clear_all": "Limpar tudo"
			},
			"errors": {
				"general": "Ocorreu um erro. Contacte a nossa equipa de apoio.",
				"salesforce": "Experimente atualizar a página. Se o erro persistir, envie a ID do erro para o canal da equipa de apoio no Slack #smooothforce-support e iremos ajudá-lo.",
				"managed_kyc": "Experimente atualizar a página. Se o erro persistir, contacte o nosso apoio ao comerciante ou o seu contacto de vendas.",
				"copy": "Copiar",
				"noTermsAccepted": "Leia e aceite todos os nossos acordos listados",
				"termsAlreadyAccepted": "Já aceitou todos os acordos listados",
				"mandatoryField": " é necessário"
			},
			"options": {
				"entity_types": {
					"SOLE_TRADER": "Comerciante independente",
					"PARTNERSHIP": "Parceria",
					"PUBLIC_LISTED_COMPANY": "Empresa pública cotada na bolsa",
					"PRIVATE_COMPANY": "Empresa privada"
				},
				"organization_entity_types": {
					"C_CORP": "Corporação C",
					"S_CORP": "Corporação S",
					"PARTNERSHIP": "Parceria",
					"TRUST_ESTATE": "Fundo/imóveis",
					"INDIVIDUAL": "Individual",
					"SOLE_PROPRIETORSHIP": "Empresa unipessoal",
					"SOLE_TRADER": "Comerciante independente",
					"LIMITED_LIABILITY_COMPANY": "Sociedade anónima",
					"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Sociedade anónima de membro único"
				},
				"goods_categories": {
					"ADULT_SHOES_AND_CLOTHING": "Roupa e calçado - Roupa e calçado de adultos",
					"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Produtos para automóveis - Peças e acessórios para automóveis",
					"BAGS_AND_WALLETS": "Joias e acessórios - Malas e carteiras",
					"BODY_AND_HAIR_CARE": "Saúde e beleza - Cuidados para corpo e cabelo",
					"BOOK_AND_MAGAZINES": "Entretenimento - Livros e revistas",
					"CANDY": "Alimentos e bebidas - Doces",
					"CAR_ELECTRONICS": "Eletrónica - Eletrónica de carros",
					"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Produtos para crianças - Roupas e produtos de cuidados para crianças",
					"CHILDREN_TOYS": "Produtos para crianças - Brinquedos infantis",
					"CLEANING_AND_SANITARY": "Casa e jardim - Limpeza e higiene",
					"COLLECTIBLES": "Lazer, desporto e hobbies - Colecionáveis",
					"CONCEPT_STORES_AND_MISCELLANEOUS": "Lazer, desporto e hobbies - Lojas de conceito e diversos",
					"COSMETICS": "Saúde e beleza - Cosméticos",
					"COSTUMES_AND_PARTY_SUPPLIES": "Lazer, desporto e hobbies - Roupas de fantasia e produtos para festas",
					"DATING_SERVICES": "Produtos intangíveis - Serviços de encontros",
					"DECORATION_AND_ART": "Casa e jardim - Decoração e arte",
					"DIETARY_SUPPLEMENTS": "Saúde e beleza - Suplementos dietéticos",
					"DIGITAL_SERVICES": "Produtos intangíveis - Serviços digitais",
					"DIVERSIFIED_CHILDREN_PRODUCTS": "Produtos para crianças - Produtos diversos para crianças",
					"DIVERSIFIED_ELECTRONICS": "Eletrónica - Diversos",
					"DIVERSIFIED_ENTERTAINMENT": "Entretenimento - Diversos",
					"DIVERSIFIED_EROTIC_MATERIAL": "Materiais eróticos - Materiais eróticos diversos",
					"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Saúde e beleza - Produtos de saúde e beleza diversos",
					"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Casa e jardim - Produtos diversos para casa e jardim",
					"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Joias e acessórios - Joias e acessórios diversos",
					"EDUCATION": "Produtos intangíveis - Educação",
					"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Eletrónica - Equipamento eletrónico e acessórios relacionados",
					"EROTIC_CLOTHING_AND_ACCESSORIES": "Materiais eróticos - Roupas e acessórios eróticos",
					"EVENT_TICKETS": "Produtos intangíveis - Bilhetes para eventos",
					"FOOD_AND_BEVERAGE": "Alimentos e bebidas - Alimentos e bebidas",
					"FRAGRANCES": "Saúde e beleza - Fragrâncias",
					"FURNITURE": "Casa e jardim - Mobiliário",
					"GENERAL_SHOES_AND_CLOTHING": "Roupa e calçado - Roupa e calçado em geral",
					"HOBBY_ARTICLES": "Lazer, desporto e hobbies - Artigos para hobbies",
					"HOUSEHOLD_ELECTRONICS": "Eletrónica - Eletrónicos domésticos",
					"JEWELRY_AND_WATCHES": "Joias e acessórios - Joias e relógios",
					"KITCHENWARE": "Casa e jardim - Utensílios de cozinha",
					"MARKETPLACES": "Produtos intangíveis - Mercados",
					"MUSIC_AND_MOVIES": "Entretenimento - Música e filmes",
					"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Lazer, desporto e hobbies - Instrumentos musicais e equipamento",
					"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Joias e acessórios - Óculos de sol e lentes sem receita médica",
					"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Eletrónica - Máquinas de escritório e acessórios relacionados",
					"OTHER_SERVICES": "Produtos intangíveis - Outros serviços",
					"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Saúde e beleza - Cuidados pessoais e melhoria do corpo",
					"PET_SUPPLIES": "Casa e jardim - Produtos para animais de estimação",
					"PHARMACEUTICAL_PRODUCTS": "Saúde e beleza - Produtos farmacêuticos",
					"PLANTS_AND_FLOWERS": "Casa e jardim - Plantas e flores",
					"PRESCRIPTION_OPTICS": "Saúde e beleza - Material de ótica com receita médica",
					"PRINTS_AND_PHOTOS": "Lazer, desporto e hobbies - Impressões e fotografias",
					"SAFETY_PRODUCTS": "Casa e jardim - Produtos de segurança",
					"SEX_TOYS": "Materiais eróticos - Brinquedos sexuais",
					"SPORTS_GEAR_AND_OUTDOOR": "Lazer, desporto e hobbies - Equipamento desportivo e de ar livre",
					"TOBACCO": "Alimentos e bebidas - Tabaco",
					"TOOLS_AND_HOME_IMPROVEMENT": "Casa e jardim - Ferramentas e melhorias na casa",
					"TRAVEL_SERVICES": "Produtos intangíveis - Serviços de viagens",
					"UNDERWEAR": "Roupa e calçado - Roupa interior",
					"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Entretenimento - Videojogos e acessórios relacionados",
					"WHEELS_AND_TIRES": "Produtos para automóveis - Rodas e pneus",
					"WINE_BEER_AND_LIQUOR": "Alimentos e bebidas - Vinho, cerveja e licor",
					"YOUTHFUL_SHOES_AND_CLOTHING": "Roupa e calçado - Roupa e calçado de jovens",
					"GAMBLING_BETTING_CASINOS_AND_LOTTERY": "Restrições de idade - Jogo a dinheiro, apostas, casinos e lotarias",
					"CHARITIES_AND_NGO": "Produtos intangíveis - Serviços de beneficência e ONG",
					"EROTIC_SERVICES": "Materiais eróticos - Serviços eróticos",
					"FINANCIAL_SERVICES_CRYPTO": "Serviços financeiros - Atividades relacionadas com criptomoedas",
					"FINANCIAL_SERVICES_MSB": "Serviços financeiros - Negócios de Serviços Financeiros",
					"FINANCIAL_SERVICES_E_WALLETS": "Serviços financeiros - Carteiras eletrónicas",
					"FINANCIAL_SERVICES_TRADING": "Serviços financeiros - Comércio",
					"SOCIAL_PLATFORMS_COMMUNITIES": "Produtos intangíveis - Comunidades de plataforma social",
					"TRAVEL_AIR_TRAVEL_AND_CRUISE_OPERATORS": "Viagens - Viagens aéreas e operadores de cruzeiros",
					"TRAVEL_BROKER_AND_AGENCIES": "Viagens - Intermediários e Agências",
					"TRAVEL_GROUND_TRANSPORTATION": "Viagens - Transportes terrestres",
					"TRAVEL_ACCOMMODATION_AND_RESORTS": "Viagens - Alojamento e Resorts",
					"EVENT_ORGANIZER": "Eventos - Organizador",
					"EVENT_BROKER_AND_AGENCIES": "Eventos - Intermediários e Agências"
				},
				"us_states": {
					"AL": "Alabama",
					"AK": "Alasca",
					"AZ": "Arizona",
					"AR": "Arkansas",
					"CA": "Califórnia",
					"CO": "Colorado",
					"CT": "Connecticut",
					"DC": "Distrito de Colúmbia",
					"DE": "Delaware",
					"FL": "Flórida",
					"GA": "Geórgia",
					"HI": "Havai",
					"ID": "Idaho",
					"IL": "Illinois",
					"IN": "Indiana",
					"IA": "Iowa",
					"KS": "Kansas",
					"KY": "Kentucky",
					"LA": "Louisiana",
					"ME": "Maine",
					"MD": "Maryland",
					"MA": "Massachusetts",
					"MI": "Michigan",
					"MN": "Minnesota",
					"MS": "Mississippi",
					"MO": "Missouri",
					"MT": "Montana",
					"NE": "Nebraska",
					"NV": "Nevada",
					"NH": "New Hampshire",
					"NJ": "New Jersey",
					"NM": "Novo México",
					"NY": "Nova Iorque",
					"NC": "Carolina do Norte",
					"ND": "Dakota do Norte",
					"OH": "Ohio",
					"OK": "Oklahoma",
					"OR": "Oregon",
					"PA": "Pensilvânia",
					"RI": "Rhode Island",
					"SC": "Carolina do Sul",
					"SD": "Dakota do Sul",
					"TN": "Tennessee",
					"TX": "Texas",
					"UT": "Utah",
					"VT": "Vermont",
					"VA": "Virgínia",
					"WA": "Washington",
					"WV": "Virgínia Ocidental",
					"WI": "Wisconsin",
					"WY": "Wyoming"
				},
				"stakeholder": {
					"types": {
						"PERSON": "Pessoa",
						"COMPANY": "Empresa"
					},
					"roles": {
						"OWNER": "Proprietário",
						"ULTIMATE_BENEFICIAL_OWNER": "Proprietário beneficiário final",
						"CONTROL_OVER_MANAGEMENT": "Controlo sobre a gestão",
						"APPLICANT": "Signatário autorizado",
						"SOLE_TRADER": "Comerciante independente",
						"PARTNER": "Parceiro(a)"
					}
				},
				"payment_intervals": {
					"DAILY": "Diariamente",
					"WEEKLY": "Semanalmente"
				},
				"business_concepts": {
					"TRADITIONAL_SALE_OF_GOODS": {
						"label": "Venda tradicional de mercadorias",
						"description": "O comerciante está a vender produtos ou serviços de maneira tradicional: as mercadorias são consideradas totalmente consumidas quando forem entregues e normalmente não existe um período de tempo prolongado entre a encomenda e a entrega"
					},
					"VOUCHER": {
						"label": "Voucher",
						"description": "Mais de 10% das vendas consistem em vouchers e/ou cartões de oferta"
					},
					"MEMBERSHIP": {
						"label": "Adesão",
						"description": "Mais de 10% das vendas consistem em adesões"
					},
					"SUBSCRIPTION": {
						"label": "Subscrição",
						"description": "Mais de 10% das vendas consistem em subscrições"
					},
					"PHARMACIES": {
						"label": "Farmácias",
						"description": "O comerciante vende medicamentos com e sem receita médica"
					},
					"US_PHARMACIES": {
						"label": "Farmácias dos EUA",
						"description": "O comerciante vende medicamentos com e sem receita médica nos EUA"
					},
					"MEDICAL_SERVICES": {
						"label": "Serviços médicos",
						"description": "O comerciante vende serviços médicos, como testes, exames, cuidados de enfermagem"
					},
					"MARKETPLACES": {
						"label": "Mercados",
						"description": "O comerciante tem uma relação subcomercial"
					},
					"FIREARM_DEALERS": {
						"label": "Comerciantes de armas",
						"description": "O comerciante vende armas e munições que requerem licença"
					},
					"AUCTIONS": {
						"label": "Leilões",
						"description": "O comerciante é uma casa de leilões"
					},
					"ALCOHOL": {
						"label": "Álcool",
						"description": "O comerciante vende álcool"
					},
					"TOBACCO": {
						"label": "Tabaco",
						"description": "O comerciante vende tabaco, incluindo ou excluindo nicotina, ou o comerciante vende cigarros eletrónicos"
					},
					"HEMP_CBD_THC": {
						"label": "Cânhamo, canabidiol (CBD) ou tetra-hidrocanabinol (THC)",
						"description": "O comerciante vende produtos contendo cânhamo, CBD ou THC"
					},
					"DONATIONS_CHARITY": {
						"label": "Donativos e beneficência",
						"description": "O comerciante é uma organização de donativos ou beneficência que inclui com “Desembolso pós‑liquidação”\""
					},
					"TRAVEL": {
						"label": "Viagens",
						"description": "Mais de 10% das vendas consistem em viagens"
					},
					"EVENTS": {
						"label": "Eventos",
						"description": "Mais de 10% das vendas consistem em eventos"
					},
					"COURSES": {
						"label": "Cursos",
						"description": "Mais de 10% das vendas consistem em cursos"
					},
					"EDUCATIONAL_COURSES": {
						"label": "",
						"description": ""
					},
					"FOOD_DELIVERY": {
						"label": "",
						"description": ""
					},
					"CUSTOMISED_PRE_ORDER_FURNITURE": {
						"label": "",
						"description": ""
					},
					"DIGITAL_CONTENT": {
						"label": "",
						"description": ""
					},
					"GAMING_INDUSTRY": {
						"label": "",
						"description": ""
					}
				}
			},
			"pages": {
				"select_products_page": {
					"page_header": {
						"primary_title": "Olá, {firstName}",
						"primary_title_without_name": "Olá,",
						"sub_title": "Mais Klarna é mais Klarna, disse Shakespeare.",
						"sub_title_no_products": "Comece a sua experiência Klarna escolhendo um produto abaixo",
						"sub_title_kp_products": "Selecione outro produto Klarna",
						"sub_title_ongoing_product": "Continue a configuração de {productName}"
					},
					"sidebar_left": {
						"products": {
							"title": "Produtos de pagamento",
							"text_blocks": [
								{
									"text": "Adicionar uma solução à sua configuração"
								}
							]
						}
					},
					"buttons": {
						"start": "Iniciar",
						"continue": "Continuar",
						"view_summary": "Ver resumo",
						"add_another_product": "Adicionar outro produto"
					},
					"goodie_bags": {
						"playground": {
							"title": "Ambiente de demonstração",
							"text": "Mude para o Ambiente de demonstração para explorar e gerar credenciais de API de teste, para poder testar a sua plataforma.",
							"link": "Ambiente de demonstração"
						},
						"marketing_assets": {
							"title": "Recursos de marketing",
							"text": "Utilizar a Klarna significa uma navegação smoooth para os seus clientes. Utilize os nossos recursos de marketing para os entusiasmar.",
							"link": "Obter recursos"
						},
						"your_application": {
							"title": "A sua candidatura",
							"text": "Clique aqui para concluir a sua configuração ou ver detalhes da sua candidatura, incluindo Termos e Condições.",
							"link": "Abrir"
						},
						"invite_more_users": {
							"title": "Convidar mais utilizadores",
							"text": "Convide os seus colaboradores para o portal do comerciante; poderá definir permissões personalizadas para cada um deles!",
							"link": "Convidar utilizadores"
						}
					},
					"footer": {
						"title": "Sempre incluído com a Klarna",
						"list": {
							"merchant_portal": {
								"title": "O portal do comerciante",
								"text_blocks": [
									{
										"text": "Faça a gestão de tudo da Klarna com acesso total à retaguarda."
									}
								]
							},
							"global_products": {
								"title": "Produtos globais, rostos locais",
								"text_blocks": [
									{
										"text": "Todos os nossos produtos são criados para estarem de acordo com as preferências e a legislação locais."
									}
								]
							},
							"local_support": {
								"title": "Apoio local para si e para os seus clientes",
								"text_blocks": [
									{
										"text": "Temos milhares de pessoas prontas para ajudar os seus clientes quando precisarem de atendimento pessoal."
									}
								]
							},
							"marketing_tool": {
								"title": "A Klarna como ferramenta de marketing",
								"text_blocks": [
									{
										"text": "Dar-lhe-emos acesso aos materiais da Klarna que pode utilizar nas suas iniciativas de marketing."
									}
								]
							},
							"single_integration": {
								"title": "Integração única, atualizações automáticas",
								"text_blocks": [
									{
										"text": "Uma integração sem atualizações. Sempre."
									},
									{
										"text": "Assim que integrar a Klarna, está tudo pronto. Está sempre atualizado e não precisa de mexer um dedo."
									}
								]
							},
							"no_risk": {
								"title": "Sem risco para si ou para os seus clientes",
								"text_blocks": [
									{
										"text": "Os seus pagamentos são sempre garantidos e os seus clientes estão abrangidos pela proteção do comprador da Klarna."
									}
								]
							}
						}
					}
				},
				"credentials_page": {
					"sidebar_left": {
						"connection_key": {
							"title": "Credenciais de API da Klarna",
							"text_blocks": [
								{
									"text": "As credenciais de API da Klarna ligam o nosso produto à sua loja, para que possa começar a vender."
								}
							]
						},
						"toc_key": {
							"title": "Termos e Condições",
							"text_blocks": [
								{
									"text": "Precisa de atualizar os Termos e Condições do seu comércio eletrónico"
								}
							]
						},
						"connect_to_your_platform": {
							"title": "Instruções de integração",
							"text_blocks": [
								{
									"text": ""
								}
							]
						}
					},
					"main": {
						"how_to_use": {
							"title": "Como utilizar credenciais de API da Klarna",
							"ordered_list": {
								"one": "Gerar e transferir as suas credenciais",
								"two": "Cole as credenciais (o nome de utilizador e a palavra-passe de API da Klarna) na sua plataforma como explicado nas instruções de integração abaixo"
							}
						},
						"number_of_live_keys_in_total": {
							"title": "5 credenciais de API da Klarna no total",
							"text": "Pode gerar até cinco credenciais de API da Klarna. Obtenha a primeira aqui e, depois, crie as restantes em Definições.",
							"button": "Gerar credenciais de API da Klarna"
						},
						"how_to_update_toc": {
							"title": "Como atualizar os Termos e Condições",
							"ordered_list": {
								"one": "Visitar a ligação",
								"two": "Leia as instruções e copie o texto",
								"three": "Inclua-o nos Termos e Condições da sua loja online"
							}
						},
						"update_toc_link": {
							"title": "",
							"text": "Lembre-se de atualizar o texto com os produtos que subscreveu.",
							"linkText": "Ir para Atualizar Termos e Condições >"
						},
						"buttons": {
							"back": "Voltar"
						}
					}
				},
				"whats_next_page": {
					"communication": {
						"TRANSACTIONS_REVIEW_AUTOMATED": "A sua candidatura está a ser analisada…",
						"TRANSACTION_DETAILS_STARTED": "A sua candidatura está a ser analisada pela nossa equipa. Entraremos em contacto consigo assim que possível.",
						"TRANSACTIONS_REVIEW_MANUAL": "A sua candidatura está a ser analisada pela nossa equipa. Entraremos em contacto consigo assim que possível.",
						"TRANSACTIONS_ENABLED": "Parabéns. Agora, está pronto(a) para vender com a Klarna.",
						"PAYOUTS_REVIEW_AUTOMATED": "O seu pedido de pagamentos está a ser analisado…",
						"PAYOUTS_REVIEW_MANUAL": "O seu pedido de pagamentos está a ser analisado pela nossa equipa. Entraremos em contacto consigo assim que possível.",
						"PAYOUTS_REVIEW_AWAITING_FIRST_TRANSACTION": "A aguardar a sua primeira venda com a Klarna…",
						"TRANSACTIONS_DISABLED": "A sua conta está desativada até que conclua o passo de ativar os pagamentos.",
						"SUSPENDED": "A sua conta está suspensa.",
						"notice": "Atualmente, estamos com tempos de espera superiores à média para analisar a sua candidatura. Não se preocupe, a sua candidatura está a ser analisada e entraremos em contacto consigo com mais informações sobre os próximos passos. Agradecemos a sua paciência e sua compreensão."
					},
					"statuses": {
						"pending": "Pendente",
						"done": "Concluído"
					},
					"in_review": {
						"title": "Estamos a analisar a sua candidatura.",
						"subtitle": "Estamos atualmente a fazer a análise final da sua candidatura à Klarna para assegurar que tudo está correto no contrato. Este é um processo manual, pelo que os tempos de tratamento podem variar, mas iremos fazê-lo o mais rapidamente possível.",
						"content": {
							"title": "Para assegurar que a análise é feita o mais rapidamente possível, certifique-se de que o seguinte está visível no seu website:",
							"list": {
								"default": {
									"item_1": "O nome registado da sua empresa",
									"item_2": "O número registado da sua empresa",
									"item_3": "O endereço registado da sua empresa",
									"item_4": "Política de devolução de, pelo menos, 14 dias",
									"item_5": "E-mail ou número de telefone do serviço de apoio ao cliente"
								},
								"US": {
									"item_1": "Nome da empresa registado",
									"item_2": "Política de Devolução",
									"irem_3": "E-mail ou número de telefone do serviço de apoio ao cliente"
								},
								"AU": {
									"item_1": "ABN (Número da Empresa) ou Nome de Empresa Registada.",
									"item_3": "O endereço registado da sua empresa",
									"item_4": "Política de devolução de, pelo menos, 14 dias",
									"item_5": "E-mail ou número de telefone do serviço de apoio ao cliente"
								}
							}
						},
						"footer": "Enviar-lhe-emos um e-mail assim que a análise estiver concluída ou se precisarmos de informações adicionais da sua parte."
					},
					"suspended": {
						"title": "Infelizmente…",
						"subtitle": "Após rever os detalhes do seu contrato, tivemos de rejeitar a sua candidatura. Pode haver vários motivos para a sua candidatura não ter sido aprovada. Abaixo estão alguns dos fatores mais comuns:",
						"content": {
							"title": "",
							"list": {
								"item_1": "A sua loja não cumpre as diretrizes éticas da Klarna.",
								"item_2": "A pessoa de contacto indicada não está contactável.",
								"item_3": "Outros fatores técnicos ou administrativos."
							}
						},
						"footer": "Obrigado pelo seu interesse na Klarna. Contacte-nos se tiver quaisquer dúvidas a este respeito ou se quiser inscrever-se com uma loja diferente no futuro."
					},
					"disabled": {
						"title": "A sua candidatura foi desativada.",
						"subtitle": "A sua conta foi desativada automaticamente, porque lhe faltam informações exigidas por lei.",
						"content": {
							"title": "Isto normalmente acontece quando a Klarna lhe pediu para fornecer algumas informações e você não respondeu durante o prazo especificado."
						},
						"footer": "Se acredita que se tratou de um erro ou se gostaria de reenviar as informações, entre em contacto com o apoio ao comerciante utilizando as informações de contacto no rodapé desta página."
					},
					"ready_to_connect": {
						"title": "Ligar a sua loja",
						"subtitle": "O seu contrato está concluído e agora pode integrar a Klarna na sua loja. Siga os passos abaixo para concluir a integração.",
						"status_messsage": {
							"title": "Integração ainda não concluída",
							"subtitle": "Siga as instruções de integração para ligar a sua loja. Este estado ficará verde assim que for feita uma transação utilizando a Klarna."
						},
						"content": {
							"title": "Instruções",
							"options": {
								"label_1": "Gerar e guardar as suas credenciais de API da Klarna",
								"description_1": "Gerar novas credenciais de API e transferi-las para o seu computador. Precisará destas credenciais de API na próxima secção.",
								"label_2": "Instale a Klarna na sua loja Shopify"
							}
						}
					},
					"ready_to_connect_new_ig": {
						"title": "Quase terminado",
						"subtitle": "Está um passo mais perto de oferecer uma experiência de compras smoooth aos seus clientes! O seu contrato está concluído e a sua loja está pronta para integração.",
						"buttons": {
							"connect": "Ligar a sua loja"
						},
						"additional_info": "Tenha em atenção que a integração apenas será marcada como concluída quando recebermos a primeira compra, o que pode demorar algum tempo, dependendo da sua plataforma."
					},
					"store_connected": {
						"title": "A sua loja está ligada",
						"subtitle": "A integração da sua loja na Klarna está concluída e os seus clientes podem pagar utilizando a Klarna.",
						"status_messsage": {
							"title": "Integração bem‑sucedida",
							"subtitle": "A transação da Klarna foi processada com sucesso através da sua loja.",
							"button_text": {
								"shown": "Mostrar instruções de integração",
								"hidden": "Ocultar instruções de integração"
							}
						}
					},
					"actions": {
						"view_summary": {
							"title": "A sua candidatura",
							"subtitle": "Analisar as informações da sua candidatura.",
							"button_text": "Ver resumo"
						},
						"connect_store": {
							"title": "Credenciais de API da Klarna",
							"subtitle": "Gere as suas credenciais de API da Klarna para integrar a sua loja.",
							"button_text": "Gerar credenciais de API da Klarna"
						},
						"add_product": {
							"title": "Produtos",
							"subtitle": "Clique aqui se deseja adicionar um produto a esta configuração.",
							"button_text": "Adicionar produtos"
						}
					},
					"timeline": {
						"application": {
							"title": "A sua candidatura",
							"alert": {
								"view_summary": "Ver resumo",
								"rejected": "Temos de rejeitar a tua candidatura.",
								"review": "Analisa as informações da sua candidatura clicando na ligação abaixo."
							}
						},
						"payouts": {
							"title": "Pagamentos ativados"
						},
						"integration": {
							"title": "Integração ainda não concluída",
							"alert": "Siga as instruções de integração para ligar a sua loja."
						},
						"integration_complete": {
							"title": "Integração concluída!"
						}
					}
				},
				"summary_page": {
					"header": {
						"title": "Parabéns, a sua configuração está concluída!",
						"rejection": "Lamentamos, mas não foi possível concluir a sua configuração."
					},
					"header_new": {
						"title": "Bem-vindo(a), comerciante Klarna",
						"subtitle": "Resumo",
						"rejection": "Candidatura rejeitada"
					},
					"joy_section": {
						"approved": {
							"title": "Aprovado!",
							"content": "A sua candidatura foi analisada e aprovada. O acesso total ao serviço da Klarna está agora nas pontas dos seus dedos. Estamos entusiasmados por trabalhar consigo!",
							"button_title": "Verifique as suas encomendas",
							"link": "ou os nossos recursos de marketing"
						},
						"rejected": {
							"title": "Infelizmente…",
							"content_1": "Após analisar a sua candidatura, não podemos aprovar o seu contrato de comerciante.",
							"content_2": "Não hesite em contactar a nossa equipa de apoio se tiver quaisquer dúvidas."
						}
					},
					"sidebar_left": {
						"application_details": "Os dados da sua candidatura",
						"store_details": {
							"title": "Dados da loja",
							"text_blocks": [
								{
									"text": "Um resumo dos seus dados"
								}
							]
						},
						"credentials": {
							"title": "Credenciais de API da Klarna",
							"text_blocks": [
								{
									"text": "As suas credenciais de API da Klarna"
								}
							]
						},
						"payouts": {
							"title": "Pagamentos",
							"text_blocks": [
								{
									"text": "Os seus dados bancários enviados"
								}
							]
						},
						"additional_bank_accounts": {
							"title": "Contas bancárias adicionais",
							"text_block": null
						},
						"business_owners": {
							"title": "Empresários",
							"text_blocks": null
						},
						"material_influencers": {
							"title": "Influenciadores significativos",
							"text_blocks": null
						},
						"stakeholders": {
							"title": "Partes interessadas",
							"text_blocks": [
								{
									"text": "As informações que enviou"
								}
							]
						}
					},
					"main": {
						"store_details": {
							"business_owners": {
								"title": "Empresários",
								"no_elements": "Não indicou quaisquer proprietários de empresa"
							}
						},
						"payouts": {
							"default_bank_accounts": {
								"title": "Conta bancária predefinida",
								"no_elements": "Nenhuma conta bancária predefinida"
							},
							"additional_bank_accounts": {
								"title": "Contas bancárias adicionais",
								"no_elements": "Não indicou quaisquer contas bancárias adicionais"
							}
						},
						"stakeholders": {
							"owners": {
								"title": "Proprietários",
								"no_elements": "Não indicou quaisquer proprietários"
							},
							"ultimate_beneficial_owner": {
								"title": "Proprietários beneficiários",
								"no_elements": "Não indicou quaisquer proprietários beneficiários"
							},
							"applicant": {
								"title": "Candidatos",
								"no_elements": "Não indicou quaisquer candidatos"
							},
							"control_over_management": {
								"title": "Pessoas com controlo sobre a gestão",
								"no_elements": "Não indicou quaisquer partes interessadas com controlo sobre a gestão"
							}
						},
						"buttons": {
							"back": "Voltar",
							"next_step": "Seguinte"
						}
					}
				},
				"additional_products_page": {
					"sidebar_left": {
						"we_have_your_data": {
							"title": "Já temos os seus dados",
							"text_blocks": [
								{
									"text": "Estas são as informações que nos deu anteriormente."
								}
							]
						}
					},
					"main": {
						"business_ownership": {
							"no_elements": "Não indicou quaisquer proprietários de empresa"
						},
						"buttons": {
							"submit": "Enviar",
							"back": "Voltar"
						}
					}
				},
				"checking_page": {
					"title": "A verificar…",
					"subtitle": "Obrigado por enviar a candidatura. Aguarde enquanto a analisamos…"
				},
				"success_page": {
					"title": "Agora pode ligar a sua loja",
					"subtitle": "Obrigado por enviar a candidatura.",
					"buttons": {
						"next": "Seguinte"
					}
				}
			},
			"components": {
				"split_image_container": {
					"timeline": {
						"basics": "Básico",
						"business": "Empresa",
						"stakeholders": "Partes interessadas",
						"bank_accounts": "Contas bancárias"
					}
				},
				"app_error": {
					"title": "A aplicação de Produtos está atualmente indisponível",
					"message": "Estamos a ter problemas com a nossa aplicação e estamos a analisá-los. Tentaremos resolver os problemas assim que possível. Tenta novamente mais tarde."
				},
				"temporarily_down": {
					"title": "Estamos a registar dificuldades técnicas",
					"message": "Lamentamos qualquer incómodo causado e asseguramos que estamos a dar o nosso melhor para resolver o problema. Verifique novamente em breve."
				},
				"maintenance_mode": {
					"title": {
						"products_app": "A nossa aplicação de Produtos está atualmente inativa devido a manutenção",
						"signup_app": "A nossa aplicação de Inscrição está atualmente inativa devido a manutenção"
					},
					"message": "Estamos a trabalhar para melhorar a sua experiência e esperamos ter concluído assim que possível. Verifique novamente em breve."
				},
				"unknown_merchant": {
					"before_link": "Se já tem um acordo connosco, visite",
					"link_text": "esta página",
					"after_link": "para saber mais sobre os nossos produtos!"
				},
				"pre_assessment_error": {
					"title": {
						"invalid_flow_type": "Ocorreu um erro.",
						"invalid_token": "Esta ligação expirou"
					},
					"message": {
						"invalid_token_risk": " Contacte o canal #smooothforce-support no Slack e iremos ajudá-lo.",
						"invalid_token": "Entre em contacto com o seu contacto de vendas.",
						"invalid_flow_type": "O tipo de integração e estado deste comerciante são incompatíveis. Se acredita que se trata de um erro, entre em contacto com o apoio ao comerciante."
					}
				},
				"topbar": {
					"title": "Configuração",
					"widget_type": {
						"MANAGED_KYC": "Recolha KYC",
						"MANAGED_RISK": "Recolha pré‑avaliação",
						"MANAGED_SME_RISK": "Recolha pré‑avaliação de PME"
					}
				},
				"product_card": {
					"incompatible_description": "Não disponível para o seu país ou a sua plataforma",
					"kco_footer_text": "As formas de pagamento disponíveis na caixa Klarna dependem do seu país de registo e do país para o qual vende.",
					"products_link_text": "Mais"
				},
				"product_prices_card": {
					"title": "Produtos",
					"subtitle": "{country}",
					"pricing": "Preços para {country}",
					"monthly_fee": "taxa mensal",
					"transaction_fee": "taxa de transação",
					"before_link": "Concordo com os",
					"link_text": "Termos e Condições",
					"after_link_one_product": "para este produto",
					"after_link_more_than_one_product": "para estes produtos",
					"product_not_available_in_your_country": "* Este produto não está disponível no seu mercado local, mas funcionará noutros países.",
					"edit_link": "Editar",
					"merchant_agreement": {
						"before_link": "Concordo com o",
						"link_text": "Contrato do comerciante",
						"after_link_one_product": "para este produto",
						"after_link_more_than_one_product": "para estes produtos"
					},
					"pricing_annex": {
						"before_link": "Concordo com os",
						"link_text": "Termos de Preços",
						"after_link_one_product": "para este produto"
					}
				},
				"support_footer": {
					"text": "Apoio em inglês",
					"copyright": {
						"eu": "Copyright © 2005-{currentYear} Klarna Bank AB (publ). Todos os direitos reservados.",
						"ap": "Copyright © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579.",
						"us": "Copyright © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215."
					},
					"terms_and_conditions": "Termos e Condições.",
					"privacy_policy": "Política de Privacidade",
					"merchant_id": "ID do comerciante {merchantId}",
					"email": "moa.support@klarna.com",
					"contact_number": "+46 (8) 123 45 67",
					"support_link": "Apoio ao comerciante",
					"recaptcha": {
						"1_main_text": "Este site é protegido pelo reCAPTCHA e pela Google",
						"2_privacy_policy": "Política de Privacidade",
						"3_and": "e",
						"4_terms_of_service": "Termos de Serviço",
						"5_apply": "aplicam-se."
					}
				},
				"global_prices_dialog": {
					"title_eu": "Preços para todos os nossos mercados",
					"title_us": "Preços",
					"subtitle": "Só lhe será cobrada uma taxa por transação, é smoooth!",
					"table": {
						"country": "País",
						"price_column_heading": "Taxa por transação",
						"global": "Global",
						"title": {
							"kp": "Formas de pagamento",
							"kco": "Caixa Klarna",
							"kco_one": "Caixa Klarna",
							"kp_one": "Forma de pagamento Klarna"
						},
						"headers": {
							"kp_one": "Taxa de Serviço"
						}
					},
					"buttons": {
						"back": "Voltar"
					},
					"foot_notes": {
						"global_price": "* Moeda local do comerciante, caso contrário "
					}
				},
				"fake_approval": {
					"first_transaction": {
						"title": "Primeira transação",
						"content": "Antes de podermos analisar os seus detalhes de pagamento, precisamos de uma primeira encomenda. Não quer desperdiçar o seu dinheiro? Não há problema!",
						"button": "Finja!"
					},
					"transactions": {
						"title": "Aprovar transações",
						"content": "Pode simplesmente fingir a aprovação da transação pela Salesforce",
						"button": "Aprovar"
					},
					"payouts": {
						"title": "Aprovar pagamentos",
						"content": "Pode simplesmente fingir a aprovação dos pagamentos pela Salesforce",
						"button": "Aprovar"
					}
				},
				"bank_account_summary": {
					"subtitle": {
						"default": "Conta bancária predefinida",
						"additional": "Conta bancária adicional {index}",
						"normal": "Conta bancária {index}"
					},
					"currency_code": {
						"label": "Moeda"
					},
					"country_of_bank_account": {
						"label": "País"
					},
					"account_number": {
						"label": {
							"default": "Número de conta",
							"MX_LOCAL": "Número de CLABE"
						}
					},
					"account_holder": {
						"label": "Nome do titular da conta"
					},
					"routing_number": {
						"label": "Número de encaminhamento"
					},
					"transit_number": {
						"label": "Número de trânsito"
					},
					"institution_number": {
						"label": "Número de instituição"
					},
					"bic": {
						"label": {
							"default": "BIC",
							"AU": "BSB"
						}
					},
					"no_edit_button": "Pode editar as informações da conta bancária depois de concluir a sua integração"
				},
				"store_details_summary": {
					"legal_company_name": {
						"label": "Nome jurídico da empresa"
					},
					"country": {
						"label": "País"
					},
					"registrationId": {
						"label": {
							"default": "Número de registo",
							"AT": "Número de registo",
							"AU": "ACN",
							"CA": "Número da empresa",
							"ES": "NIF/NIE/DNI da empresa",
							"GB": "Número da organização",
							"GR": "Número G.E.MI. (Γ.Ε.ΜΗ.)",
							"US": "Número de identificação de empregador"
						}
					},
					"organizationRegistrationAuthority": {
						"label": "Tribunal de registo"
					},
					"goodsCategory": {
						"label": "Categoria de mercadorias"
					},
					"registered": {
						"label": {
							"default": "Empresa registada",
							"AU": "A empresa tem um ACN"
						}
					},
					"subjectToVat": {
						"label": {
							"default": "Empresa sujeita a IVA",
							"AU": "Empresa sujeita a ABN",
							"ES": "A empresa tem um NIF/NIE/DNI"
						}
					},
					"vatId": {
						"label": {
							"default": "Número de IVA",
							"AU": "ABN",
							"ES": "NIF/NIE/DNI da empresa"
						}
					},
					"storeName": {
						"label": "Nome da loja"
					},
					"website": {
						"label": "Site"
					},
					"email": {
						"label": "E-mail de apoio ao cliente"
					},
					"entityType": {
						"label": "Tipo de entidade"
					},
					"toc_data": {
						"label": "Termos e condições",
						"toc_approval_text": {
							"before_link": "Os seus",
							"link_text": "termos e condições da Klarna",
							"after_link": "aceites em {date}",
							"merchant_agreement": {
								"before_link": "O seu",
								"link_text": "Contrato do comerciante",
								"after_link": "aceite em {date}"
							},
							"pricing_annex": {
								"before_link": "O seu",
								"link_text": "Anexo de Preços",
								"after_link": "aceite em {date}"
							}
						}
					},
					"companyName": {
						"label": "Nome da parceria"
					},
					"registeredCompanyName": {
						"label": "Nome da empresa"
					},
					"address": {
						"label": "Endereço"
					},
					"operatingAddress": {
						"label": "Endereço de funcionamento"
					},
					"organizationEntityType": {
						"label": "Classificação fiscal"
					}
				},
				"api_key_dialog": {
					"title": "Credenciais de API da Klarna geradas",
					"subtitle": "As credenciais serão mostradas apenas uma vez. Clique no botão abaixo para transferir as suas credenciais antes de fechar esta janela.",
					"key_box": {
						"username": {
							"label": "Nome de utilizador da API da Klarna"
						},
						"password": {
							"label": "Palavra-passe da API da Klarna"
						},
						"file_name": "Credenciais_Klarna"
					},
					"buttons": {
						"download": "Transferir como .txt"
					}
				},
				"platform_instructions": {
					"step": "Passo {current}/{max}",
					"next": "Seguinte",
					"back": "Voltar",
					"shopify": [
						{
							"title": "Gerar e guardar as suas credenciais de API da Klarna",
							"step_instructions": [
								[
									{
										"text": "Gere novas credenciais de API e transfira o ficheiro para o seu computador. Abra o ficheiro e mantenha-o aberto, pois precisará destas credenciais de API na próxima secção."
									}
								]
							],
							"alternate": [
								{
									"text": "Para obter informações mais detalhadas sobre a sua integração Shopify, siga o"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "guia de integração expandido."
								}
							]
						},
						{
							"title": "Instale a Klarna na sua loja Shopify",
							"step_instructions": [
								[
									{
										"text": "Vá ao"
									},
									{
										"link": "https://www.klarnapayments.com/merchant_admin/guide/install_app/slice_it_pay_over_time_with_klarna/enter-your-shopify-store-name-here",
										"text": "Assistente de configuração de forma de pagamento Klarna no Shopify."
									}
								],
								[
									{
										"text": "Siga as instruções para concluir a sua integração."
									}
								]
							],
							"alternate": [
								{
									"text": "Para obter informações mais detalhadas sobre a sua integração Shopify, siga o"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "guia de integração expandido."
								}
							]
						},
						{
							"title": "Fazer uma compra experimental",
							"step_instructions": [
								[
									{
										"text": "Para verificar se a integração está configurada corretamente, faça uma compra experimental na sua loja."
									}
								],
								[
									{
										"text": "Depois de fazer a encomenda, vá a"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Encomendas no Portal do comerciante,"
									},
									{
										"text": "encontre a sua encomenda e cancele-a, para evitar ter de a pagar."
									}
								],
								[
									{
										"text": "Assim que a sua integração for bem‑sucedida, o banner no topo desta página ficará verde e apresentará as palavras \"Integração concluída\"."
									}
								]
							],
							"alternate": [
								{
									"text": "Para obter informações mais detalhadas sobre a sua integração Shopify, siga o"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "guia de integração expandido."
								}
							]
						}
					],
					"plentymarkets": [
						{
							"title": "Ative o plugin de forma de pagamento da Klarna para Plentymarkets",
							"step_instructions": [
								[
									{
										"text": "Para poder instalar o plugin da Klarna, precisa de um sistema em execução de Plentymarkets CERES. O"
									},
									{
										"link": "https://marketplace.plentymarkets.com/en/plugins/sales/online-shops/ceres_4697",
										"text": "Plugin Ceres"
									},
									{
										"text": "está disponível para transferência em plentyMarketplace. A partir de lá, será redirecionado(a) para"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/online-store/setting-up-ceres",
										"text": "as instruções de instalação."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações detalhadas sobre a integração da Klarna com Plentymarkets Ceres, siga"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "esta ligação."
									}
								]
							]
						},
						{
							"title": "Instalação e configuração",
							"step_instructions": [
								[
									{
										"text": "A instalação do plugin da Klarna é feita através do"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "plentyMarketplace."
									},
									{
										"text": "Também é redirecionado para o plentyMarketplace a partir da retaguarda do sistema plentymarkets. As"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/slp/plugins/plugins-system-hinzufuegen",
										"text": "instruções sobre como instalar plugins em plentymarkets"
									},
									{
										"text": "podem ser encontradas no plentyKnowledge."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações detalhadas sobre a integração da Klarna com Plentymarkets Ceres, siga"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "esta ligação."
									}
								]
							]
						},
						{
							"title": "Configuração do plugin",
							"step_instructions": [
								[
									{
										"text": "O plugin é configurado diretamente no respetivo conjunto. Ao clicar na linha do"
									},
									{
										"bold": "plugin da Klarna,"
									},
									{
										"text": "abre-se a página de configuração."
									}
								],
								[
									{
										"text": "A configuração está dividida em duas áreas:"
									},
									{
										"list": [
											[
												{
													"bold": "Autenticação:"
												},
												{
													"text": "O modo é utilizado para determinar se está a testar ou a ser produtivo. Dependendo do modo, o nome de utilizador e a palavra-passe têm de ser armazenados."
												}
											],
											[
												{
													"bold": "Definições gerais:"
												},
												{
													"text": "Aqui seleciona o produto que deseja usar. As formas de pagamento individuais da Klarna (Pagamento Klarna) ou toda a finalização de compra da Klarna (Caixa Klarna). Ao selecionar a finalização de compra, a finalização de compra será automaticamente substituída pela caixa Klarna."
												}
											]
										]
									},
									{
										"text": "Não existem mais definições necessárias e, se desativar o plugin, esta ação será anulada."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações detalhadas sobre a integração da Klarna com Plentymarkets Ceres, siga"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "esta ligação."
									}
								]
							]
						},
						{
							"title": "Informações finais",
							"step_instructions": [
								[
									{
										"text": "Aplicam-se os seguintes requisitos de sistema:"
									},
									{
										"list": [
											{
												"text": "Plentymarkets versão 7"
											},
											{
												"text": "Plugins Ceres e IO instalados"
											}
										]
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações detalhadas sobre a integração da Klarna com Plentymarkets Ceres, siga"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "esta ligação."
									}
								]
							]
						}
					],
					"woocommerce_kco": [
						{
							"title": "Ativar o plugin da caixa Klarna para WooCommerce",
							"step_instructions": [
								[
									{
										"text": "Em primeiro lugar, certifique-se de que instalou o plugin da caixa Klarna para WooCommerce. Se ainda não tiver o plugin, vá a"
									},
									{
										"link": "https://woocommerce.com/products/klarna-checkout/#",
										"text": "esta página"
									},
									{
										"text": "para o obter."
									}
								],
								[
									{
										"text": "Assim que tiver as suas credenciais de API da Klarna, vá a “Definições” e, depois, “Finalização de compra” no seu painel WooCommerce. Escolha Caixa Klarna."
									}
								],
								[
									{
										"text": "Ative a caixa Klarna assinalando a caixa de seleção Ativar Caixa Klarna."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração WooCommerce, consulte o seu"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "guia expandido."
									}
								]
							]
						},
						{
							"title": "Configure as suas definições",
							"step_instructions": [
								[
									{
										"text": "Configure as definições para a sua caixa Klarna. Perceba que o campo “Título” é utilizado para definir o título para a forma de pagamento apresentada na sua finalização de compra e e-mails de confirmação de encomenda (isto é, caixa Klarna)."
									}
								],
								[
									{
										"text": "Assinale a caixa de seleção “Modo de teste” se desejar criar encomendas utilizando credenciais de teste."
									}
								],
								[
									{
										"text": "Está na altura de preencher as definições de País. Se está localizado(a) na Europa, clique em “expandir” na secção Europa. Se está localizado(a) nos EUA, clique em “expandir” na secção EUA."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração WooCommerce, consulte o seu"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "guia expandido."
									}
								]
							]
						},
						{
							"title": "Adicione as suas credenciais de API da Klarna",
							"step_instructions": [
								[
									{
										"text": "Adicione as suas credenciais de API da Klarna nos campos de nome de utilizador de API da Klarna e palavra-passe de API da Klarna."
									}
								],
								[
									{
										"text": "Guarde as suas definições."
									}
								],
								[
									{
										"text": "A última coisa a fazer é configurar a caixa Klarna como forma de pagamento predefinida. Vá a “Definições” e depois “Pagamentos” no seu painel WooCommerce. Encontre a secção “Formas de pagamento” e defina a caixa Klarna como a forma de pagamento predefinida."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração WooCommerce, consulte o seu"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "guia expandido."
									}
								]
							]
						},
						{
							"title": "Últimos passos",
							"step_instructions": [
								[
									{
										"text": "Certifique-se de ativar"
									},
									{
										"link": "https://codex.wordpress.org/Using_Permalinks",
										"text": "pretty permalinks"
									},
									{
										"text": "na sua instalação WordPress. Caso contrário, as revogações da Klarna para a sua loja não funcionarão e as encomendas não serão atualizadas com o estado ou a informação corretos."
									}
								],
								[
									{
										"text": "Se desejar tratar da sua encomenda Klarna diretamente em WooCommerce, precisa de instalar o"
									},
									{
										"link": "https://wordpress.org/plugins/klarna-order-management-for-woocommerce/",
										"text": "plugin de gestão de encomendas"
									},
									{
										"text": "da Klarna."
									}
								],
								[
									{
										"text": "Certifique-se de que a Caixa Klarna é apresentada conforme esperado adicionando um item ao seu carrinho, e continuando para a finalização de compra (mas não faça realmente a encomenda)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração WooCommerce, consulte o seu"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "guia expandido."
									}
								]
							]
						}
					],
					"woocommerce_kp": [
						{
							"title": "Gerar e guardar as suas credenciais de API da Klarna",
							"step_instructions": [
								[
									{
										"text": "Gere novas credenciais de API e transfira o ficheiro para o seu computador. Abra o ficheiro e mantenha-o aberto, pois precisará destas credenciais de API na próxima secção."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração WooCommerce, siga as"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "guia de integração expandido."
									}
								]
							]
						},
						{
							"title": "Instale e ative o plugin de forma de pagamento Klarna",
							"step_instructions": [
								[
									{
										"text": "Instale o"
									},
									{
										"link": "https://woocommerce.com/products/klarna-payments/",
										"text": "Plugin de forma de pagamento Klarna para WooCommerce."
									}
								],
								[
									{
										"text": "Na sua conta WooCommerce, vá a"
									},
									{
										"bold": "Definições → Pagamentos → Forma de pagamento Klarna."
									}
								],
								[
									{
										"text": "Ative Forma de Pagamento Klarna ao assinalar a caixa de seleção Ativar Formas de Pagamento Klarna."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração WooCommerce, siga as"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "guia de integração expandido."
									}
								]
							]
						},
						{
							"title": "definições Configurar o seu país",
							"step_instructions": [
								[
									{
										"text": "Preencha as definições de país. Cada país com Klarna tem o seu próprio conjunto de definições específicas para o país. Ao adicionar credenciais de comerciante para um país específico, também ativa Forma de pagamento Klarna como uma forma de pagamento para esse país."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração WooCommerce, siga as"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "guia de integração expandido."
									}
								]
							]
						},
						{
							"title": "Introduza as suas credenciais de API da Klarna",
							"step_instructions": [
								[
									{
										"text": "Introduza as suas credenciais de API da Klarna nos campos de nome de utilizador de API da Klarna e palavra-passe de API da Klarna."
									}
								],
								[
									{
										"text": "Guarde as suas definições."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração WooCommerce, siga as"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "guia de integração expandido."
									}
								]
							]
						},
						{
							"title": "Fazer uma compra experimental",
							"step_instructions": [
								[
									{
										"text": "Para verificar se a integração está configurada corretamente, faça uma compra experimental na sua loja."
									}
								],
								[
									{
										"text": "Depois de fazer a encomenda, vá a"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Encomendas no Portal do comerciante,"
									},
									{
										"text": "encontre a sua encomenda e cancele-a, para evitar ter de a pagar."
									}
								],
								[
									{
										"text": "Assim que a sua integração for bem‑sucedida, o banner no topo desta página ficará verde e apresentará as palavras \"Integração concluída\"."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração WooCommerce, siga as"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "guia de integração expandido."
									}
								]
							]
						}
					],
					"magento_kco": [
						{
							"title": "Configure as suas definições para ativar a caixa Klarna",
							"step_instructions": [
								[
									{
										"text": "Em primeiro lugar, certifique-se de que instalou o módulo caixa Klarna para Magento. Se ainda não tiver o módulo, vá a"
									},
									{
										"link": "https://marketplace.magento.com/klarna-m2-checkout.html",
										"text": "esta página"
									},
									{
										"text": "para o obter."
									}
								],
								[
									{
										"text": "Assim que tiver as suas credenciais de API da Klarna, abra o seu painel Magento. Vá a “Lojas” → “Configuração” → “Vendas” → “Formas de pagamento” → “Klarna” → “API da Klarna”."
									}
								],
								[
									{
										"text": "Expanda a secção “API da Klarna” e preencha a sua versão de API, o nome de utilizador da API da Klarna e a palavra-passe da API da Klarna. Certifique-se de desativar o modo de teste se estiver pronto(a) para tornar o seu site disponível."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração no Magento, consulte os respetivos"
									},
									{
										"link": "https://marketplace.magento.com/media/catalog/product/klarna-m2-checkout-6-2-0-ce/user_guides.pdf",
										"text": "guia expandido."
									}
								]
							]
						},
						{
							"title": "Últimos passos",
							"step_instructions": [
								[
									{
										"text": "Quando as suas definições estiverem configuradas, precisa de verificar se a caixa Klarna está ativada nas suas opções de finalização de compra."
									}
								],
								[
									{
										"text": "Vá a “Lojas” → “Configurações” → “Vendas” → “Finalização de compra” → “Opções de Caixa Klarna”, no seu painel Magento."
									}
								],
								[
									{
										"text": "Como predefinição, a caixa Klarna deve estar ativada. Se não estiver, mude para"
									},
									{
										"bold": "Ativar"
									},
									{
										"text": "em “Ativar Caixa Klarna”."
									}
								]
							]
						}
					],
					"magento_kp": [
						{
							"title": "Gerar e guardar as suas credenciais de API da Klarna",
							"step_instructions": [
								[
									{
										"text": "Gere novas credenciais de API e transfira o ficheiro para o seu computador. Abra o ficheiro e mantenha-o aberto, pois precisará destas credenciais de API na próxima secção."
									}
								]
							]
						},
						{
							"title": "Instalar e ativar o módulo de forma de pagamento Klarna",
							"step_instructions": [
								[
									{
										"text": "Visite"
									},
									{
										"link": "https://docs.magento.com/user-guide/payment/klarna-setup.html#set-up-klarna-payments-in-magento",
										"text": "Configurar a Klarna no Guia do Utilizador de Magento"
									},
									{
										"text": "e siga as instruções para instalar e configurar o módulo na sua conta Magento."
									}
								]
							]
						},
						{
							"title": "Fazer uma compra experimental",
							"step_instructions": [
								[
									{
										"text": "Para verificar se a integração está configurada corretamente, faça uma compra experimental na sua loja."
									}
								],
								[
									{
										"text": "Depois de fazer a encomenda, vá a"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Encomendas no Portal do comerciante,"
									},
									{
										"text": "encontre a sua encomenda e cancele-a, para evitar ter de a pagar."
									}
								],
								[
									{
										"text": "Assim que a sua integração for bem‑sucedida, o banner no topo desta página ficará verde e apresentará as palavras \"Integração concluída\"."
									}
								]
							]
						}
					],
					"shopware_kp": [
						{
							"title": "Ativar o plugin de Forma de pagamento Klarna para Shopware",
							"step_instructions": [
								[
									{
										"text": "Em primeiro lugar, certifique-se de que instalou o plugin de Forma de pagamento Klarna para Shopware. Se ainda não tiver o plugin, vá a"
									},
									{
										"link": "https://store.shopware.com/en/besti13231874259f/klarna-payments.html",
										"text": "esta página"
									},
									{
										"text": "para o obter."
									}
								],
								[
									{
										"text": "Num passo seguinte, precisa de importar o plugin de Forma de pagamento Klarna para o Shopware ao clicar em"
									},
									{
										"bold": "Configuração → Gestor de Plugin → Instalado → Carregar Plugin."
									},
									{
										"text": "Clicar"
									},
									{
										"bold": "Selecionar"
									},
									{
										"text": "e selecione o ficheiro ZIP do plugin de Forma de pagamento Klarna. Confirme ao clicar em"
									},
									{
										"bold": "Carregar Plugin."
									},
									{
										"text": "O plugin pode agora ser encontrado no gestor de plugins."
									}
								],
								[
									{
										"text": "Instale o plugin ao clicar no ícone"
									},
									{
										"bold": "verde “+”"
									},
									{
										"text": "."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de Shopware, consulte o nosso"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guia expandido (em alemão)."
									}
								]
							]
						},
						{
							"title": "Configurar o plugin de Forma de pagamento Klarna para Shopware",
							"step_instructions": [
								[
									{
										"text": "Navegue para as definições de Plugin ao clicar em"
									},
									{
										"bold": "Configuração → Definições básicas → Pesquisar Forma de Pagamento Klarna"
									}
								],
								[
									{
										"text": "Introduza as suas credenciais de API da Klarna nos campos"
									},
									{
										"bold": "Nome de utilizador da API da Klarna"
									},
									{
										"text": "e"
									},
									{
										"bold": "Palavra-passe da API da Klarna"
									},
									{
										"text": "e guarde as suas alterações."
									}
								],
								[
									{
										"text": "Certifique-se de que está a utilizar o modo em tempo direto e utilize as suas credenciais de API da Klarna."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de Shopware, consulte o nosso"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guia expandido (em alemão)."
									}
								]
							]
						},
						{
							"title": "Configure os seus gateways de Forma de Pagamento Klarna",
							"step_instructions": [
								[
									{
										"text": "Antes de utilizar a Klarna, precisa de ativar os seus gateways de Forma de Pagamento Klarna. Pode encontrá-los ao clicar em"
									},
									{
										"bold": "Configuração → Formas de pagamento"
									}
								],
								[
									{
										"text": "Por predefinição, todos os gateways de forma de pagamento da Klarna estão instalados. Abra os gateways de Forma de Pagamento Klarna para os quais se registou e ative‑os assinalando a"
									},
									{
										"bold": "caixa de seleção"
									},
									{
										"text": "Ativado. Guarde as suas alterações."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de Shopware, consulte o nosso"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guia expandido (em alemão)."
									}
								]
							]
						},
						{
							"title": "Configurar o seu custo de envio",
							"step_instructions": [
								[
									{
										"text": "Configure os seus custos de envio para os seus gateways de Forma de Pagamento Klarna ao clicar em"
									},
									{
										"bold": "Configuração → Custo de envio"
									}
								],
								[
									{
										"text": "Selecione os métodos de envio que devem estar disponíveis para a Klarna ao clicar no"
									},
									{
										"bold": "ícone do lápis."
									}
								],
								[
									{
										"text": "Selecione o separador “seleção de forma de pagamento” e mova o seu gateway de forma pagamento Klarna de"
									},
									{
										"bold": "Disponível"
									},
									{
										"text": "para"
									},
									{
										"bold": "Selecionado."
									},
									{
										"text": "Guarde as suas definições"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de Shopware, consulte o nosso"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guia expandido (em alemão)."
									}
								]
							]
						},
						{
							"title": "Ative o seu plugin de Forma de Pagamento Klarna",
							"step_instructions": [
								[
									{
										"text": "A seguir, precisa de ativar o plugin de Forma de Pagamento Klarna. Clique em"
									},
									{
										"bold": "Configuração → Gestor de Plugin → Instalado"
									},
									{
										"text": "para chegar ao Gestor de Plugins."
									}
								],
								[
									{
										"text": "Ative o Plugin ao clicar no"
									},
									{
										"bold": "“X” vermelho"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Ser-lhe-á perguntado se quer esvaziar a cache. Clique em"
									},
									{
										"bold": "Sim."
									},
									{
										"text": "Tenha em atenção que precisa de limpar a cache e compilar temas de todas as vezes que alterar algo nas definições do módulo ou nas formas de pagamento da Klarna."
									}
								],
								[
									{
										"text": "Para ativar completamente o plugin de forma de Pagamentos Klarna, o tema da loja precisa de ser recompilado. Clique em"
									},
									{
										"bold": "Compile os temas"
									},
									{
										"text": "quando lhe for pedido."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de Shopware, consulte o nosso"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guia expandido (em alemão)."
									}
								]
							]
						},
						{
							"title": "Últimos passos",
							"step_instructions": [
								[
									{
										"text": "Para evitar quaisquer erros de arredondamento, certifique-se de que tem a extensão PHP bcmath instalada no seu servidor. Encontre o guia"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "aqui"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Reinicie a sua retaguarda uma vez para assegurar que todas as configurações estão disponíveis na sua loja."
									}
								],
								[
									{
										"text": "Certifique-se de que os seus produtos de Pagamento da Klarna são apresentados conforme esperado, ao adicionar um item ao seu carrinho, ao escolher a Klarna como forma de pagamento e ao continuar para a finalização da compra (mas não faça realmente a encomenda)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de Shopware, consulte o nosso"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guia expandido (em alemão)."
									}
								]
							]
						}
					],
					"shopware_kco": [
						{
							"title": "Ativar o plugin de Caixa Klarna para Shopware",
							"step_instructions": [
								[
									{
										"text": "Em primeiro lugar, certifique-se de que instalou o plugin da caixa Klarna para Shopware (Versão 5.2.17 e mais recentes). Se ainda não tiver o plugin, vá a"
									},
									{
										"link": "https://store.shopware.com/en/besti56121054232f/klarna-checkout.html",
										"text": "esta página"
									},
									{
										"text": "para o obter."
									}
								],
								[
									{
										"text": "Num passo seguinte, precisa de importar o plugin da Caixa Klarna para o Shopware ao clicar em"
									},
									{
										"bold": "Configuração → Gestor de Plugin → Instalado → Carregar Plugin."
									},
									{
										"text": "Clicar"
									},
									{
										"bold": "Selecionar"
									},
									{
										"text": "e selecione o ficheiro ZIP do plugin da caixa Klarna. Confirme ao clicar em"
									},
									{
										"bold": "Carregar Plugin."
									},
									{
										"text": "O plugin pode agora ser encontrado no gestor de plugins."
									}
								],
								[
									{
										"text": "Instale o plugin ao clicar no ícone"
									},
									{
										"bold": "verde “+”"
									},
									{
										"text": "."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de Shopware, consulte o nosso"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guia expandido (em alemão)."
									}
								]
							]
						},
						{
							"title": "Configurar o plugin da Caixa Klarna para Shopware",
							"step_instructions": [
								[
									{
										"text": "Navegue para as definições de Plugin ao clicar em"
									},
									{
										"bold": "Configuração → Definições básicas → Pesquisar Caixa Klarna"
									}
								],
								[
									{
										"text": "Introduza as suas credenciais de API da Klarna nos campos"
									},
									{
										"bold": "Nome de utilizador da API da Klarna"
									},
									{
										"text": "e"
									},
									{
										"bold": "Palavra-passe da API da Klarna"
									},
									{
										"text": "e guarde as suas alterações."
									}
								],
								[
									{
										"text": "Certifique-se de que está a utilizar o modo em tempo direto e utilize as suas credenciais de API da Klarna."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de Shopware, consulte o nosso"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guia expandido (em alemão)."
									}
								]
							]
						},
						{
							"title": "Ative o gateway de pagamento da caixa Klarna",
							"step_instructions": [
								[
									{
										"text": "Antes de utilizar a Klarna, precisa de ativar o seu gateway de Pagamento Klarna. Pode encontrá-los ao clicar em"
									},
									{
										"bold": "Configuração → Formas de pagamento"
									}
								],
								[
									{
										"text": "Abra o gateway da caixa Klarna e ative-o ao assinalar a"
									},
									{
										"bold": "caixa de seleção"
									},
									{
										"text": "Ativado. Guarde as suas alterações."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de Shopware, consulte o nosso"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guia expandido (em alemão)."
									}
								]
							]
						},
						{
							"title": "Configurar o seu custo de envio",
							"step_instructions": [
								[
									{
										"text": "Configure os seus custos de envio para a sua caixa Klarna ao clicar em"
									},
									{
										"bold": "Configuração → Custo de envio"
									}
								],
								[
									{
										"text": "Selecione os métodos de envio que devem estar disponíveis para a Klarna ao clicar no"
									},
									{
										"bold": "ícone do lápis."
									}
								],
								[
									{
										"text": "Selecione o separador “seleção de forma de pagamento” e mova a sua caixa Klarna de"
									},
									{
										"bold": "Disponível"
									},
									{
										"text": "para"
									},
									{
										"bold": "Selecionado."
									},
									{
										"text": "Guarde as suas definições"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de Shopware, consulte o nosso"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guia expandido (em alemão)."
									}
								]
							]
						},
						{
							"title": "Ative o seu plugin da caixa Klarna",
							"step_instructions": [
								[
									{
										"text": "A seguir, precisa de ativar o plugin da Caixa Klarna. Clique em"
									},
									{
										"bold": "Configuração → Gestor de Plugin → Instalado"
									},
									{
										"text": "para chegar ao Gestor de Plugins."
									}
								],
								[
									{
										"text": "Ative o Plugin ao clicar no"
									},
									{
										"bold": "“X” vermelho"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Ser-lhe-á perguntado se quer esvaziar a cache. Clique em"
									},
									{
										"bold": "Sim."
									}
								],
								[
									{
										"text": "Para ativar completamente o plugin da Caixa Klarna, o tema da loja precisa de ser recompilado. Clique em"
									},
									{
										"bold": "Compile os temas"
									},
									{
										"text": "quando lhe for pedido."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de Shopware, consulte o nosso"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guia expandido (em alemão)."
									}
								]
							]
						},
						{
							"title": "Últimos passos",
							"step_instructions": [
								[
									{
										"text": "Para evitar quaisquer erros de arredondamento, certifique-se de que tem a extensão PHP bcmath instalada no seu servidor. Encontre o guia"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "aqui"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Certifique-se de que “Linha de endereço adicional 1” e “Linha de endereço adicional 2” não estão marcadas como obrigatórias."
									}
								],
								[
									{
										"text": "Reinicie a sua retaguarda uma vez para assegurar que todas as configurações estão disponíveis na sua loja."
									}
								],
								[
									{
										"text": "Certifique-se de que a sua Caixa Klarna é apresentada conforme esperado ao adicionar um item ao seu carrinho, escolher a Klarna como forma de pagamento e continuar para a finalização de compra (mas não faça realmente a encomenda)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de Shopware, consulte o nosso"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guia expandido (em alemão)."
									}
								]
							]
						}
					],
					"shopware_6_kp": [
						{
							"title": "Ativar o plugin de Forma de pagamento Klarna para Shopware",
							"step_instructions": [
								[
									{
										"text": "Para poder instalar o plugin da Klarna, precisa de um sistema em execução de Shopware 6. As diretrizes de instalação podem ser encontradas"
									},
									{
										"link": "https://docs.shopware.com/en/shopware-6-en/first-steps/installing-shopware-6",
										"text": "aqui."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de Shopware, consulte o nosso"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guia expandido (em alemão)."
									}
								]
							]
						},
						{
							"title": "Instalação e configuração. Existem várias maneiras de instalar o plugin da Klarna.",
							"step_instructions": [
								[
									{
										"text": "Primeiro, execute o assistente."
									}
								],
								[
									{
										"text": "Instalação através da Administração."
									}
								],
								[
									{
										"text": "Instalação através de transferência direta da loja da comunidade."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de Shopware, consulte o nosso"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guia expandido (em alemão)."
									}
								]
							]
						},
						{
							"title": "Ativar o plugin de Forma de pagamento Klarna para Shopware",
							"step_instructions": [
								[
									{
										"text": "Vá à visão geral dos seus plugins na administração Shopware. Pode aceder a isto através de"
									},
									{
										"bold": "Definições > Sistema > Plugins."
									}
								],
								[
									{
										"text": "Selecionar"
									},
									{
										"bold": "Instalar"
									},
									{
										"text": "a partir do menu de contexto (\"...\"). Receberá uma mensagem de sucesso da Shopware a dizer que o plugin foi instalado com sucesso."
									}
								],
								[
									{
										"text": "Por motivos de segurança, o plugin está agora instalado, mas ainda não está ativado. Precisa de otimizá-lo com os seus dados de acesso e definições individuais primeiro."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de Shopware, consulte o nosso"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guia expandido (em alemão)."
									}
								]
							]
						},
						{
							"title": "Assistente",
							"step_instructions": [
								[
									{
										"text": "Depois de o plugin ter sido ativado, vá ao"
									},
									{
										"bold": "menu de contexto (\"...\") > assistente.",
										"text": "Será então encaminhado(a) para a rotina."
									}
								],
								[
									{
										"text": "A rotina irá guiá-lo(a) através de todo o processo de configuração e permite-lhe registar-se com a Klarna se ainda não tiver uma conta de comerciante."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de Shopware, consulte o nosso"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guia expandido (em alemão)."
									}
								]
							]
						},
						{
							"title": "Configuração do plugin",
							"step_instructions": [
								[
									{
										"bold": "Canais de vendas."
									},
									{
										"text": "Aqui, você determina se as definições seguintes devem ser aplicadas a \"todos os canais de vendas\" ou se só se devem aplicar a certos canais de vendas individuais."
									}
								],
								[
									{
										"bold": "Definições da API."
									},
									{
										"text": "Nome de utilizador da API e palavra-passe da API: Introduza os seus dados de acesso da API para os modos em tempo real e de teste nas secções apropriadas."
									}
								],
								[
									{
										"text": "Pode testar as suas credenciais de API da Klarna ao clicar no botão"
									},
									{
										"bold": "Testar credenciais API",
										"text": ", que se encontra no cabeçalho. Receberá então uma mensagem de sucesso ou uma indicação de que os dados parecem estar incorretos."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de Shopware, consulte o nosso"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guia expandido (em alemão)."
									}
								]
							]
						},
						{
							"title": "Ativar/desativar plugin",
							"step_instructions": [
								[
									{
										"text": "Se deseja ativar/desativar o plugin de Forma de pagamento Klarna ou só deseja ver o estado de ativação atual, vá a “Shopware Admin” e selecione"
									},
									{
										"bold": "Definições > Sistema > Plugins."
									}
								],
								[
									{
										"text": "Aqui, pode encontrar o estado atual na tabela por baixo de"
									},
									{
										"bold": "\"Os meus Plugins\"."
									}
								],
								[
									{
										"text": "O estado pode ser alterado ao clicar no Cursor de deslizamento."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de Shopware, consulte o nosso"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guia expandido (em alemão)."
									}
								]
							]
						},
						{
							"title": "Últimos passos",
							"step_instructions": [
								[
									{
										"text": "Para evitar quaisquer erros de arredondamento, certifique-se de que tem a versão de PHP >= 7,2."
									}
								],
								[
									{
										"text": "Instalação completa de Shopware"
									},
									{
										"bold": "(Frente de loja + Administração, não sem cabeçalho)."
									}
								],
								[
									{
										"text": "O sistema tem de ser acessível a partir do exterior para atualizar o estado de pagamento."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de Shopware, consulte o nosso"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guia expandido (em alemão)."
									}
								]
							]
						}
					],
					"3dcart_kp": [
						{
							"title": "Gerar e guardar as suas credenciais de API da Klarna",
							"step_instructions": [
								[
									{
										"text": "Gere novas credenciais de API e transfira o ficheiro para o seu computador. Abra o ficheiro e mantenha-o aberto, pois precisará destas credenciais de API na próxima secção."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de 3dcart, siga o"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "guia de integração expandido."
									}
								]
							]
						},
						{
							"title": "Ativar Forma de Pagamento Klarna no Gestor de Lojas Online",
							"step_instructions": [
								[
									{
										"text": "Inicie sessão no seu"
									},
									{
										"link": "https://www.shift4shop.com/login-page.html",
										"text": "Gestor de Lojas Online 3dcart,"
									},
									{
										"text": "e navegue para"
									},
									{
										"bold": "Definições → Pagamento."
									}
								],
								[
									{
										"text": "Na página de pagamento, clique no botão"
									},
									{
										"bold": "Selecionar formas de pagamento"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Verá uma lista de módulos pré‑instalados. Localize o módulo Klarna e ative‑o utilizando o comutador."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de 3dcart, siga o"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "guia de integração expandido."
									}
								]
							]
						},
						{
							"title": "Introduza as suas credenciais de API da Klarna",
							"step_instructions": [
								[
									{
										"text": "Depois de ativar o módulo, introduza o nome de utilizador da API da Klarna (UID) no campo fornecido. Encontrará isto no ficheiro de credenciais que transferiu anteriormente."
									}
								],
								[
									{
										"text": "A seguir, clique na ligação de"
									},
									{
										"bold": "Alteração de palavra-passe"
									},
									{
										"text": "e introduza a sua palavra-passe da API da Klarna no campo da palavra‑passe."
									}
								],
								[
									{
										"text": "Em"
									},
									{
										"bold": "Idioma do país"
									},
									{
										"text": ", selecione o idioma do país que será utilizado para as opções de pagamento Klarna na loja."
									}
								],
								[
									{
										"text": "Acima do campo de nome de utilizador, está uma caixa de seleção chamada"
									},
									{
										"bold": "\"Modo de Teste\"."
									},
									{
										"text": "Assinale esta opção para ativar o modo de teste, permitindo-lhe fazer encomendas sem quaisquer despesas ou ações de pagamento, enquanto testa o módulo."
									}
								],
								[
									{
										"text": "Assim que tiver configurado as suas definições, clique em \"Guardar\" no canto superior direito."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de 3dcart, siga o"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "guia de integração expandido."
									}
								]
							]
						},
						{
							"title": "Fazer uma compra experimental",
							"step_instructions": [
								[
									{
										"text": "Para verificar se a integração está configurada corretamente, faça uma compra experimental na sua loja."
									}
								],
								[
									{
										"text": "Depois de fazer a encomenda, vá a"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Encomendas no Portal do comerciante,"
									},
									{
										"text": "encontre a sua encomenda e cancele-a, para evitar ter de a pagar."
									}
								],
								[
									{
										"text": "Assim que a sua integração for bem‑sucedida, o banner no topo desta página ficará verde e apresentará as palavras \"Integração concluída\"."
									}
								],
								[
									{
										"text": "Se ligou o “Modo de teste” no passo anterior, volte atrás para anular essa seleção e guardar antes de tornar a sua loja disponível, para que as suas encomendas reais sejam efetuadas corretamente."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Para obter informações mais detalhadas sobre a sua integração de 3dcart, siga o"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "guia de integração expandido."
									}
								]
							]
						}
					],
					"bigcommerce_kp": [
						{
							"title": "Gerar e guardar as suas credenciais de API da Klarna",
							"step_instructions": [
								[
									{
										"text": "Gere novas credenciais de API e transfira o ficheiro para o seu computador. Abra o ficheiro e mantenha-o aberto, pois precisará destas credenciais de API na próxima secção."
									}
								]
							],
							"alternate": [
								{
									"text": "Para obter informações mais detalhadas sobre a sua integração de BigCommerce, siga o"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "guia de integração expandido."
								}
							]
						},
						{
							"title": "Configure as suas definições de BigCommerce",
							"step_instructions": [
								[
									{
										"text": "Em BigCommerce, vá a"
									},
									{
										"link": "http://login.bigcommerce.com/deep-links/settings/payment",
										"text": "Configuração da Loja › Pagamentos,"
									},
									{
										"text": "e expanda a secção de Formas de pagamento online. Depois, clique em"
									},
									{
										"bold": "Configurar"
									},
									{
										"text": "junto de Forma de pagamento Klarna."
									}
								],
								[
									{
										"text": "Será direcionado(a) para o separador Definições de Forma de Pagamento Klarna. Introduza as credenciais de API que guardou na secção anterior e copie o nome de utilizador e a palavra-passe para os seus campos correspondentes."
									}
								],
								[
									{
										"text": "Guarde as suas alterações quando estiver pronto(a)."
									}
								]
							],
							"alternate": [
								{
									"text": "Para obter informações mais detalhadas sobre a sua integração de BigCommerce, siga o"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "guia de integração expandido."
								}
							]
						},
						{
							"title": "Fazer uma compra experimental",
							"step_instructions": [
								[
									{
										"text": "Para verificar se a integração está configurada corretamente, faça uma compra experimental na sua loja."
									}
								],
								[
									{
										"text": "Depois de fazer a encomenda, vá a"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Encomendas no Portal do comerciante,"
									},
									{
										"text": "encontre a sua encomenda e cancele-a, para evitar ter de a pagar."
									}
								],
								[
									{
										"text": "Assim que a sua integração for bem‑sucedida, o banner no topo desta página ficará verde e apresentará as palavras \"Integração concluída\"."
									}
								]
							],
							"alternate": [
								{
									"text": "Para obter informações mais detalhadas sobre a sua integração de BigCommerce, siga o"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "guia de integração expandido."
								}
							]
						}
					],
					"prestashop_kco": [
						{
							"title": "Ativar o módulo da caixa Klarna",
							"step_instructions": [
								[
									{
										"text": "Em primeiro lugar, certifique-se de que instalou o módulo oficial da Klarna para Prestashop. Se ainda não o tiver, vá a"
									},
									{
										"link": "https://addons.prestashop.com/en/express-checkout-process/90132-klarna-checkout.html?no_cache=1",
										"text": "esta página"
									},
									{
										"text": "para o obter."
									}
								],
								[
									{
										"text": "Infelizmente, a partir de 1 de janeiro de 2023, estes plug-ins desenvolvidos e de propriedade da Prestasworks A.B (SI) deixarão de ser distribuídos gratuitamente. Se estiver interessado na Klarna, poderá comprar o plug-in ou aguardar os plug-ins de propriedade da Klarna que deverão ser lançados no segundo trimestre de 2023."
									}
								],
								[
									{
										"text": "Inicie sessão na sua página de administração de Prestashop e vá a"
									},
									{
										"bold": "Módulos → Módulos."
									}
								],
								[
									{
										"text": "Pesquise “Klarna” na barra de pesquisa para localizar o módulo Klarna por Prestaworks AB. Clicar"
									},
									{
										"bold": "Configurar."
									}
								]
							]
						},
						{
							"title": "Configure as definições do seu módulo Klarna",
							"step_instructions": [
								[
									{
										"text": "Está agora na página de definições do módulo. No topo das “Definições gerais”, verá um botão chamado"
									},
									{
										"bold": "Ativar KCO nesta loja"
									},
									{
										"text": "(Caixa Klarna V3). Escolha"
									},
									{
										"bold": "Sim."
									}
								],
								[
									{
										"text": "Clicar"
									},
									{
										"bold": "Guardar"
									},
									{
										"text": "para guardar as suas definições."
									}
								],
								[
									{
										"text": "Agora, clique no seu país de vendas no menu à esquerda e introduza as suas credenciais de API da Klarna em"
									},
									{
										"bold": "Nome de utilizador da API da Klarna"
									},
									{
										"text": "e"
									},
									{
										"bold": "palavra-passe da API da Klarna."
									}
								],
								[
									{
										"text": "Clicar"
									},
									{
										"bold": "Guarde."
									}
								]
							]
						},
						{
							"title": "Últimos passos",
							"step_instructions": [
								[
									{
										"text": "Se estiver pronto(a) para colocar o seu site disponível, verifique que o modo de teste está desativado. Pode fazer isto no separador"
									},
									{
										"bold": "Definições comuns."
									},
									{
										"text": "O botão"
									},
									{
										"bold": "Testdrive"
									},
									{
										"text": "deve estar definido para"
									},
									{
										"bold": "Não."
									}
								],
								[
									{
										"text": "Nas"
									},
									{
										"bold": "Definições comuns,"
									},
									{
										"text": "certifique-se de configurar as suas definições para como deseja tratar as encomendas, definições para envio de faturas, etc."
									}
								],
								[
									{
										"text": "Certifique-se de que a sua Caixa Klarna é apresentada conforme esperado ao adicionar um item ao seu carrinho, e continue para a finalização da compra (mas não faça realmente a encomenda)."
									}
								]
							]
						}
					],
					"prestashop_kp": [
						{
							"title": "Gerar e guardar as suas credenciais de API da Klarna",
							"step_instructions": [
								[
									{
										"text": "Gere novas credenciais de API e transfira o ficheiro para o seu computador. Abra o ficheiro e mantenha-o aberto, pois precisará destas credenciais de API na próxima secção."
									}
								]
							]
						},
						{
							"title": "Instalar e ativar o módulo de forma de pagamento Klarna",
							"step_instructions": [
								[
									{
										"text": "Abra a"
									},
									{
										"link": "https://addons.prestashop.com/en/payment-card-wallet/90140-klarna-payments.html?no_cache=1",
										"text": "página de instruções Prestashop de Forma de Pagamento Klarna"
									},
									{
										"text": "e siga as instruções para instalar e configurar o módulo na sua conta Prestashop."
									}
								]
							]
						},
						{
							"title": "Fazer uma compra experimental",
							"step_instructions": [
								[
									{
										"text": "Para verificar se a integração está configurada corretamente, faça uma compra experimental na sua loja."
									}
								],
								[
									{
										"text": "Depois de fazer a encomenda, vá a"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Encomendas no Portal do comerciante,"
									},
									{
										"text": "encontre a sua encomenda e cancele-a, para evitar ter de a pagar."
									}
								],
								[
									{
										"text": "Assim que a sua integração for bem‑sucedida, o banner no topo desta página ficará verde e apresentará as palavras \"Integração concluída\"."
									}
								]
							]
						}
					],
					"jumpseller": [
						{
							"title": "Gerar as suas credenciais de API da Klarna.",
							"step_instructions": [
								[
									{
										"text": "Precisará destas credenciais para integrar a Klarna na sua loja."
									}
								]
							]
						},
						{
							"title": "Adicione Klarna como a sua forma de pagamento.",
							"step_instructions": [
								[
									{
										"text": "No Painel de Administração Jumpseller, navegue para Definições > Pagamentos, encontre \"Klarna\" na lista de verificação e clique em \"Adicionar forma\"."
									}
								]
							]
						},
						{
							"title": "Configure a nossa nova forma de pagamento.",
							"step_instructions": [
								[
									{
										"text": "No painel de configuração da Klarna (painel de administração Jumpseller Admin Panel, navegue para Definições > Pagamentos > Klarna), (i) e adicione as credenciais de API da Klarna geradas no primeiro passo, (ii) selecione os pacotes EMD /que deseja/precisa de partilhar com a e (iii) selecione se precisa de capturar automaticamente as encomendas (a predefinição é não)."
									}
								]
							]
						}
					],
					"lightspeed": [
						{
							"title": "Integrar Lightspeed eCom",
							"step_instructions": [
								[
									{
										"text": "Veja o guia de integração em"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/eng.pdf",
										"text": "Inglês"
									},
									{
										"text": "e em"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/nl.pdf",
										"text": "Neerlandês"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"shoper": [
						{
							"title": "Integrar Shoper",
							"step_instructions": [
								[
									{
										"text": "Veja o guia de integração em"
									},
									{
										"link": "https://www.shoper.pl/help/artykul/klarna-platnosci-odroczone-konfiguracja",
										"text": "o website Shoper"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"timma": [
						{
							"title": "Integrar Timma",
							"step_instructions": [
								[
									{
										"text": "Veja o guia de integração em"
									},
									{
										"link": "https://help.timma.fi/sv/articles/4990994-betalning-via-klarna",
										"text": "o website Timma"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"smartetailing": [
						{
							"title": "Gerar e guardar as suas credenciais de API da Klarna",
							"step_instructions": [
								[
									{
										"text": "Gere novas credenciais de API e transfira o ficheiro para o seu computador. Abra o ficheiro e mantenha-o aberto, pois precisará destas credenciais de API na próxima secção."
									}
								]
							]
						},
						{
							"title": "Integrar com SmartEtailing",
							"step_instructions": [
								[
									{
										"text": "Siga as instruções no"
									},
									{
										"link": "https://www.smartetailing.com/help/financing-with-klarna",
										"text": "website SmartEtailing."
									}
								]
							]
						}
					],
					"workstand": [
						{
							"title": "Gerar e guardar as suas credenciais de API da Klarna",
							"step_instructions": [
								[
									{
										"text": "Gere novas credenciais de API e transfira o ficheiro para o seu computador. Abra o ficheiro e mantenha-o aberto, pois precisará destas credenciais de API na próxima secção."
									}
								]
							]
						},
						{
							"title": "Integrar com Workstand",
							"step_instructions": [
								[
									{
										"text": "Siga as instruções no"
									},
									{
										"link": "https://www.workstand.com/help/financing-with-klarna",
										"text": "website Workstand."
									}
								]
							]
						}
					],
					"jtl5_kco": [
						{
							"title": "Ler a documentação do nosso plugin",
							"step_instructions": [
								[
									{
										"text": "Ir para a nossa"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "página de documentação"
									}
								]
							]
						},
						{
							"title": "Ativar o módulo da caixa Klarna para JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Certifique-se de que instalou a extensão oficial da Klarna. Se ainda não a tiver,"
									},
									{
										"text": "vá a"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "esta página"
									},
									{
										"text": "para o obter."
									}
								]
							]
						}
					],
					"jtl5_kp": [
						{
							"title": "Ler a documentação do nosso plugin",
							"step_instructions": [
								[
									{
										"text": "Ir para a nossa"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "página de documentação"
									}
								]
							]
						},
						{
							"title": "Ativar o módulo de Pagamentos Klarna para JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Certifique-se de que instalou a extensão oficial da Klarna. Se ainda não a tiver,"
									},
									{
										"text": "vá a"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "esta página"
									},
									{
										"text": "para o obter."
									}
								]
							]
						}
					],
					"no_instructions": [
						{
							"title": "Eis o que precisa de fazer a seguir",
							"step_instructions": [
								[
									{
										"bold": "Gerar as suas credenciais de API da Klarna."
									},
									{
										"text": "Precisa destas credenciais para integrar a Klarna na sua loja."
									}
								],
								[
									{
										"bold": "Adicione as credenciais de API da Klarna no seu sistema de retaguarda para ativar a Klarna."
									},
									{
										"text": "Veja o nosso"
									},
									{
										"link": "https://developers.klarna.com/",
										"text": "Portal de desenvolvedor"
									},
									{
										"text": "para obter mais apoio."
									}
								]
							]
						}
					]
				},
				"stakeholders": {
					"form": {
						"first_name": {
							"label": "Nome próprio",
							"error": "Introduza um nome próprio"
						},
						"last_name": {
							"label": "Apelido",
							"error": "Introduza um apelido"
						},
						"dateOfBirth": {
							"label": {
								"default": "Data de nascimento (DD/MM/AAAA)",
								"without_format": "Data de nascimento",
								"US": "Data de nascimento (MM/DD/AAAA)"
							},
							"error": "Introduza uma data válida",
							"error_too_young": "Precisa de ter, pelo menos, 18 anos para vender com a Klarna"
						},
						"address": {
							"label": "Endereço residencial",
							"error": "Introduza um endereço"
						},
						"city": {
							"label": "Cidade",
							"error": "Introduza uma cidade"
						},
						"country": {
							"label": "País",
							"error": "Selecione um país"
						},
						"postal_code": {
							"label": {
								"default": "Código postal",
								"US": "Código postal"
							},
							"error": {
								"default": "Introduza um código postal válido",
								"US": "Introduza um código postal válido"
							}
						},
						"region": {
							"label": "Estado/região (opcional)",
							"label_summary": "Estado/região"
						},
						"state": {
							"label": "Estado",
							"error": "Introduza um estado"
						},
						"role_question": {
							"OWNER": "Esta pessoa é um proprietário?",
							"BENEFICIAL_OWNER": "Esta pessoa controla mais de 25% das ações ou dos direitos de voto?",
							"ULTIMATE_BENEFICIAL_OWNER": "Esta pessoa detém ou controla mais de 25% das ações ou dos direitos de voto"
						},
						"is_person_pep": [
							{
								"text": "Esta pessoa é uma"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "pessoa politicamente exposta (PPE),"
							},
							{
								"text": ","
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "familiar direto(a)"
							},
							{
								"text": "ou"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "colega de trabalho conhecido"
							},
							{
								"text": "de uma PPE?"
							}
						],
						"pep_relationship": {
							"label": "Relação",
							"error": "Selecione a relação que esta pessoa tem com uma PPE"
						},
						"pep_position": {
							"label": "Posição de PPE",
							"error": "Selecione o cargo que a PPE detém"
						},
						"personal_id_question": "Esta pessoa não tem um número de identificação pessoal",
						"personal_id": {
							"US": {
								"label": "Número da Segurança Social (últimos 4 dígitos)",
								"label_summary": "Número da Segurança Social"
							},
							"US_FULL_SSN": {
								"label": "Número da Segurança Social",
								"label_summary": "Número da Segurança Social"
							},
							"CA": {
								"label": "Número da Segurança Social (SIN) ou Número de Passaporte",
								"label_summary": "Número da Segurança Social (SIN) ou Número de Passaporte"
							},
							"SE": {
								"label": "Número de identificação nacional (PNO)",
								"label_summary": "Número de identificação nacional (PNO)"
							},
							"FI": {
								"label": "Código de Identificação Pessoal (HETU)",
								"label_summary": "Número de identificação nacional (HETU)"
							},
							"NO": {
								"label": "Número de identidade nacional",
								"label_summary": "Número de identidade nacional"
							},
							"DK": {
								"label": "Número de identificação pessoal",
								"label_summary": "Número de identificação pessoal (CPR)"
							},
							"IT": {
								"label": "Código Fiscal",
								"label_summary": "Código fiscal"
							},
							"ES": {
								"label": "Número de identificação pessoal",
								"label_summary": "Número de identificação pessoal (DNI)"
							},
							"PL": {
								"label": "Número de identificação pessoal",
								"label_summary": "Número de identificação pessoal (PESEL)"
							},
							"default": {
								"label": "Número do passaporte",
								"label_summary": "Número do passaporte"
							},
							"value": "Confidencial"
						},
						"registration_number": {
							"label": "Número de identificação da empresa",
							"error": "Introduza o EIN no formato: XX-XXXXXXXXX"
						},
						"company_name": {
							"label": "Nome da loja",
							"error": "Introduza um nome de empresa válido"
						},
						"legal_company_name": {
							"label": "Nome jurídico da empresa",
							"error_label": "Introduza o nome legal da empresa"
						},
						"add_person": "Adicionar pessoa",
						"remove": "Remover",
						"edit": "Editar"
					}
				},
				"steps_headers": {
					"merchant": {
						"merchant_id": "ID do comerciante: {merchantId}"
					}
				},
				"goodie_bags": {
					"marketing_material": {
						"title": "Material de marketing",
						"text": "Agora, você faz parte da família Klarna. Aqui está um pacote de material e mais para começar.",
						"link": "Transferir"
					},
					"invite_more_users": {
						"title": "Convidar mais utilizadores",
						"text": "Convide os seus colaboradores para o portal do comerciante; poderá definir permissões personalizadas para cada um deles!",
						"link": "Convidar utilizadores"
					}
				},
				"terms_and_conditions_confirmation": {
					"title": "Produtos e preços",
					"subtitle": "{country}",
					"pricing": "Preços para {country}",
					"monthly_fee": "taxa mensal",
					"transaction_fee": "taxa de transação",
					"before_link": "Concordo com os",
					"link_text": "termos e condições da Klarna",
					"after_link_one_product": "para este produto",
					"after_link_more_than_one_product": "para estes produtos",
					"product_not_available_in_your_country": "* Este produto não está disponível no seu mercado local, mas funcionará noutros países."
				},
				"product_description": {
					"product_attributes": {
						"installed": {
							"text": "Instalado"
						},
						"in_progress": {
							"text": "Em curso"
						}
					}
				},
				"phone_collection_block": {
					"title": "Está a ter problemas com a sua integração da Klarna?",
					"description": "Deixe o seu número abaixo e um dos nossos agentes irá telefonar-lhe para lhe prestar apoio a adicionar a Klarna ao seu comércio eletrónico.",
					"success_banner": "Obrigado! A nossa equipa entrará em contacto consigo assim que possível.",
					"submit": "Enviar",
					"fields": {
						"phone": {
							"label": "Número de telefone",
							"tooltip": "Precisa de incluir o código do país, por ex., +1 541 754 3010",
							"errors": {
								"required": "O número de telefone é obrigatório",
								"invalid": "Número de telefone inválido"
							}
						}
					}
				}
			},
			"containers": {
				"applicant": {
					"title": {
						"unmanaged": "Quem assina os contratos na sua empresa?",
						"managed": "Quem assina os contratos na empresa?",
						"recollection": "Quem está autorizado a assinar em nome da sua empresa?"
					},
					"subtitle": {
						"unmanaged": "A sua empresa está prestes a celebrar um contrato com a Klarna. Precisamos de verificar quem está legalmente autorizado a assinar contratos.",
						"managed": "Forneça as informações sobre todos os signatários autorizados da empresa que entraram no acordo. Somos obrigados por lei a validar a autoridade signatária destes representantes. Se ninguém da lista assinou o acordo, clique em “Adicionar pessoa” e forneça as informações necessárias.",
						"recollection": "Como a sua empresa tem um acordo ativo com a Klarna, somos obrigados por lei a recolher e verificar as informações sobre todos os seus representantes legais."
					},
					"form_title": "Introduza as informações",
					"robot_message": {
						"unmanaged": "São normalmente os diretores do conselho de administração ou executivos, tais como CEO, CFO ou COO. Introduzir duas ou mais pessoas pode ajudar a acelerar a aprovação do contrato.",
						"managed": "São normalmente os diretores do conselho de administração ou executivos, tais como CEO, CFO ou COO. Introduzir duas ou mais pessoas pode ajudar a acelerar a aprovação do contrato."
					},
					"error_tooltip": {
						"too_young": " Esta pessoa não pode enviar o pedido, porque tem menos de {minAge} anos."
					},
					"alert_all_too_young": "Todas as pessoas que celebram o contrato têm de ter mais de {minAge} anos. Para continuar, adicione e selecione um(a) candidato(a) que tenha mais de {minAge} anos.",
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar",
						"add_person": "+ Adicionar pessoa"
					},
					"role": {
						"recollection": "Representante legal"
					}
				},
				"application_summary": {
					"title": "Reveja e envie a sua candidatura.",
					"subtitle": {
						"unmanaged": "Veja os seus dados antes de os enviar.",
						"managed": "Veja os dados antes de os enviar."
					},
					"stakeholders": {
						"title": "Gestão da empresa",
						"subtitle": "Parte interessada {index}"
					},
					"businessDetailsCard": {
						"title": "Dados comerciais"
					},
					"businessDetailsCardFields": {
						"companyName": "Nome da empresa",
						"organizationEntityType": "Classificação fiscal",
						"organizationRegistrationAuthority": "Tribunal de registo",
						"goodsCategory": "Categoria de mercadorias",
						"registrationId": {
							"default": "Número de registo",
							"AT": "Número de registo",
							"AU": "ACN",
							"CA": "Número da empresa",
							"ES": "NIF/NIE/DNI da empresa",
							"GB": "Número da organização",
							"GR": "Número G.E.MI. (Γ.Ε.ΜΗ.)",
							"NZ": "Número da empresa",
							"US": "Número de identificação de empregador"
						},
						"registered": {
							"default": "Empresa registada",
							"AU": "A empresa tem um ACN"
						},
						"subjectToVat": {
							"default": "Empresa sujeita a IVA",
							"AU": "Empresa sujeita a ABN"
						},
						"vatId": {
							"default": "Número de IVA",
							"AU": "ABN",
							"NZ": "Número de GST",
							"ES": "NIF/NIE/DNI da empresa"
						},
						"storeName": "Nome da loja",
						"storeName_us": "Nome da marca/DBA",
						"website": "Site",
						"email": "E-mail de apoio ao cliente",
						"entityType": "Tipo de entidade"
					},
					"companyRegistrationAddressCard": {
						"title": "Endereço de registo da empresa"
					},
					"companyAddressCard": {
						"title": "Endereço da empresa"
					},
					"operatingAddressCard": {
						"title": "Endereço operacional da empresa"
					},
					"documentsCard": {
						"title": "Documentos carregados"
					},
					"buttons": {
						"edit": "Editar",
						"back": "Voltar",
						"submit": "Enviar"
					},
					"noTermsAccepted": "Leia e aceite os Termos e Condições",
					"noTermsAcceptedWithPricingAnnex": "Leia e aceite o Contrato do comerciante e os Termos de Preços"
				},
				"artificial_ultimate_beneficial_owner": {
					"title": {
						"default": "Quem gere a empresa?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Somos obrigados por lei pela diretiva antilavagem de dinheiro da UE ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") a recolher estas informações."
							}
						],
						"US": [
							{
								"text": "Como instituição financeira, somos obrigados por lei a recolher estas informações."
							}
						],
						"CA": [
							{
								"text": "Como instituição financeira, somos obrigados por lei a recolher estas informações."
							}
						],
						"AU": [
							{
								"text": "Como instituição financeira, somos obrigados por lei a recolher estas informações."
							}
						]
					},
					"infobox": {
						"default": "Introduza as informações pessoais e o endereço residencial do CEO da empresa.",
						"US": "Introduza as informações pessoais e o endereço residencial do proprietário maioritário ou de um gestor de alto nível, tal como o CEO, CFO ou COO.",
						"CA": "Introduza as informações pessoais e o endereço residencial do proprietário maioritário ou de um gestor de alto nível, tal como o CEO, CFO ou COO."
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					}
				},
				"managed_artificial_ultimate_beneficial_owner": {
					"title": "Esta empresa é uma empresa pública ou é propriedade exclusiva de uma empresa pública?",
					"title_stakeholder": "Quem gere a empresa?",
					"subtitle": "Como instituição financeira, somos obrigados por lei a recolher estas informações.",
					"subtitle_stakeholder": "Introduza as informações pessoais e o endereço residencial do CEO da empresa.",
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					}
				},
				"bank_account": {
					"title": {
						"default": "Quais são os dados da sua conta bancária?"
					},
					"subtitle": {
						"US": "As transações com a Klarna serão transferidas para esta conta bancária.",
						"default": "Utilizaremos os dados desta conta bancária para transferir os pagamentos das suas vendas."
					},
					"no_more_bank_accounts": "Já adicionou contas bancárias para todas as moedas suportadas. Bom trabalho!",
					"robot_message_general": "A conta bancária predefinida tem de ser num banco no país onde a empresa está registada. Também terá de adicionar uma conta bancária para cada moeda que tenciona aceitar.",
					"robot_message": "O IBAN é o número de conta bancária internacional (do inglês, “International Bank Account Number”) e é fornecido pelo seu banco para a sua conta. Ex.: GB98 MIDL 0700 9312 3456 78",
					"robot_message_account_number": {
						"AU": "O número de conta é fornecido pelo seu banco e tem entre 6 e 10 dígitos. Ex.: 12345678",
						"US": "O número de conta é fornecido pelo seu banco e tem entre 6 e 17 dígitos. Ex.: 12345678",
						"GB": "O Número da Conta é fornecido pelo seu banco e tem 8 dígitos. Por ex.: 12345678. Alguns bancos no Reino Unido têm números de conta mais curtos (por ex., 7 dígitos). Neste caso, serão adicionados zeros no início do seu número para o comprimento ser 8."
					},
					"robot_message_revolut": "O IBAN que forneceu não pode receber pagamentos nacionais em GBP. Terá de entrar em contacto com o seu banco e pedir os dados da conta que suportam transferências nacionais em GBP.",
					"robot_message_local": "O IBAN que forneceu é um IBAN local para o seu banco, que não é suportado por nós. Precisará de entrar em contacto com o seu banco e pedir o seu IBAN pessoal ou utilizar uma conta diferente para se ligar à Klarna.",
					"buttons": {
						"add_bank_account": "+ Adicionar conta bancária",
						"skip": "Ignorar (por agora)",
						"remove": "Remover",
						"submit": "Enviar",
						"next": "Seguinte",
						"back": "Voltar"
					},
					"fields": {
						"currency_code": {
							"label": "Moeda",
							"disable_reason": {
								"account_in_merchant_currency_required": "A moeda predefinida é {currency} por causa do país onde a sua empresa está registada."
							},
							"errors": {
								"general": "Selecione uma moeda"
							}
						},
						"country_of_bankaccount": {
							"label": "País",
							"errors": {
								"general": "Selecione um país"
							}
						},
						"iban_account_number": {
							"label": "Número da Conta (IBAN)",
							"errors": {
								"general": "Introduza um número de conta bancária (IBAN)"
							}
						},
						"use_as_default_bank_account": {
							"label": "Utilize esta conta para moedas não especificadas",
							"tooltip": "Encomendas com moedas não indicadas nesta página serão pagas nesta conta. O seu banco pode cobrar uma taxa adicional para algumas moedas."
						},
						"local_account_number": {
							"label": {
								"default": "Número de conta",
								"MX": "Número de CLABE"
							},
							"errors": {
								"general": {
									"default": "Introduza um número de conta bancária",
									"MX": "Introduza um número de CLABE válido"
								}
							}
						},
						"account_holder": {
							"label": "Nome do titular da conta",
							"errors": {
								"general": "Introduza o nome do titular da conta (máximo 70 caracteres)."
							}
						},
						"transit_number": {
							"label": "Número de trânsito",
							"errors": {
								"general": "Introduza um número de trânsito válido"
							}
						},
						"institution_number": {
							"label": "Número de instituição",
							"errors": {
								"general": "Introduza um número de instituição válido"
							}
						},
						"bic": {
							"label": {
								"AU": "BSB"
							},
							"errors": {
								"general": {
									"AU": "Introduza uma BSB (filial de banco do estado) válida"
								}
							},
							"tooltip": {
								"AU": "O código BSB deve ter 6 caracteres numéricos divididos por um -. Por exemplo, 123-456"
							}
						},
						"routing_number": {
							"label": {
								"default": "Número de encaminhamento",
								"GB": "Código de ordenação"
							},
							"errors": {
								"general": {
									"default": "Introduza um número de encaminhamento válido",
									"GB": "Introduza um código de ordenação válido"
								}
							}
						}
					}
				},
				"control_over_management": {
					"title": {
						"default": "Quem gere a empresa?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Somos obrigados por lei pela diretiva antilavagem de dinheiro da UE ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") a recolher estas informações."
							}
						],
						"GB": [
							{
								"text": "Somos obrigados por lei a recolher estas informações. Certifique-se de que o seu registo na Companies House está atualizado."
							}
						]
					},
					"infobox": "Introduza as informações pessoais e o endereço residencial de pessoas que exercem controlo sobre a gestão da sua empresa, tais como o diretor executivo ou os membros da administração.",
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar",
						"add_person": "+ Adicionar pessoa"
					},
					"messages": {
						"lookup": "Estas pessoas gerem a sua empresa? Veja e confirme se está correto."
					}
				},
				"de_registration_information": {
					"title": {
						"unmanaged": "A sua empresa está registada?",
						"managed": "Esta empresa está registada?"
					},
					"subtitle": {
						"unmanaged": "Precisamos do número de registo da sua empresa para verificar os dados do seu negócio.",
						"managed": "Precisamos do número de registo da empresa para verificar os dados do negócio."
					},
					"question": {
						"title": {
							"unmanaged": "Introduza o seu número de registo e o tribunal de registo",
							"managed": "Introduza o número de registo e o tribunal de registo"
						}
					},
					"fields": {
						"registration_number": {
							"label": "Número de registo"
						},
						"registration_court": {
							"label": "Tribunal de registo",
							"errors": {
								"general": {
									"unmanaged": "Selecione o seu tribunal de registo",
									"managed": "Selecione o tribunal de registo"
								}
							}
						}
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					}
				},
				"documents": {
					"title": "Carregar os seus documentos",
					"subtitle": "Precisamos que nos envie alguns elementos de documentação adicional necessários para validarmos a sua identidade. Carregue apenas ficheiros <strong>JPG</strong>, <strong>PNG</strong> ou <strong>PDF</strong> (o tamanho máximo do ficheiro é 10 MB).",
					"subheadline": {
						"default": "Como a Klarna é um banco com sede na Suécia e, portanto sob os regulamentos de controlo da Autoridade Sueca de Supervisão Financeira, tem de estar em conformidade com a diretiva UE 2015/849. A Klarna precisa de recolher informações sobre as pessoas que controlam a empresa, para que você possa começar a utilizar os serviços da Klarna. Carregue apenas ficheiros <strong>JPG, PNG ou PDF</strong> (o tamanho máximo do ficheiro é 10 MB).",
						"US": "Como a Klarna é um banco com sede na Suécia e, portanto, sob os regulamentos de controlo da Autoridade Sueca de Supervisão Financeira, tem de estar em conformidade com a diretiva UE 2015/849. A Klarna precisa de recolher informações sobre as pessoas que controlam a empresa, para que possa começar a utilizar os serviços da Klarna. Forneça a seguinte documentação para validarmos a sua identidade. Carregue apenas ficheiros JPG, PNG ou PDF (o tamanho máximo do ficheiro é de 10 MB).",
						"IT": "Como a Klarna é um banco com sede na Suécia e, portanto, sob os regulamentos de controlo da Autoridade Sueca de Supervisão Financeira, tem de estar em conformidade com a diretiva UE 2015/849. A Klarna precisa de recolher informações sobre as pessoas que controlam a empresa, para que possa começar a utilizar os serviços da Klarna. Observe que, para prosseguir com a candidatura, a sua empresa precisa de estar registada na Câmara de Comércio. Carregue apenas ficheiros JPG, PNG ou PDF (o tamanho máximo dos ficheiros é de 10 MB)"
					},
					"header_title": "Documentos",
					"stakeholder": "Parte interessada",
					"business_documents": "Documentos da empresa",
					"browse_files": "Carregar ficheiros",
					"optional": "(opcional)",
					"upload_area": {
						"title": {
							"before_link": "Largar os seus ficheiros aqui",
							"link_text": "Selecionar ficheiros"
						},
						"description": "{acceptedFileFormats} - Máximo {maxFileSizeMB} MB/ficheiro"
					},
					"description": {
						"APPROVAL": "Carregar <strong>aprovação</strong>",
						"CONTRACT": "Carregar <strong>contrato</strong>",
						"CORRECTION_NOTE": "Carregar <strong>nota de correção</strong>",
						"COUNTERSIGNED_CONTRACT": "Carregar <strong>contrato assinado</strong>",
						"ID_DOCUMENT": "Carregar <strong>ID</strong> ou <strong>passaporte</strong>",
						"LICENSE": "Carregar <strong>licença</strong>",
						"PROOF_OF_ADDRESS": "Carregar <strong>comprovativo de morada</strong>",
						"SPECIAL_AGREEMENT": "Carregar <strong>acordo especial</strong>",
						"SUPPORTING_DOCUMENT": "Carregar <strong>documento de suporte</strong>",
						"TAX_OFFICE_REGISTRATION": "Carregar <strong>registo fiscal</strong>"
					},
					"explanation": {
						"APPROVAL": {
							"title": {
								"default": "Aprovação"
							},
							"subtitle": {
								"default": null
							}
						},
						"CONTRACT": {
							"title": {
								"default": "Contrato"
							},
							"subtitle": {
								"default": null
							}
						},
						"CORRECTION_NOTE": {
							"title": {
								"default": "Nota de correção"
							},
							"subtitle": {
								"default": null
							}
						},
						"COUNTERSIGNED_CONTRACT": {
							"title": {
								"default": "Contrato assinado"
							},
							"subtitle": {
								"default": null
							}
						},
						"ID_DOCUMENT": {
							"title": {
								"default": "Comprovativo de identidade",
								"IT": "Cartão de identidade"
							},
							"subtitle": {
								"default": "Forneça ambos os lados do cartão de identificação.",
								"AT": "Forneça-nos ambos os lados do seu cartão de identidade. Se o seu endereço não constar do seu documento de identidade, precisaremos de documentação adicional, como uma conta de serviços públicos, para verificar o seu endereço.",
								"AU": "Para uma avaliação mais rápida da sua candidatura, forneça uma cópia válida de um documento de identidade com foto, como passaporte ou carta de condução portuguesa, para os seguintes indivíduos associados à empresa: Empresário individual/Parceria – o(s) proprietário(s). Empresa – o representante legal, todos os administradores e qualquer acionista que detenha mais de 25% das ações.",
								"BE": "Forneça ambos os lados do cartão de identidade, certifique-se de que a qualidade da imagem é suficiente e que todas as informações estão claramente legíveis.",
								"DE": "Forneça-nos ambos os lados do seu cartão de identidade. Se o seu endereço não constar do seu documento de identidade, precisaremos de documentação adicional, como uma conta de serviços públicos, para verificar o seu endereço.",
								"FR": "Forneça ambos os lados do cartão de identidade, certifique-se de que a qualidade da imagem é suficiente e que todas as informações estão claramente legíveis.",
								"GB": "Forneça ID; se for um cartão de identidade, ambos os lados.",
								"IT": "Um cartão de identidade válido, frente/verso, para cada uma das pessoas indicadas na candidatura. Carta de condução, passaporte, cartão/número da segurança social não são aceites.",
								"NL": "Forneça ambos os lados do cartão de identidade, certifique-se de que a qualidade da imagem é suficiente e que todas as informações estão claramente legíveis.",
								"US": "Carta de condução ou passaporte – Forneça ambos os lados do cartão de identidade."
							}
						},
						"LICENSE": {
							"title": {
								"default": "Licença"
							},
							"subtitle": {
								"default": null
							}
						},
						"PROOF_OF_ADDRESS": {
							"title": {
								"default": "Comprovativo de Morada",
								"BE": "Comprovativo de Morada",
								"CZ": "Comprovativo de Morada",
								"ES": "Comprovativo de Morada",
								"FI": "Comprovativo de Morada",
								"FR": "Comprovativo de Morada",
								"GR": "Comprovativo de Morada",
								"IT": "Comprovativo de Morada",
								"NL": "Comprovativo de Morada",
								"PL": "Comprovativo de Morada",
								"PT": "Comprovativo de Morada"
							},
							"subtitle": {
								"default": "Estamos a aceitar os seguintes documentos como comprovativo de morada (desde que não tenham mais de 3 meses): eletricidade, água, gás, contas de Wi-Fi declaração de impostos, contrato de locação ou Comprovativo de morada gerado pela Autoridade Tributária e Aduaneira. Caso não tenha nenhum dos documentos, carregue qualquer outro comprovativo de morada e adicione uma nota com o motivo.",
								"AU": "Para uma avaliação mais rápida da sua candidatura, forneça um dos seguintes documentos dos últimos 90 dias, para verificar o endereço residencial: Conta de serviços públicos, conta de internet, declaração de impostos ou contrato de arrendamento/aluguer. *Se estiver a fornecer um passaporte como forma de identificação, ou se o seu endereço atual não corresponder ao endereço do documento de identificação fornecido, este passo é obrigatório.",
								"BE": "Aceitamos os seguintes documentos, que não tenham mais de 3 meses, como comprovativo de endereço residencial: Contrato de eletricidade, água, gás, declaração fiscal ou contrato de arrendamento. Caso não possua nenhum destes documentos, carregue qualquer outro comprovativo de residência e acrescente uma nota com o motivo.",
								"FR": "Aceitamos os seguintes documentos, que não tenham mais de 3 meses, como comprovativo de endereço residencial: Contrato de eletricidade, água, gás, declaração fiscal ou contrato de arrendamento. Caso não possua nenhum destes documentos, carregue qualquer outro comprovativo de residência e acrescente uma nota com o motivo.",
								"NL": "Aceitamos os seguintes documentos, que não tenham mais de 3 meses, como comprovativo de endereço residencial: Contrato de eletricidade, água, gás, declaração fiscal ou contrato de arrendamento. Caso não possua nenhum destes documentos, carregue qualquer outro comprovativo de residência e acrescente uma nota com o motivo.",
								"US": "Aceitamos contas de serviços públicos (gás, água, internet, telefone, etc.), arrendamento ou hipoteca com comprovativo de endereço – Não deve ter data de há mais de 90 dias a contar da data da candidatura.",
								"IT": "Se o seu cartão de identidade tiver uma morada diferente da sua morada atual, necessitaremos de um documento adicional para verificar a sua residência atual. Aceitamos os seguintes documentos, com menos de 3 meses, como prova do endereço de residência das pessoas listadas na candidatura:"
							},
							"list": {
								"IT": [
									{
										"text": "Certificado de residência emitido online (via SPID) ou pelo Município da sua residência"
									},
									{
										"text": "Contas de eletricidade/água/gás/Internet"
									},
									{
										"text": "contrato de arrendamento"
									}
								]
							}
						},
						"SPECIAL_AGREEMENT": {
							"title": {
								"default": "Acordo especial"
							},
							"subtitle": {
								"default": null
							}
						},
						"SUPPORTING_DOCUMENT": {
							"title": {
								"default": "Documento de suporte",
								"GB": "Autorretrato"
							},
							"subtitle": {
								"default": null,
								"AU": "Se vende itens de marca de alto valor, forneça de 2 a 3 faturas de fornecedor para esses produtos aqui. Certifique-se de que a fatura inclui os produtos adquiridos, o nome do fornecedor, o nome do destinatário e o endereço de entrega.",
								"GB": "Forneça uma foto de autorretrato a segurar a ID."
							}
						},
						"TAX_OFFICE_REGISTRATION": {
							"title": {
								"default": "Documento de registo fiscal",
								"AT": "Documento de registo na autoridade fiscal",
								"AU": "Escritura fiduciária",
								"BE": "Número de IVA ativo para transações internacionais (VIES).",
								"DE": "Documento de registo na autoridade fiscal",
								"FR": "Número de IVA ativo para transações internacionais (VIES).",
								"IT": "Número de IVA ativo para transações internacionais (VIES).",
								"NL": "Número de IVA ativo para transações internacionais (VIES).",
								"NO": "Registo fiscal",
								"US": "Carta EIN"
							},
							"subtitle": {
								"default": null,
								"AT": "Aceitamos os seguintes documentos como documentos comerciais: Excerto do registo comercial/licença de empresário individual",
								"AU": "Se o seu ABN estiver associado a um fundo, forneça uma cópia do documento do fundo, incluindo o programa do fundo. Note que este passo é obrigatório para fundos.",
								"BE": "Verifique se o seu número de IVA está ativo para transações internacionais. Isto é necessário mesmo que negoceie apenas no seu país a nível local, pois a Klarna é uma entidade estrangeira. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Pode contactar os serviços fiscais locais para solicitar uma ativação VIES gratuita do seu número de IVA.",
								"CZ": "Aceitamos os seguintes documentos como documentos comerciais: Certidão de inscrição no Registo Público ou extrato do registo comercial da empresa individual.",
								"DE": "Aceitamos os seguintes documentos como documentos comerciais: Excerto do registo comercial/licença de empresário individual",
								"ES": "Aceitamos os seguintes documentos como documentos comerciais: atos de incorporação para empresas registadas;  para empresários individuais - Certificação da situação no recenseamento / Modelo 036 / Modelo 037",
								"FI": "Aceitamos os seguintes documentos como documentos comerciais: Artigos de registo para empresários individuais - Certificação da situação no recenseamento / Modelo 036 / Modelo 037",
								"FR": "Verifique se o seu número de IVA está ativo para transações internacionais. Isto é necessário mesmo que negoceie apenas no seu país a nível local, pois a Klarna é uma entidade estrangeira. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Pode contactar os serviços fiscais locais para solicitar uma ativação VIES gratuita do seu número de IVA.",
								"GR": "Aceitamos os seguintes documentos como documentos comerciais: Registo na repartição de finanças / Início de atividade / Documento do Registo Comercial emitido pelo Serviço Competente da GEMI (União Central das Câmaras)",
								"IT": "Pode contactar o Internal Revenue Service (Agenzia delle Entrate) para solicitar uma ativação VIES gratuita do seu número de IVA. Isto será necessário mesmo que negoceie apenas em Itália, pois a Klarna é uma entidade estrangeira.",
								"NL": "Verifique se o seu número de IVA está ativo para transações internacionais. Isto é necessário mesmo que negoceie apenas no seu país a nível local, pois a Klarna é uma entidade estrangeira. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Pode contactar os serviços fiscais locais para solicitar uma ativação VIES gratuita do seu número de IVA.",
								"NO": "Aceitamos os seguintes documentos como documentos comerciais: Documentos da empresa",
								"PL": "Aceitamos os seguintes documentos como documentos comerciais: Certificado de inscrição no registo de empresas CEIDG, extrato do National Court Register (KRS)",
								"PT": "Estamos a aceitar os seguintes documentos como documentos comerciais: Certidão Permanente (Obrigatório), Certificado de Incorporação. Para comerciantes independentes, registo de emprego independente (Declaração de Início de Atividade).",
								"US": "Isto é a carta recebida do IRS atribuindo-lhe um EIN (IRS CP575 Carta EIN). Se a sua empresa for uma empresa individual e estiver a registar o seu SSN, forneça uma cópia do seu cartão SSN"
							},
							"link": {
								"BE": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"FR": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"NL": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"GR": "https://www.businessregistry.gr/publicity/index"
							}
						},
						"CERTIFIED_ID": {
							"title": {
								"default": "Documento de identificação certificado"
							},
							"subtitle": {
								"default": "Aceitamos os seguintes documentos: Cartão de identidade, passaporte, carta de condução. Os documentos devem obedecer aos seguintes critérios:"
							},
							"list": [
								{
									"text": "Certificado por um oficial de certificação autorizado (por exemplo, um notário público, comissário de juramentos, advogado, procurador e/ou contabilista certificado)."
								},
								{
									"text": "Assinado e carimbado. O selo deve conter detalhes visíveis e verificáveis do certificador, como nome completo, endereço e, quando aplicável, número de registo."
								},
								{
									"text": "Datado – data de certificação não superior a 6 meses."
								},
								{
									"text": "Atestado como uma cópia fiel de um original, declarando claramente que o documento original foi visto."
								}
							]
						}
					},
					"modal": {
						"title": "Porque precisamos dos seus documentos?",
						"close": "Fechar",
						"content": [
							{
								"title": "Descrição do processo",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Requisitos de ficheiros",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Como digitalizar documentos?",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							}
						]
					},
					"errors": {
						"general": "Falha ao carregar",
						"too_large_file": "O ficheiro é demasiado grande <strong>(máx. {maxFileSizeMB} MB)</strong>",
						"max_num_files_exceeded": "Apenas é permitido que carregue {number} ficheiros.",
						"invalid_file_format": "Formato de ficheiro inválido. Os únicos tipos de ficheiros aceites são {acceptedFileFormats}",
						"duplicate_file_name": "Nome de ficheiro duplicado. Todos os ficheiros carregados têm de ter nomes únicos.",
						"try_again": "Tente novamente ou <u>escolha outro ficheiro</u>"
					},
					"buttons": {
						"modal": "Porque precisamos dos seus documentos?",
						"next": "Seguinte",
						"back": "Voltar",
						"submit": "Enviar documentos"
					}
				},
				"document_upload_success": {
					"title": "Carregamento concluído.",
					"message": "Obrigado! Os documentos foram carregados com sucesso."
				},
				"forced_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Pode introduzir o seu número de registo?",
							"AT": "Pode introduzir o seu número de registo?",
							"CA": "Pode introduzir o seu BN federal?",
							"GR": "Pode introduzir o seu número G.E.MI. (Γ.Ε.ΜΗ.)?",
							"NZ": "Pode introduzir o número da sua empresa?"
						},
						"managed": {
							"default": "Pode introduzir o número de registo da empresa?",
							"AT": "Pode introduzir o número de registo da empresa?",
							"CA": "Pode introduzir o seu BN federal?",
							"GR": "Pode introduzir o número G.E.MI. (Γ.Ε.ΜΗ.) da empresa?",
							"NZ": "Pode introduzir o número comercial da empresa?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Precisamos do número de registo da sua empresa para verificar os dados do seu negócio.",
							"AT": "Precisamos do número de registo da sua empresa para verificar os dados do seu negócio.",
							"CA": "Precisamos do número comercial federal atribuído à sua empresa pela CRA (Agência de Rendimentos do Canadá) para verificar os detalhes da sua empresa.",
							"GR": "Precisamos do seu número G.E.MI. para verificar os dados comerciais.",
							"NZ": "Precisamos do número comercial da sua empresa para verificar os seus dados comerciais."
						},
						"managed": {
							"default": "Precisamos do número de registo da empresa para verificar os dados comerciais.",
							"AT": "Precisamos do número de registo da empresa para verificar os dados comerciais.",
							"CA": "Precisamos do número comercial federal atribuído à sua empresa pela CRA (Agência de Rendimentos do Canadá) para verificar os detalhes da sua empresa.",
							"GR": "Precisamos do número G.E.MI. para verificar os dados comerciais.",
							"NZ": "Precisamos do número comercial da empresa para verificar os dados comerciais."
						}
					},
					"infobox": {
						"unmanaged": {
							"CA": "Tenha em atenção que a Klarna não pode atualmente fornecer os seus serviços de pagamento a empresas unipessoais no Canadá. Se continuar com o seu pedido, o mesmo será rejeitado."
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Número de registo",
								"AT": "Número de registo",
								"CA": "Número da empresa",
								"GR": "Número G.E.MI. (Γ.Ε.ΜΗ.)",
								"NZ": "Número da empresa"
							}
						}
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					}
				},
				"tax_identification_number": {
					"title": {
						"unmanaged": "Qual é a sua classificação fiscal?",
						"managed": "Pode introduzir a classificação fiscal da empresa?"
					},
					"subtitle": {
						"unmanaged": "Iremos pedir-lhe diferentes informações, dependendo da situação legal da empresa.",
						"managed": "Iremos pedir-lhe diferentes informações, dependendo da situação legal da empresa."
					},
					"info": {
						"unmanaged": "Pode encontrar o seu NIE (Número de Identificação de Empregador) em declarações de impostos, relatórios de crédito, documentação da folha de pagamento ou licenças e autorizações",
						"managed": "Pode encontrar o NIE da empresa (Número de Identificação de Empregador) em declarações de impostos, relatórios de crédito, documentação da folha de pagamento ou licenças e autorizações"
					},
					"fields": {
						"registration_number": {
							"label": "Número de identificação de empregador",
							"errors": {
								"general": "Introduza um número de identificação de empregador válido",
								"invalid": "O número de identificação de empregador deve ter 9 dígitos com um \"-\" depois dos primeiros dois. Ex.: 12-3456789"
							}
						},
						"organization_entity": {
							"label": {
								"unmanaged": "Classificação Fiscal Federal",
								"managed": "Tipo de negócio"
							},
							"errors": {
								"is_one_of": "Escolha um dos tipos de negócio indicados"
							}
						}
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					}
				},
				"forced_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Pode introduzir o seu número de IVA?",
							"AU": "Pode introduzir o seu ABN?",
							"ES": "Qual é o seu número de identificação fiscal?",
							"NZ": "Pode introduzir o seu número GST?"
						},
						"managed": {
							"default": "Pode introduzir o número de IVA?",
							"AU": "Pode introduzir o ABN?",
							"ES": "Qual é o seu número de identificação fiscal?",
							"NZ": "Pode introduzir o número GST?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Com o seu número de IVA, podemos verificar mais facilmente os dados da empresa.",
							"AU": "Com o seu ABN, podemos verificar mais facilmente os dados da empresa.",
							"NZ": "Com o seu número de GST, podemos verificar mais facilmente os dados da empresa.",
							"ES": "Com o seu número NIF, NIE ou DNI, podemos verificar mais facilmente os dados da empresa."
						},
						"managed": {
							"default": "Utilizamos o número de IVA para verificar os dados da empresa.",
							"AU": "Utilizamos o ABN para verificar os dados da empresa.",
							"NZ": "Utilizamos o número de GST para verificar os dados da empresa.",
							"ES": "Utilizamos o número NIF, NIE ou DNI para verificar os dados da empresa."
						}
					},
					"fields": {
						"vat_number": {
							"label": {
								"default": "Número de IVA",
								"AU": "ABN",
								"NZ": "Número de GST",
								"ES": "NIF/NIE/DNI"
							}
						}
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					}
				},
				"legal_entity_type": {
					"title": {
						"unmanaged": "Que tipo de negócio tem?",
						"managed": "Que tipo de negócio faz esta empresa?"
					},
					"subtitle": {
						"unmanaged": "Somos obrigados a fazer algumas perguntas específicas com base no seu tipo de negócio.",
						"managed": "Somos obrigados a fazer algumas perguntas específicas com base no tipo de negócio."
					},
					"fields": {
						"legal_entity_type": {
							"label": "Tipo de entidade jurídica",
							"errors": {
								"is_one_of": "Escolha um dos tipos de negócio indicados"
							}
						}
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					}
				},
				"optional_registration_information": {
					"title": {
						"unmanaged": {
							"default": "A sua empresa é uma empresa coletiva (LDA, SA, etc) ou LDA Unipessoal?",
							"AU": "A sua empresa tem um ACN?",
							"ES": "A sua empresa está no Registo Comercial?"
						},
						"managed": {
							"default": "Esta empresa está registada?",
							"AU": "Esta empresa tem um ACN?",
							"ES": "A sua empresa está no Registo Comercial?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Precisamos do número do contribuinte de sua empresa para verificar os dados de seu negócio. Se es Empresário em Nome Individual (ENI) selecione \"Não\".",
							"AT": "Precisamos do número de registo da sua empresa para verificar os dados do seu negócio.",
							"AU": "Se tem um ACN, introduza-o; caso contrário, selecione Não e continue.",
							"ES": "Responda Sim se for um SL, SA, SCP, ...etc. Responda Não se for um(a) autónomo(a), freelancer, ...etc",
							"GB": "Precisamos do número de organização da sua empresa para verificar os seus dados comerciais.",
							"GR": "Precisamos do seu número G.E.MI. para verificar os dados comerciais."
						},
						"managed": {
							"default": "Precisamos do número de registo da empresa para verificar os dados do negócio.",
							"AT": "Precisamos do número de registo da empresa para verificar os dados do negócio.",
							"AU": "Se esta empresa tem um ACN, introduza-o; caso contrário, selecione Não e continue.",
							"ES": "Responda Sim se for um SL, SA, SCP, ...etc. Responda Não se for um(a) autónomo(a), freelancer, ...etc",
							"GB": "Precisamos do número de organização da empresa para verificar os dados comerciais da empresa.",
							"GR": "Precisamos do número G.E.MI. da empresa para verificar os dados comerciais."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Introduza o seu número de registo",
							"AT": "Introduza o seu número de registo",
							"AU": "Introduza o seu ACN",
							"ES": "Introduza o NIF/NIE/DNI da sua empresa",
							"GB": "Introduza o número da sua organização",
							"GR": "Introduza o seu número G.E.MI. (Γ.Ε.ΜΗ.)."
						},
						"managed": {
							"default": "Introduza o número de registo",
							"AT": "Introduza o número de registo",
							"AU": "Introduza o ACN",
							"ES": "Introduza o NIF/NIE/DNI da sua empresa",
							"GB": "Introduza o número da organização",
							"GR": "Introduza o número G.E.MI. (Γ.Ε.ΜΗ.)."
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Número de registo",
								"AT": "Número de registo",
								"AU": "Número de Empresa Australiana (ACN)",
								"ES": "NIF/NIE/DNI da empresa",
								"GB": "Número da organização",
								"GR": "Número G.E.MI. (Γ.Ε.ΜΗ.)"
							},
							"errors": null
						}
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					}
				},
				"mid-selector": {
					"title": "Selecionar uma loja",
					"subtitle": "Este e-mail está associado a várias lojas. Selecione uma loja para continuar.",
					"mid-selector": "ID de comerciante/Nome da loja",
					"buttons": {
						"next": "Continuar"
					}
				},
				"optional_registration_information_widget": {
					"title": {
						"unmanaged": "A sua empresa é uma empresa coletiva (LDA, SA, etc) ou LDA Unipessoal?",
						"managed": "Esta empresa está registada?"
					},
					"subtitle": {
						"unmanaged": {
							"default": "Precisamos do número do contribuinte de sua empresa para verificar os dados de seu negócio. Se es Empresário em Nome Individual (ENI) selecione \"Não\"",
							"AT": "Precisamos do número de registo da sua empresa para verificar os dados do seu negócio."
						},
						"managed": {
							"default": "Precisamos do número de registo da empresa para verificar os dados do negócio.",
							"AT": "Precisamos do número de registo da empresa para verificar os dados do negócio."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Introduza o seu número de registo",
							"AT": "Introduza o seu número de registo"
						},
						"managed": {
							"default": "Introduza o número de registo",
							"AT": "Introduza o número de registo"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Número de registo",
								"AT": "Número de registo"
							}
						}
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					}
				},
				"optional_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "O número de contribuinte está registado para IVA?",
							"ES": "A sua empresa tem um NIF/NIE/DNI?",
							"NZ": "A sua empresa está registada para GST?"
						},
						"managed": {
							"default": "Esta empresa está registada para IVA?",
							"ES": "A sua empresa tem um NIF/NIE/DNI?",
							"NZ": "Esta empresa está registada para GST?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Se tiver um número de IVA, podemos verificar mais facilmente os dados da sua empresa.",
							"ES": "Se a sua empresa tiver um número NIF/NIE/DNI, podemos verificar mais facilmente os dados da sua empresa.",
							"NZ": "Se tiver um número de GST, podemos verificar mais facilmente os dados da sua empresa."
						},
						"managed": {
							"default": "Utilizamos o número de IVA para verificar os dados da empresa.",
							"ES": "Se a sua empresa tiver um número NIF/NIE/DNI, podemos verificar mais facilmente os dados da sua empresa.",
							"NZ": "Utilizamos o número de GST para verificar os dados da empresa."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Introduza o seu número de IVA",
							"ES": "Introduza o NIF/NIE/DNI da sua empresa",
							"NZ": "Introduza o seu número de GST"
						},
						"managed": {
							"default": "Introduza o número de IVA",
							"ES": "Introduza o NIF/NIE/DNI da sua empresa",
							"NZ": "Introduza o seu número de GST"
						}
					},
					"vat_id": {
						"label": {
							"default": "Número de IVA",
							"ES": "NIF/NIE/DNI da empresa",
							"NZ": "Número de GST"
						}
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					}
				},
				"optional_vat_registration_widget": {
					"title": {
						"unmanaged": "O número de contribuinte está registado para IVA?",
						"managed": "Esta empresa está registada para IVA?"
					},
					"subtitle": {
						"unmanaged": "Se tiver um número de IVA, podemos verificar mais facilmente os dados da sua empresa.",
						"managed": "Utilizamos o número de IVA para verificar os dados da empresa."
					},
					"form_title": {
						"unmanaged": "Introduza o seu número de IVA",
						"managed": "Introduza o número de IVA"
					},
					"vat_id": {
						"label": {
							"default": "Número de IVA",
							"NZ": "Número de GST"
						}
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					}
				},
				"partnership_details": {
					"title": {
						"unmanaged": "Qual é o seu endereço comercial?",
						"managed": "Qual é o endereço comercial da sua empresa?"
					},
					"subtitle": {
						"unmanaged": "Precisamos de saber onde a sua empresa está localizada.",
						"managed": "Precisamos de saber onde a empresa está localizada."
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					},
					"fields": {
						"partnership_name": {
							"label": "Nome da parceria",
							"errors": {
								"general": "Introduza um nome de parceria"
							}
						},
						"street": {
							"label": "Endereço",
							"errors": {
								"general": "Introduza um endereço válido"
							}
						},
						"postal_code": {
							"label": "Código postal",
							"errors": {
								"general": "Introduza um código postal válido"
							}
						},
						"city": {
							"label": "Cidade",
							"errors": {
								"general": "Introduza uma cidade válida"
							}
						},
						"country": {
							"label": "País",
							"errors": {
								"general": "Introduza um país válido"
							}
						}
					}
				},
				"partners_and_principals": {
					"title": {
						"default": "Quem é o proprietário da empresa?",
						"GB": "Quem gere a empresa?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Somos obrigados por lei pela diretiva antilavagem de dinheiro da UE ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") a recolher estas informações."
							}
						],
						"AU": [
							{
								"text": "Como instituição financeira, somos obrigados por lei a recolher estas informações."
							}
						]
					},
					"infobox": "Introduza as informações pessoais e o endereço residencial de todos os parceiros e elementos que exercem controlo sobre a gestão da sua empresa.",
					"buttons": {
						"add_person": "+ Adicionar pessoa",
						"next": "Seguinte",
						"back": "Voltar"
					}
				},
				"payouts_summary": {
					"title": "Contas bancárias",
					"default_bank_accounts": {
						"no_elements": "Nenhuma conta bancária predefinida"
					},
					"additional_bank_accounts": {
						"no_elements": "Não indicou quaisquer contas bancárias adicionais"
					}
				},
				"pre_assessment_company_details": {
					"title": "Preencha com mais detalhes sobre a oportunidade.",
					"subtitle": "Forneça-nos uma parte do volume do cartão e os dados da empresa para este comerciante. Indique também se a empresa opera a partir de outro mercado além do país de registo, pois isto é obrigatório para avaliação de risco.",
					"fields": {
						"volume_by_card": {
							"label": "Parte do volume do cartão do volume total (%)",
							"errors": {
								"invalid": "O volume do cartão deve ser um número entre 0 e 100",
								"invalid_hint": "Adicione a parte do volume de transações com cartão do total do volume da Klarna para esta oportunidade. Introduza 0% se a sua oportunidade não tiver quaisquer pagamentos com cartão"
							}
						},
						"average_order_value": {
							"label": "Valor médio por encomenda (em SEK)",
							"tooltip": "Deve ser um valor positivo em SEK",
							"errors": {
								"invalid": "Deve ser um valor positivo em SEK"
							}
						},
						"registration_country": {
							"label": "País de registo",
							"errors": {
								"required": "O país de registo é obrigatório"
							}
						},
						"operating_country": {
							"label": "País de operação",
							"errors": {
								"required": "O país de operação é obrigatório"
							}
						},
						"registration_number": {
							"label": {
								"default": "Número de registo (obrigatório para empresas registadas)",
								"AU": "ACN (obrigatório para empresas registadas)",
								"ES": "NIF/NIE/DNI da empresa (obrigatório para empresas registadas)",
								"GR": "Número da empresa G.E.MI. (Γ.Ε.ΜΗ.) (obrigatório para empresas registadas)",
								"NZ": "Número da empresa (obrigatório para empresas registadas)",
								"US": "TIN/EIN (obrigatório para empresas registadas)"
							}
						},
						"vat_number": {
							"label": "ABN",
							"errors": {
								"required": "Introduza ACN ou ABN",
								"invalid": "O ABN deve ter 11 dígitos"
							}
						},
						"registration_authority": {
							"label": "Autoridade de registo",
							"errors": {
								"required": "Selecione a sua autoridade de registo"
							}
						},
						"company_name": {
							"label": "",
							"errors": {
								"required": ""
							}
						},
						"sales_contact": {
							"label": "E-mail do representante de vendas",
							"errors": {
								"invalid": "Introduza um e-mail válido"
							}
						},
						"store_url": {
							"label": "URL da loja",
							"errors": {
								"required": "O URL da loja é obrigatório",
								"invalid": "Introduza um url de website válido"
							}
						},
						"goods_category": {
							"label": "Principal categoria de mercadorias vendidas",
							"errors": {
								"invalid": "Precisa de selecionar uma das opções"
							}
						},
						"is_managed": {
							"label": "Conseguiu passar a ser um comerciante gerido?"
						}
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					}
				},
				"pre_assessment_products": {
					"title": "Indique todos os produtos",
					"subtitle": "Para avaliação de risco, são obrigatórios todos os produtos por país de venda",
					"select": {
						"label": "Pesquisar produto"
					},
					"selected": {
						"label": "Produtos selecionados:"
					},
					"clear": "Limpar tudo",
					"errors": {
						"invalid": "Deve ser selecionado, pelo menos, um produto por país"
					},
					"channels": {
						"ONLINE": "Online",
						"IN_STORE": "Em loja",
						"TELESALES": "Televendas",
						"SELLER_APP": "Aplicação do vendedor"
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					}
				},
				"wrong_prefill_data": {
					"title": "Data inválida fornecida",
					"subtitle": "Informações pré‑preenchidas inválidas ou incompatíveis fornecidas pela Salesforce.",
					"details": "Detalhes: ",
					"fields": {
						"goodsCategory": "Categoria de mercadorias",
						"paymentInterval": "Intervalo de pagamentos",
						"paymentDelay": "Atraso no pagamento",
						"registrationCountry": "País de registo",
						"storeUrl": "URL da loja",
						"mainSellingCountry": "Principal país de venda",
						"products": "Produtos",
						"products_item": "Produto {index}",
						"products_item_yearlyAcquiredVolume": "Volume de produto {index} adquirido anualmente",
						"products_item_sellingCountry": "País de venda do produto {index}",
						"products_item_productName": "Nome do produto {index}",
						"products_item_channels": "Canais do produto {index}",
						"products_item_channels_item": "Canal do produto {index}"
					},
					"error_types": {
						"fallback": "é inválido",
						"any": {
							"required": "é obrigatório e não foi fornecido nenhum"
						}
					}
				},
				"selling_countries": {
					"title": "Indique todos os países de venda",
					"subtitle": "A lista completa de países é necessária para avaliação de risco",
					"select": {
						"label": "Pesquisar país"
					},
					"selected": {
						"label": "Países selecionados:"
					},
					"fields": {
						"selling_countries": {
							"label": "Selecionar país",
							"errors": {
								"invalid": "Tem de selecionar pelo menos um país"
							}
						}
					},
					"clear": "Limpar tudo",
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					}
				},
				"main_selling_country": {
					"title": "Qual é o principal mercado da Klarna para o comerciante?",
					"subtitle": "Selecione o mercado com o maior volume Klarna esperado",
					"errors": {
						"invalid": "Precisa de selecionar um país"
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					}
				},
				"fca_number": {
					"title": "Introduza o número FCA",
					"subtitle": "Temos a obrigação legal de verificar a licença do corretor de crédito.",
					"fields": {
						"fca_number": {
							"label": "Número FCA",
							"errors": {
								"general": "Introduza um número FCA válido"
							}
						}
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					}
				},
				"sole_trader": {
					"title": "Quem é o proprietário da empresa?",
					"subtitle": {
						"default": [
							{
								"text": "Somos obrigados por lei pela diretiva antilavagem de dinheiro da UE ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") a recolher estas informações."
							}
						]
					},
					"infobox": {
						"unmanaged": "Introduza as suas informações pessoais e endereço residencial.",
						"managed": "Introduza as informações pessoais e o endereço residencial do proprietário."
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					},
					"fields": {
						"are_you_the_sole_trader": {
							"label": "A pessoa a fazer a candidatura é a mesma que o comerciante independente.",
							"error": "Lamentamos, mas só pode prosseguir se, como comerciante independente, estiver a fazer esta candidatura."
						}
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Opera a partir de um endereço diferente?",
								"managed": "Esta empresa opera a partir de um endereço diferente?"
							},
							"subtitle": {
								"unmanaged": "Escolha “Sim” apenas se estiver a operar a sua empresa a partir de outro endereço que não o seu endereço residencial.",
								"managed": "Escolha “Sim” apenas se esta empresa operar o seu negócio a partir de outro endereço que não o endereço residencial do comerciante independente."
							}
						},
						"title": "Introduza o endereço comercial",
						"fields": {
							"street": {
								"label": "Endereço",
								"errors": {
									"general": "Introduza um endereço válido"
								}
							},
							"postal_code": {
								"label": "Código postal",
								"errors": {
									"general": "Introduza um código postal válido"
								}
							},
							"city": {
								"label": "Cidade",
								"errors": {
									"general": "Introduza uma cidade válida"
								}
							},
							"country": {
								"label": "País",
								"errors": {
									"general": "Introduza um país válido"
								}
							}
						}
					}
				},
				"sole_trader_confirmation": {
					"title": "Pode confirmar mais duas coisas?",
					"subtitle": "",
					"fields": {
						"are_you_the_sole_trader": {
							"title": "Você é o comerciante independente",
							"label": "A pessoa a fazer a candidatura é a mesma que o comerciante independente."
						},
						"are_you_the_only_with_financial_control": {
							"title": "Só você tem controlo financeiro",
							"label": "O proprietário é a única pessoa que tem controlo financeiro sobre as contas bancárias da sua empresa"
						}
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					},
					"robot_message": "Lamentamos, mas precisamos de confirmar estas duas coisas"
				},
				"underwriting_info": {
					"title": "Especifique o volume e o atraso do pagamento da oportunidade",
					"subtitle": "Indique o volume geral anual esperado da Klarna para esta oportunidade para todos os mercados e o atraso do pagamento. No caso de o atraso de pagamento diferir conforme o país, utilize o correspondente ao principal país de venda selecionado.",
					"fields": {
						"yearly_acquired_volume": {
							"label": "Volume Anual Total do Mercado (em coroas suecas)",
							"errors": {
								"invalid": "O Volume Anual Total do Mercado deve ser um valor positivo em coroas suecas",
								"too_long": "O Volume Anual Total do Mercado não pode ter mais de 16 dígitos"
							}
						},
						"payment_delay": {
							"label": "Atraso no pagamento",
							"errors": {
								"general": "Introduza um valor de atraso de pagamento",
								"invalid": "O atraso de pagamento deve ser um número entre {min} e {max}"
							}
						},
						"payment_interval": {
							"label": "Intervalo de pagamentos",
							"errors": {
								"invalid": "Precisa de selecionar uma das opções"
							}
						},
						"volume_by_card": {
							"label": "Parte da finalização de compra (%)",
							"errors": {
								"invalid": "A parte da finalização de compra deve ser um número entre 0 e 100",
								"invalid_hint": "Adicione a parte do volume de transações com cartão do total do volume da Klarna para esta oportunidade. Introduza 0% se a sua oportunidade não tiver quaisquer pagamentos com cartão"
							}
						},
						"average_order_value": {
							"label": "Valor médio por encomenda (em SEK)"
						}
					},
					"buttons": {
						"back": "Voltar",
						"next": "Seguinte"
					}
				},
				"store_details": {
					"title": {
						"unmanaged": {
							"default": "Quais são os dados da sua loja?"
						},
						"managed": "Quais são os dados da loja?"
					},
					"subtitle": {
						"unmanaged": {
							"US": "Utilizaremos a informação para configurar a sua conta comercial.",
							"default": "Utilizaremos os dados fornecidos como as suas informações de contacto primárias e para dar uma vista de olhos à sua loja."
						},
						"managed": "Utilizaremos os dados fornecidos como as informações de contacto primárias para os consumidores e para dar uma vista de olhos à loja."
					},
					"fields": {
						"store_name": {
							"label": {
								"CA": "Nome da marca/DBA",
								"MX": "Nome da marca/DBA",
								"US": "Nome da marca/DBA",
								"default": "Nome da loja"
							},
							"errors": {
								"required": "O nome da loja é obrigatório",
								"required_us": "Nome da marca/DBA é obrigatório",
								"invalid": "Introduza um nome de loja com, no mínimo, 2 caracteres",
								"invalid_us": "Introduza um nome de loja/DBA com, no mínimo, 2 caracteres",
								"invalid_characters": "O nome da loja não pode conter os seguintes caracteres: < >",
								"invalid_characters_us": "O nome da marca / DBA não pode conter os seguintes caracteres: < >"
							}
						},
						"website": {
							"label": "Website da loja online",
							"errors": {
								"required": "O website é obrigatório",
								"invalid": "Introduza um url de website válido"
							}
						},
						"goods_category": {
							"label": "Principal categoria de mercadorias vendidas",
							"errors": {
								"required": "A categoria de mercadorias é obrigatória"
							}
						},
						"email": {
							"label": "E-mail de apoio ao cliente",
							"errors": {
								"required": "O e-mail de apoio ao cliente é obrigatório",
								"invalid": "Introduza um e-mail válido"
							}
						}
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Alterar produtos"
					}
				},
				"uk_company_details": {
					"title": {
						"unmanaged": "Qual é o seu endereço comercial registado?",
						"managed": "Qual é o endereço comercial registado da empresa?"
					},
					"subtitle": {
						"unmanaged": "Precisamos de saber em que endereço a sua empresa está registada.",
						"managed": "Precisamos de saber em que endereço a empresa está registada."
					},
					"question": {
						"title": {
							"unmanaged": "Opera a partir de um endereço diferente?",
							"managed": "Esta empresa opera a partir de um endereço diferente?"
						},
						"subtitle": {
							"unmanaged": "Escolha “Sim” apenas se estiver a operar a sua empresa a partir de outro endereço que não o seu endereço comercial registado.",
							"managed": "Escolha “Sim” apenas se esta empresa operar o seu negócio a partir de outro endereço que não o endereço comercial registado."
						}
					},
					"toggle": {
						"title": "Adicione o endereço do principal local de negócio"
					},
					"fields": {
						"company_name": {
							"label": "Nome jurídico da empresa",
							"errors": {
								"general": "Introduza um nome de empresa"
							}
						},
						"street": {
							"label": "Endereço",
							"errors": {
								"general": "Introduza um endereço"
							}
						},
						"postal_code": {
							"label": "Código postal",
							"errors": {
								"general": "Introduza um código postal"
							}
						},
						"city": {
							"label": "Cidade",
							"errors": {
								"general": "Introduza uma cidade"
							}
						},
						"country": {
							"label": "País",
							"errors": {
								"general": "Introduza um país"
							}
						}
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					},
					"messages": {
						"lookup": "Esta é a sua empresa? Veja e confirme se está correto."
					}
				},
				"uk_sole_trader": {
					"title": "Quem é o proprietário desta empresa?",
					"subtitle": {
						"unmanaged": "Está prestes a celebrar um contrato com a Klarna. Precisamos de recolher as suas informações pessoais.",
						"managed": "Somos obrigados a recolher e verificar as informações pessoais do proprietário."
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Opera a partir de um endereço diferente?",
								"managed": "Esta empresa opera a partir de um endereço diferente?"
							},
							"subtitle": {
								"unmanaged": "Escolha “Sim” apenas se estiver a operar a sua empresa a partir de outro endereço que não o seu endereço residencial.",
								"managed": "Escolha “Sim” apenas se esta empresa operar o seu negócio a partir de outro endereço que não o endereço residencial do comerciante independente."
							}
						},
						"title": "Introduza o endereço comercial",
						"fields": {
							"street": {
								"label": "Endereço",
								"errors": {
									"general": "Introduza um endereço válido"
								}
							},
							"postal_code": {
								"label": "Código postal",
								"errors": {
									"general": "Introduza um código postal válido"
								}
							},
							"city": {
								"label": "Cidade",
								"errors": {
									"general": "Introduza uma cidade válida"
								}
							},
							"country": {
								"label": "País",
								"errors": {
									"general": "Introduza um país válido"
								}
							}
						}
					}
				},
				"us_sole_proprietorship": {
					"title": "Quem é o proprietário da empresa?",
					"subtitle": {
						"default": "Como instituição financeira, somos obrigados por lei a recolher estas informações."
					},
					"infobox": {
						"unmanaged": "Introduza as suas informações pessoais e endereço residencial.",
						"managed": "Introduza as informações pessoais e o endereço residencial do proprietário."
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Opera a partir de um endereço diferente?",
								"managed": "Esta empresa opera a partir de um endereço diferente?"
							},
							"subtitle": {
								"unmanaged": "Escolha “Sim” apenas se estiver a operar a sua empresa a partir de outro endereço que não o seu endereço residencial.",
								"managed": "Escolha “Sim” apenas se esta empresa operar o seu negócio a partir de outro endereço que não o endereço residencial do comerciante independente."
							}
						},
						"title": "Introduza o endereço comercial",
						"fields": {
							"street": {
								"label": "Endereço",
								"errors": {
									"general": "Introduza um endereço válido"
								}
							},
							"postal_code": {
								"label": "Código postal",
								"errors": {
									"general": "Introduza um código postal válido"
								}
							},
							"city": {
								"label": "Cidade",
								"errors": {
									"general": "Introduza uma cidade válida"
								}
							},
							"country": {
								"label": "País",
								"errors": {
									"general": "Introduza um país válido"
								}
							},
							"region": {
								"label": "Estado",
								"errors": {
									"general": "Introduza um estado"
								}
							}
						}
					}
				},
				"ultimate_beneficial_owner": {
					"title": {
						"default": "Existem pessoas que detenham mais de 25% da empresa?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Como instituição financeira, somos obrigados por lei a recolher estas informações."
							}
						],
						"default": [
							{
								"text": "Precisamos de saber quem são as pessoas que detêm mais de 25% das ações ou direitos de voto da empresa ou exercem um controlo semelhante. Somos obrigados por lei pela diretiva antilavagem de dinheiro da UE ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") a recolher estas informações."
							}
						]
					},
					"infobox": {
						"default": "Introduza as informações pessoais e o endereço residencial de cada pessoa.",
						"AU": "Introduza as informações pessoais e o endereço residencial de cada pessoa. Estas têm de ser pessoas singulares para empresas com estruturas de propriedade complexas."
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar",
						"add_person": "+ Adicionar pessoa"
					},
					"messages": {
						"lookup": "Estas pessoas detêm mais de 25% da sua empresa? Veja e confirme se está correto."
					}
				},
				"us_company_details": {
					"title": {
						"unmanaged": "Qual é o seu endereço comercial?",
						"managed": "Qual é o endereço comercial registado da empresa?"
					},
					"subtitle": {
						"unmanaged": "É onde a sua empresa está legalmente registada e aparecerá nas suas faturas de cliente Klarna.",
						"managed": "Precisamos de saber em que endereço a empresa está registada."
					},
					"question": {
						"title": {
							"unmanaged": "Opera a partir de um endereço diferente?",
							"managed": "Esta empresa opera a partir de um endereço diferente?"
						},
						"subtitle": {
							"unmanaged": "Escolha “Sim” apenas se estiver a operar a sua empresa a partir de outro endereço que não o seu endereço comercial registado.",
							"managed": "Escolha “Sim” apenas se esta empresa operar o seu negócio a partir de outro endereço que não o endereço comercial registado."
						}
					},
					"toggle": {
						"title": "Adicione o endereço do principal local de negócio"
					},
					"fields": {
						"company_name": {
							"label": "Nome da empresa registado",
							"errors": {
								"general": "Introduza um nome de empresa"
							}
						},
						"street": {
							"label": "Endereço",
							"errors": {
								"general": "Introduza um endereço"
							}
						},
						"postal_code": {
							"label": "Código postal",
							"errors": {
								"general": "Introduza um código postal"
							}
						},
						"city": {
							"label": "Cidade",
							"errors": {
								"general": "Introduza uma cidade"
							}
						},
						"country": {
							"label": "País",
							"errors": {
								"general": "Introduza um país"
							}
						},
						"state_of_incorporation": {
							"label": "Estado de constituição",
							"errors": {
								"general": "Introduza um estado de constituição"
							}
						},
						"state": {
							"label": "Estado",
							"errors": {
								"general": "Introduza um estado"
							}
						},
						"region": {
							"label": "Região",
							"errors": {
								"puerto_rico": "Porto Rico não permitido"
							}
						}
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					}
				},
				"select_products": {
					"title": "Os nossos serviços",
					"title_kco_hidden": "Formas de pagamento que aumentam as vendas.",
					"subtitle": "Escolha os serviços que lhe interessam.",
					"subtitle_kco_hidden": "Desbloqueie o poder de compra do seu cliente. Ofereça mais opções de pagamento, para poderem decidir quando e como pagar.",
					"platform_alert": null,
					"buttons": {
						"next": "Seguinte"
					}
				},
				"signup_products": {
					"title_line_1": "Produtos Klarna para a sua loja.",
					"title_kco_hidden_line_1": "Formas de pagamento que",
					"title_kco_hidden_line_2": "aumentam as vendas.",
					"subtitle": "Oferecer formas de pagamento Klarna leva a um aumento médio de 30% na conversão, de 41% no valor médio de encomendas (AOV) e 36% na frequência de compras.",
					"subtitle_kco_hidden": "Desbloqueie o poder de compra do seu cliente. Ofereça mais opções de pagamento, para poderem decidir quando e como pagar.",
					"info_block": "A apresentar produtos disponíveis para",
					"special_offer": "Oferta especial: {percentageFee}% + {fixedFee} por transação. Válido até {validUntil}.",
					"buttons": {
						"contact_sales": "Contactar as vendas",
						"next": "Criar conta",
						"back": "Voltar"
					}
				},
				"questionnaire": {
					"buttons": {
						"back": "Voltar",
						"next": "Seguinte"
					}
				},
				"business_concepts": {
					"title": "Selecione os conceitos de negócio aplicáveis.",
					"subtitle": "Selecione apenas aqueles que se aplicam. Estes podem ser vários.",
					"errors": {
						"select_at_least_one": "Selecione, pelo menos, um conceito de negócio."
					},
					"buttons": {
						"next": "Seguinte",
						"back": "Voltar"
					}
				},
				"confirm_copy": {
					"title": "Confirmar cópia",
					"disclaimer": "Quaisquer informações existentes sobre a IDC atual serão substituídas por dados de ",
					"merchant_id": "{mid}",
					"buttons": {
						"skipCopy": "Não copiar",
						"confirmCopy": "Copiar dados"
					}
				},
				"pre_assessment_summary": {
					"title": "Resumo",
					"subtitle": "Analise os dados atentamente antes de os enviar para subscrever",
					"banner": {
						"mcc_deal": "Esta é uma oferta MCC; siga a rotina de encaminhamento MCC/ECC"
					},
					"selling_countries": {
						"title": "Selecione o mercado com o maior volume esperado.",
						"main_selling_country": "Principal país de venda"
					},
					"pre_assessment_products": {
						"title": "Produtos"
					},
					"company_details": {
						"title": "Dados da empresa"
					},
					"fca_number": {
						"title": "Número FCA"
					},
					"high_exposure_questionnaires": {
						"title": "Questionários de elevada exposição"
					},
					"mia_questionnaires": {
						"title": "Questionários MIA"
					},
					"buttons": {
						"back": "Voltar",
						"edit": "Editar",
						"submit": "Enviar"
					}
				},
				"pre_assessment_overview": {
					"title": "Visão geral de pré‑avaliação",
					"subtitle_APPROVED": "Encontre as condições aprovadas para esta oportunidade abaixo.",
					"subtitle_REJECTED": "Encontre as condições rejeitadas para esta oportunidade abaixo.",
					"subtitle_UNRESOLVED": "Pode alterar as informações enviadas no caso de identificar quaisquer erros. Isto não ativa um novo caso.",
					"status": {
						"APPROVED": "O caso foi aprovado",
						"REJECTED": "O caso foi rejeitado",
						"UNRESOLVED": "A aguardar decisão de subscrição…",
						"UNRESOLVED_TIMED_OUT": "O caso passará por subscrição manual. Tenha em atenção que isto pode demorar vários dias.",
						"UNRESOLVED_TIMED_OUT_LINK_LABEL": "Ver caso na Interface gráfica do utilizador (GUI) de Análise do Comerciante",
						"STARTED": "O caso é enviado para análise"
					},
					"buttons": {
						"change": "Alterar",
						"new_case": "Novo caso"
					}
				},
				"recollection_introduction": {
					"title": {
						"default": "Olá!"
					},
					"subtitle": {
						"default": [
							{
								"text": "Sendo uma empresa regulamentada sob a supervisão da autoridade sueca de supervisão financeira, a Klarna é obrigada a prevenir a lavagem de dinheiro, conforme definido na diretiva UE 2015/849 (conforme alterada ou substituída). Para si, como comerciante, a diretiva significa que a Klarna irá recolher informações sobre as pessoas que controlam a sua empresa (proprietários beneficiários) antes de poder começar a utilizar os serviços da Klarna. Os comerciantes existentes fornecerão essas informações regularmente, para assegurar que estão atualizadas. Pode encontrar mais informações na diretiva da UE "
							},
							{
								"text": "aqui",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "."
							}
						]
					},
					"buttons": {
						"next": "Seguinte"
					}
				},
				"recollection_confirmation": {
					"title": "Confirmação",
					"subtitle": "Analise os dados atentamente antes de os enviar para subscrever",
					"stakeholder": "Parte interessada {index}",
					"buttons": {
						"back": "Voltar",
						"submit": "Enviar"
					}
				},
				"recollection_overview": {
					"title": "Obrigado!",
					"subtitle": "Aqui está uma visão geral das informações que enviou.",
					"stakeholder": "Parte interessada {index}",
					"notice": "As suas informações foram enviadas com sucesso."
				},
				"volume_separation": {
					"title_line_1": "Qual é o tamanho da sua empresa online?",
					"subtitle": "A Klarna está equipada com as melhores soluções para a sua empresa –independentemente de ser grande ou pequena.",
					"selector_title": "Receita anual",
					"below": "Menos de {threshold}",
					"between": "Entre {belowThreshold} e {aboveThreshold}",
					"over": "Mais de {threshold}",
					"buttons": {
						"back": "Voltar"
					}
				},
				"basic_info": {
					"title_line_1": "Comece o seu negócio",
					"title_line_2": "com a Klarna.",
					"subtitle": "Precisamos de algumas informações básicas para o(a) levar ao sítio certo.",
					"fields": {
						"email": {
							"label": "E-mail da empresa",
							"field_link": "Não é uma empresa?",
							"errors": {
								"required": "O endereço de e-mail é obrigatório",
								"invalid": "Introduza um endereço de e-mail válido"
							}
						},
						"email_confirmation": {
							"label": "Confirmar o e-mail da empresa",
							"tooltip": "O e-mail da empresa será o principal modo de comunicação com a Klarna. Certifique-se de que está correto",
							"errors": {
								"required": "É necessário confirmar o endereço de e-mail",
								"invalid": "Certifique-se de que introduziu o mesmo endereço de e-mail duas vezes"
							}
						},
						"website": {
							"label": "URL de comércio eletrónico",
							"errors": {
								"required": "O URL de comércio eletrónico é obrigatório",
								"invalid": "Introduza um URL válido"
							}
						},
						"country": {
							"label": "País de registo",
							"errors": {
								"general": "Selecione um dos países disponíveis"
							}
						}
					},
					"buttons": {
						"continue": "Continuar"
					}
				},
				"contact_details": {
					"title_line_1": "Vamos conversar por chat.",
					"subtitle": "Preencha este formulário e entraremos em contacto consigo assim que possível, com soluções direcionadas para a sua empresa.",
					"fields": {
						"full_name": {
							"label": "Nome completo",
							"errors": {
								"required": "O nome completo é obrigatório"
							}
						},
						"phone": {
							"label": "Número de telefone",
							"tooltip": "Precisa de incluir o código do país, por ex., +1 541 754 3010",
							"errors": {
								"required": "O número de telefone é obrigatório",
								"invalid": "Número de telefone inválido"
							}
						},
						"tell_us_more": {
							"label": "Conte-nos um pouco mais sobre a sua empresa (opcional)"
						}
					},
					"buttons": {
						"back": "Voltar",
						"submit": "Enviar dados de contacto"
					}
				},
				"contact_received": {
					"title": "Falaremos em breve!",
					"message_1": "A nossa equipa de vendas entrará em contacto consigo assim que possível.",
					"message_2": "A nossa equipa entrará em contacto assim que possível. Também enviámos uma confirmação das informações que enviou para "
				},
				"we_are_sorry": {
					"title": "Sentimos muito, mas neste momento não é possível aceitar a sua candidatura.",
					"message_1_unsupported_country": "A Klarna atualmente não suporta o seu país selecionado:",
					"message_1_sensitive_goods": "A Klarna não suporta as seguintes categorias selecionadas:",
					"message_1_platform": "A Klarna não suporta a plataforma de e-commerce selecionada:",
					"message_2": "Estamos sempre à procura de criar novas parcerias e entraremos em contacto tão logo possamos prosseguir com sua aplicação no futuro.",
					"platform_alert": {
						"jtl4": [
							{
								"text": "Ainda pode utilizar o"
							},
							{
								"text": "plugin",
								"link": "https://www.mollie.com/de/integrations/jtl"
							},
							{
								"text": "do nosso parceiro Mollie."
							}
						]
					}
				},
				"platform": {
					"title_line_1": "Em que plataforma está?",
					"subtitle": "Escolha a sua plataforma de comércio eletrónico e o seu negócio será integrado rapidamente.",
					"custom": "Integração própria construída",
					"other_platform": "Outras soluções de integração",
					"platform_search": {
						"label": "Plataforma de comércio eletrónico",
						"no_match": "Não foram encontradas correspondências para \"{input}\""
					},
					"buttons": {
						"back": "Voltar"
					}
				},
				"partner": {
					"title_line_1": "Com que parceiro de serviços de pagamento gostaria de se integrar?",
					"subtitle": "Escolha o parceiro de serviços de pagamento mais adequado para as suas necessidades."
				},
				"account_creation_loading": {
					"title": "A criar a sua conta…",
					"message": "A configurar o seu ID de empresa…"
				},
				"application_checking": {
					"title": "A verificar a sua candidatura…",
					"message": "A analisar dados da loja"
				},
				"application_review": {
					"title": "Estamos a analisar a sua candidatura.",
					"title_approved": "A sua candidatura foi aprovada!",
					"message": "Este é um processo manual, pelo que os tempos de tratamento podem variar, mas iremos fazê-lo o mais rapidamente possível.",
					"email_info_1": "Enviámos-lhe um e-mail com a linha de assunto “{subject}”.",
					"email_info_2": "Siga os passos para iniciar sessão e seguir o estado da sua candidatura.",
					"email_info_2_approved": "Siga os passos para iniciar sessão e integrar a Klarna na sua loja de comércio eletrónico.",
					"email_subject": "Bem-vindo(a) ao portal do comerciante da Klarna",
					"resend_email": "Reenviar e-mail"
				},
				"user_already_exists": {
					"title": "Inicie sessão no Portal do comerciante para continuar.",
					"message_1": "Este endereço de e-mail já está associado a uma conta do Portal do comerciante. Para fazer alterações a uma conta existente, inicie sessão",
					"log_in": "Inicie sessão no Portal do comerciante",
					"forgot_password": "Esqueceu-se da sua palavra-passe?"
				},
				"otherPlatform": {
					"info": "Já temos integração para {platform}",
					"link": "Começar a integração aqui",
					"title": "Smoooth, pode integrar diretamente!",
					"info2": "Boas notícias! Pode integrar a Klarna no seu comércio eletrónico diretamente a partir de <strong>{platform}</strong>.",
					"link2": "Vá a {platform} + Integração Klarna"
				},
				"noLandingPagePlatform": {
					"text": {
						"one": {
							"default": "Contacte diretamente a nossa equipa de vendas",
							"SE": "Contacte diretamente a nossa equipa de vendas em"
						}
					}
				},
				"sensitive_goods": {
					"title_2": "Oferece algum dos seguintes produtos ou serviços?",
					"subtitle_2": "A Klarna pode definir alguns itens como restritos com base no mercado, em leis, volume de vendas, apetência pelo risco e outras limitações que podem ser permitidas e não podem ser processadas sem a aprovação da Klarna.",
					"titleV2": "Escolha qual dos abaixo se aplica à sua empresa.",
					"goodsCategories": {
						"CBD_HEMP_TOBACCO_ECIGARETTES_VAPE": {
							"title_2": "Produtos com restrições de idade",
							"description_2": "Tabaco, cigarros eletrónicos, vaporizadores, produtos de canábis, álcool, conteúdo adulto"
						},
						"EVENTS_TICKETS_TOURISM_TRAVEL_VOUCHERS": {
							"title_2": "Viagens, visitas e eventos",
							"description_2": "Transportes, eventos, plataforma de bilhetes, hotéis ou alojamento, rendas, agências turísticas"
						},
						"WEAPONS_AMMUNITION": {
							"title_2": "Armas licenciadas",
							"description_2": "Munições, facas de combate, equipamento de caça, bastões, spray de gás pimenta"
						},
						"MARKETPLACE": {
							"title_2": "Mercado com vendas diretas",
							"description_2": "Serviços que permitem a terceiros vender as suas mercadorias ou oferecer serviços através da sua plataforma online"
						},
						"PHARMACEUTICALS": {
							"title_2": "Serviços médicos e farmacêuticos",
							"description_2": "Distribuição de de medicamentos com prescrição, procedimentos médicos incluindo estéticos e tatuagens"
						},
						"SERVICES_SUBSCRIPTIONS_MEMBERSHIPS_RENTALS_CONTENT": {
							"title_2": "Adesões, subscrições e serviços",
							"description_2": "Subscrição de mercadorias físicas, conteúdos digitais, serviços de transmissão, sites de encontros, etc."
						},
						"NONE": {
							"title_2": "Ofereço um tipo de produto/serviço diferente"
						}
					},
					"link": "Mais sobre itens restritos",
					"buttons": {
						"next": "Seguinte",
						"continue": "Continuar"
					}
				}
			},
			"address_form_component": {
				"postal_code": {
					"tooltip": {
						"default": "Introduza o seu código postal para preencher automaticamente outras partes do seu endereço",
						"US": "Introduza o seu código postal para preencher automaticamente outras partes do seu endereço"
					},
					"label": {
						"default": "Código postal",
						"US": "Código postal"
					},
					"error": {
						"default": "Introduza um código postal válido",
						"US": "Introduza um código postal válido"
					}
				},
				"city": {
					"label": "Cidade",
					"error": "Introduza uma cidade"
				},
				"street": {
					"label": "Endereço",
					"error": "Introduza um endereço",
					"tooltip": "Comece a escrever para ver mais sugestões de rua",
					"no_suggestion_found": "Sem correspondências para {input}"
				},
				"country": {
					"label": "País",
					"error": "Selecione um país"
				},
				"region": {
					"label": "Estado/região (opcional)"
				},
				"state": {
					"label": "Estado",
					"error": "Introduza um estado"
				}
			},
			"platforms": {
				"custom": "Integração API",
				"other": "Não consigo encontrar a minha plataforma"
			},
			"buttons": {
				"back": "Voltar"
			},
			"products": {
				"not_available": "Não disponível em {reason}",
				"not_available_country": "Não disponível no seu país",
				"not_available_platform": "Não disponível em {plataforma}",
				"why_product": "Porquê a Klarna {name}",
				"kco_one": {
					"name": {
						"default": "Finalização de compra"
					},
					"description": {
						"default": "Substituir a sua finalização de compra da loja pelos serviços completos de finalização de compra da Klarna."
					},
					"description_expanded": {
						"default": "Substituir a sua finalização de compra da loja pelos serviços completos de finalização de compra da Klarna."
					},
					"options": {
						"kco_one-pay-now": {
							"name": {
								"default": "Pagar agora"
							},
							"description": {
								"default": "Oferecer pagamentos instantâneos por cartão ou transferência bancária."
							}
						},
						"kco_one-pay-later": {
							"name": {
								"default": "Pagar em 30 dias"
							},
							"description": {
								"default": "Oferecer 30 dias para pagar. Sem juros."
							}
						},
						"kco_one-slice-it": {
							"name": {
								"default": "Financiamento"
							},
							"description": {
								"default": "Oferecer para pagar ao longo de 6 a 36 meses.",
								"DE": "Oferecer para pagar ao longo de 6 a 24 meses",
								"AT": "Oferecer para pagar ao longo de 6 a 24 meses."
							}
						},
						"kco_one-slice-it-in-3": {
							"name": {
								"default": "Prestações"
							},
							"description": {
								"default": "Oferecer 3 prestações sem juros.",
								"GB": "Oferecer 3 prestações sem juros."
							}
						},
						"kco_one-slice-it-in-4": {
							"name": {
								"default": "Dividir em 4",
								"US": "Prestações",
								"AU": "Pagar em 4 prestações"
							},
							"description": {
								"default": "Oferecer 4 prestações sem juros.",
								"GB": "Oferecer 4 prestações sem juros."
							}
						}
					},
					"features": {
						"other_payment_options": {
							"name": {
								"default": "Outras opções de pagamento"
							},
							"description": {
								"default": "Cartões de débito, cartões de crédito e outros"
							}
						},
						"on_site_messaging": {
							"name": {
								"default": "Mensagem no local"
							}
						},
						"billing": {
							"name": {
								"default": "Identificação e faturação automáticas"
							}
						},
						"shipping": {
							"name": {
								"default": "Opções de envio personalizadas"
							}
						},
						"post_purchase": {
							"name": {
								"default": "Apoio após a compra"
							}
						}
					}
				},
				"kp_one": {
					"name": {
						"default": "Forma de pagamento"
					},
					"description": {
						"default": "Adicione formas de pagamento Klarna à sua finalização de compra existente."
					},
					"description_expanded": {
						"default": "Oferecer formas de pagamento Klarna leva a um aumento médio de 30% na conversão, de 41% no valor médio de encomendas (AOV) e 36% na frequência de compras."
					},
					"options": {
						"kp_one-pay-now": {
							"name": {
								"default": "Pagar agora"
							},
							"description": {
								"default": "Oferecer pagamentos instantâneos por cartão ou transferência bancária."
							}
						},
						"kp_one-pay-later": {
							"name": {
								"default": "Pague a 30 dias"
							},
							"description": {
								"default": "Os clientes pagam 30 dias após a compra, sem juros."
							}
						},
						"kp_one-slice-it": {
							"name": {
								"default": "Financiamento"
							},
							"description": {
								"default": "Os clientes podem pagar em 6-36 meses.",
								"DE": "Os clientes podem pagar em 6-24 meses",
								"AT": "Os clientes podem pagar em 6-24 meses."
							}
						},
						"kp_one-slice-it-in-3": {
							"name": {
								"default": "Prestações"
							},
							"description": {
								"default": "Oferecer 3 prestações sem juros.",
								"GB": "Oferecer 3 prestações sem juros."
							}
						},
						"kp_one-slice-it-in-4": {
							"name": {
								"default": "Dividir em 4",
								"US": "4 pagamentos",
								"CA": "4 pagamentos",
								"AU": "Pagar em 4 prestações"
							},
							"description": {
								"default": "Oferecer 4 prestações sem juros.",
								"GB": "Oferecer 4 prestações sem juros.",
								"US": "Encomendas entre 35 USD e 1000 USD podem ser divididas em 4 pagamentos sem juros, a serem feitos a cada 2 semanas.",
								"CA": "Encomendas entre 35 USD e 1000 USD podem ser divididas em 4 pagamentos sem juros, a serem feitos a cada 2 semanas."
							}
						},
						"kp_one-pay-by-card": {
							"name": {
								"default": "Pagar com cartão"
							},
							"description": {
								"default": "Oferecer pagamentos instantâneos por cartão ou transferência bancária."
							}
						}
					}
				}
			}
		},
		"fields": {
			"enm": {
				"product_channel": {
					"label": "Como planeia fazer as suas vendas?",
					"options": {
						"IN_STORE": "Loja física",
						"TELESALES": "Vendas remotas"
					},
					"description": {
						"IN_STORE": "As vendas são principalmente feitas em pessoa e o cliente recebe os itens imediatamente. ",
						"TELESALES": "As vendas são principalmente feitas por telefone a parte de chamadas feitas por clientes. O cliente não recebe os itens imediatamente."
					}
				},
				"country": {
					"label": "País"
				},
				"organization_category": {
					"label": "Tipo de entidade jurídica",
					"options": {
						"SOLE_TRADER": "Comerciante independente",
						"PARTNERSHIP": "Parceria",
						"UNDEFINED": "INDEFINIDO",
						"BV": "BV",
						"CV": "CV",
						"CVOA": "CVOA",
						"EEN": "EEN",
						"MTS": "MTS",
						"NV": "NV",
						"SE": "SE",
						"VOF": "VOF",
						"C_CORP": "Corporação C",
						"S_CORP": "Corporação S",
						"TRUST_ESTATE": "Fundo/imóveis",
						"INDIVIDUAL": "Individual",
						"SOLE_PROPRIETORSHIP": "Empresa unipessoal",
						"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Sociedade anónima de membro único",
						"LIMITED_LIABILITY_COMPANY": "Sociedade anónima",
						"PUBLIC_LISTED_COMPANY": "Empresa pública cotada na bolsa",
						"PRIVATE_COMPANY": "EMPRESA_PRIVADA"
					}
				},
				"store_category": {
					"label": "Principal categoria de mercadorias vendidas",
					"options": {
						"ADULT_SHOES_AND_CLOTHING": "Roupa e calçado - Roupa e calçado de adultos",
						"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Produtos para automóveis - Peças e acessórios para automóveis",
						"BAGS_AND_WALLETS": "Joias e acessórios - Malas e carteiras",
						"BODY_AND_HAIR_CARE": "Saúde e beleza - Cuidados para corpo e cabelo",
						"BOOK_AND_MAGAZINES": "Entretenimento - Livros e revistas",
						"CANDY": "Alimentos e bebidas - Doces",
						"CAR_ELECTRONICS": "Eletrónica - Eletrónica de carros",
						"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Produtos para crianças - Roupas e produtos de cuidados para crianças",
						"CHILDREN_TOYS": "Produtos para crianças - Brinquedos infantis",
						"CLEANING_AND_SANITARY": "Casa e jardim - Limpeza e higiene",
						"COLLECTIBLES": "Lazer, desporto e hobbies - Colecionáveis",
						"CONCEPT_STORES_AND_MISCELLANEOUS": "Lazer, desporto e hobbies - Lojas de conceito e diversos",
						"COSMETICS": "Saúde e beleza - Cosméticos",
						"COSTUMES_AND_PARTY_SUPPLIES": "Lazer, desporto e hobbies - Roupas de fantasia e produtos para festas",
						"DATING_SERVICES": "Produtos intangíveis - Serviços de encontros",
						"DECORATION_AND_ART": "Casa e jardim - Decoração e arte",
						"DIETARY_SUPPLEMENTS": "Saúde e beleza - Suplementos dietéticos",
						"DIGITAL_SERVICES": "Produtos intangíveis - Serviços digitais",
						"DIVERSIFIED_CHILDREN_PRODUCTS": "Produtos para crianças - Produtos diversos para crianças",
						"DIVERSIFIED_ELECTRONICS": "Eletrónica - Diversos",
						"DIVERSIFIED_ENTERTAINMENT": "Entretenimento - Diversos",
						"DIVERSIFIED_EROTIC_MATERIAL": "Materiais eróticos - Materiais eróticos diversos",
						"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Saúde e beleza - Produtos de saúde e beleza diversos",
						"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Casa e jardim - Produtos diversos para casa e jardim",
						"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Joias e acessórios - Joias e acessórios diversos",
						"EDUCATION": "Produtos intangíveis - Educação",
						"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Eletrónica - Equipamento eletrónico e acessórios relacionados",
						"EROTIC_CLOTHING_AND_ACCESSORIES": "Materiais eróticos - Roupas e acessórios eróticos",
						"EVENT_TICKETS": "Produtos intangíveis - Bilhetes para eventos",
						"FOOD_AND_BEVERAGE": "Alimentos e bebidas - Alimentos e bebidas",
						"FRAGRANCES": "Saúde e beleza - Fragrâncias",
						"FURNITURE": "Casa e jardim - Mobiliário",
						"GENERAL_SHOES_AND_CLOTHING": "Roupa e calçado - Roupa e calçado em geral",
						"HOBBY_ARTICLES": "Lazer, desporto e hobbies - Artigos para hobbies",
						"HOUSEHOLD_ELECTRONICS": "Eletrónica - Eletrónicos domésticos",
						"JEWELRY_AND_WATCHES": "Joias e acessórios - Joias e relógios",
						"KITCHENWARE": "Casa e jardim - Utensílios de cozinha",
						"MARKETPLACES": "Produtos intangíveis - Mercados",
						"MUSIC_AND_MOVIES": "Entretenimento - Música e filmes",
						"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Lazer, desporto e hobbies - Instrumentos musicais e equipamento",
						"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Joias e acessórios - Óculos de sol e lentes sem receita médica",
						"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Eletrónica - Máquinas de escritório e acessórios relacionados",
						"OTHER_SERVICES": "Produtos intangíveis - Outros serviços",
						"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Saúde e beleza - Cuidados pessoais e melhoria do corpo",
						"PET_SUPPLIES": "Casa e jardim - Produtos para animais de estimação",
						"PHARMACEUTICAL_PRODUCTS": "Saúde e beleza - Produtos farmacêuticos",
						"PLANTS_AND_FLOWERS": "Casa e jardim - Plantas e flores",
						"PRESCRIPTION_OPTICS": "Saúde e beleza - Material de ótica com receita médica",
						"PRINTS_AND_PHOTOS": "Lazer, desporto e hobbies - Impressões e fotografias",
						"SAFETY_PRODUCTS": "Casa e jardim - Produtos de segurança",
						"SEX_TOYS": "Materiais eróticos - Brinquedos sexuais",
						"SPORTS_GEAR_AND_OUTDOOR": "Lazer, desporto e hobbies - Equipamento desportivo e de ar livre",
						"TOBACCO": "Alimentos e bebidas - Tabaco",
						"TOOLS_AND_HOME_IMPROVEMENT": "Casa e jardim - Ferramentas e melhorias na casa",
						"TRAVEL_SERVICES": "Produtos intangíveis - Serviços de viagens",
						"UNDERWEAR": "Roupa e calçado - Roupa interior",
						"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Entretenimento - Videojogos e acessórios relacionados",
						"WHEELS_AND_TIRES": "Produtos para automóveis - Rodas e pneus",
						"WINE_BEER_AND_LIQUOR": "Alimentos e bebidas - Vinho, cerveja e licor",
						"YOUTHFUL_SHOES_AND_CLOTHING": "Roupa e calçado - Roupa e calçado de jovens"
					}
				},
				"currency": {
					"label": "Moeda"
				},
				"account_type": {
					"label": "Tipo de conta bancária",
					"options": {
						"IBAN": "IBAN",
						"LOCAL_SE": "Local da Suécia",
						"LOCAL_US": "Local dos EUA",
						"LOCAL_GENERIC": "Local da Noruega/Dinamarca",
						"SPECIAL": "Especial",
						"BANKGIRO": "Bankgiro local da Suécia",
						"PLUSGIRO": "Plusgiro local da Suécia"
					}
				},
				"person_role": {
					"label": "Papel",
					"options": {
						"LEGAL_REPRESENTATIVE": "Representante legal",
						"ALTERNATIVE_BENEFICIAL_OWNER": "Proprietário beneficiário alternativo",
						"ULTIMATE_BENEFICIAL_OWNER": "Proprietário beneficiário final",
						"OWNER": "Proprietário"
					}
				},
				"business_size": {
					"label": "Tamanho da empresa",
					"options": {
						"LARGE": "grande",
						"MEDIUM": "médio",
						"small": "pequeno"
					}
				},
				"sensitive_good_category": {
					"label": "Oferece algum dos seguintes produtos ou serviços na sua loja física?",
					"options": {
						"AGE_RESTRICTED_PRODUCTS": "Produtos com restrições de idade",
						"LICENSED_WEAPONS": "Armas licenciadas",
						"PHARMA_AND_MEDICAL_SERVICES": "Serviços médicos e farmacêuticos",
						"TRAVEL_TOURS_EVENTS": "Viagens, visitas e eventos",
						"PEER_TO_PEER_MARKETPLACE": "Mercado com vendas diretas",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Adesões, subscrições e serviços",
						"NONE": "Ofereço um tipo de produto/serviço diferente"
					},
					"description": {
						"AGE_RESTRICTED_PRODUCTS": "Tabaco, cigarros eletrónicos, vaporizadores, produtos de canábis, álcool, conteúdo adulto",
						"LICENSED_WEAPONS": "Munições, facas de combate, equipamento de caça, bastões, spray de gás pimenta",
						"PHARMA_AND_MEDICAL_SERVICES": "Distribuição de de medicamentos com prescrição, procedimentos médicos incluindo estéticos e tatuagens",
						"TRAVEL_TOURS_EVENTS": "Transportes, eventos, plataforma de bilhetes, hotéis ou alojamento, rendas, agências turísticas",
						"PEER_TO_PEER_MARKETPLACE": "Serviços que permitem a terceiros vender as suas mercadorias ou oferecer serviços através da sua plataforma online",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Subscrição de mercadorias físicas, conteúdos digitais, serviços de transmissão, sites de encontros, etc.",
						"NONE": "Ofereço um tipo de produto/serviço diferente"
					},
					"error_message": "Lamentamos. Não podemos continuar com a sua candidatura, porque atualmente não suportamos o tipo de produto ou serviços que selecionou."
				}
			},
			"common": {
				"country": {
					"label": "País"
				},
				"address": {
					"city": {
						"label": "Cidade"
					},
					"postal_code": {
						"label": "Código postal"
					},
					"region": {
						"label": "Estado/região"
					},
					"street_address": {
						"label": "Endereço da loja física"
					},
					"street_address2": {
						"label": "Linha de endereço 2"
					}
				}
			},
			"payload": {
				"business_information": {
					"company_name": {
						"label": "Nome da empresa"
					},
					"registration_authority": {
						"label": "Autoridade de registo"
					},
					"registration_id": {
						"label": "Número de registo"
					},
					"subject_to_vat": {
						"label": "O número de contribuinte está registado para IVA?"
					},
					"vat_id": {
						"label": "Número de IVA"
					},
					"persons": {
						"date_of_birth": {
							"label": "Data de nascimento"
						},
						"first_name": {
							"label": "Nome próprio"
						},
						"last_name": {
							"label": "Apelido"
						},
						"person_identity_document": {
							"label": "Documento de identidade"
						},
						"person_proof_of_address": {
							"label": "Comprovativo de morada"
						},
						"personal_identifier": {
							"label": "ID pessoal"
						}
					},
					"should_auto_capture_orders": {
						"label": "Gostaria de capturar encomendas automaticamente?",
						"tooltip": "As encomendas devem ser capturadas quando são entregues nas lojas ou quando são enviadas a partir de um armazém. Ao selecionar a captura automática, a encomenda será capturada automaticamente quando o consumidor confirmar a compra."
					}
				},
				"contract_entity": {
					"label": "Entidade contratual"
				},
				"contract_onboarding_type": {
					"label": "Tipo de integração de parceiro comercial"
				},
				"underwriting_inquiry_email": {
					"label": "Subscrição por e-mail"
				},
				"bank_accounts": {
					"account_holder": {
						"label": "Nome do titular da conta"
					},
					"account_number": {
						"label": "Número de conta"
					},
					"bic": {
						"label": "Código BIC"
					},
					"iban": {
						"label": "Número da Conta (IBAN)"
					},
					"is_default": {
						"label": "Utilize esta conta para moedas não especificadas"
					},
					"routing_number": {
						"label": "Número de encaminhamento"
					}
				},
				"in_stores": {
					"contact_email": {
						"label": "E-mail de contacto"
					},
					"name": {
						"label": "Nome da loja"
					},
					"support_email": {
						"label": "E-mail de apoio ao cliente"
					},
					"support_phone": {
						"label": "Número de telefone de apoio"
					},
					"business_concepts": {
						"options": {
							"TRADITIONAL_SALE_OF_GOODS": "Venda tradicional de mercadorias",
							"VOUCHER": "Voucher",
							"MEMBERSHIP": "Adesão",
							"SUBSCRIPTION": "Subscrição",
							"PHARMACIES": "Farmácias",
							"US_PHARMACIES": "Farmácias dos EUA",
							"MEDICAL_SERVICES": "Serviços médicos",
							"MARKETPLACES": "Mercados",
							"FIREARM_DEALERS": "Comerciantes de armas",
							"AUCTIONS": "Leilões",
							"ALCOHOL": "Álcool",
							"TOBACCO": "Tabaco",
							"HEMP_CBD_THC": "Cânhamo, canabidiol (CBD) ou tetra-hidrocanabinol (THC)",
							"DONATIONS_CHARITY": "Donativos e beneficência",
							"TRAVEL": "Viagens",
							"EVENTS": "Eventos",
							"COURSES": "Cursos",
							"EDUCATIONAL_COURSES": "",
							"FOOD_DELIVERY": "",
							"CUSTOMISED_PRE_ORDER_FURNITURE": "",
							"DIGITAL_CONTENT": "",
							"GAMING_INDUSTRY": ""
						}
					}
				},
				"terms_and_conditions": {
					"default": "Termos e condições",
					"UPSELL_WEBSTORE_TO_KPOS": "Termos para Klarna nas lojas"
				},
				"pricing_terms": {
					"default": "Termos de Preços",
					"UPSELL_WEBSTORE_TO_KPOS": "Preços para Klarna nas lojas"
				}
			}
		},
		"group": {
			"title": {
				"additional_data": "Informações adicionais",
				"bank_account": "Quais são os dados da sua conta bancária?",
				"business_size": "Qual é o seu volume anual esperado através do Ponto de Venda Klarna?",
				"in_store_get_started": "Dê arranque ao seu negócio com Klarna.",
				"in_store_legal_form": "Que tipo de negócio tem?",
				"in_store_registered_address": "Qual é a sua sede social?",
				"in_store_registration": "A sua empresa está registada?",
				"in_store_stakeholder": "Quem gere a empresa?",
				"in_store_stores": "Quais são as informações da sua loja para o Ponto de Venda Klarna?",
				"in_store_vat": "O número de contribuinte está registado para IVA?",
				"product_channel": "Como é que a sua empresa planeia utilizar o Ponto de Venda Klarna?",
				"sensitive_goods": "Que categoria de produtos estará a vender com o Ponto de Venda Klarna?",
				"ads_manager_get_started": "Está quase.",
				"content_store_get_started": "Está quase."
			},
			"subtitle": {
				"additional_data": "Estamos a rever a sua candidatura e precisamos de mais algumas informações para continuar.",
				"bank_account": "As transações com a Klarna serão transferidas para esta conta bancária.",
				"business_size": "Precisamos de algumas informações básicas sobre a sua empresa a fim de processarmos a sua candidatura.",
				"in_store_get_started": "Precisamos de algumas informações básicas para o(a) levar ao sítio certo",
				"in_store_legal_form": "Somos obrigados a fazer algumas perguntas específicas com base no seu tipo de negócio.",
				"in_store_registered_address": "É onde a sua empresa está legalmente registada e aparecerá nas suas faturas de cliente Klarna.",
				"in_store_registration": "Precisamos do número de registo da sua empresa a fim de verificar os respetivos dados.",
				"in_store_stakeholder": "Enquanto instituição financeira, somos obrigados a recolher estas informações",
				"in_store_stores": "Utilizaremos estas informações para configurar a sua nova conta de Ponto de Venda Klarna.",
				"in_store_vat": "Se tiver um número de IVA, podemos verificar mais facilmente os dados da sua empresa.",
				"product_channel": "Escolha o seu canal de vendas primário.. Poderá utilizar o Ponto de Venda Klarna para ambos os canais.",
				"sensitive_goods": "A integração autónoma para o Ponto de Venda Klarna não lhe permite vender itens que são definidos pela Klarna como restritos.",
				"ads_manager_get_started": "Forneça um e-mail de faturação para serem enviadas as faturas de campanha. Tem de ser utilizador administrador para ativar a conta e então pode conceder permissões a outros utilizadores.",
				"content_store_get_started": "Antes de obter acesso ao gestor de conteúdos, leia e aceite os nossos termos e condições."
			},
			"summary": {
				"title": "Antes de enviar a sua candidatura, reveja os seus dados"
			},
			"status": {
				"UNDERWRITING_INITIATED": {
					"title": {
						"default": "Estamos a processar o seu pedido. Isto pode demorar algum tempo.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Aguarde...",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Aguarde..."
					},
					"paragraphs": {
						"default": [
							{
								"text": "O seu pedido está a ser processado e estamos a criar a sua nova ID de comerciante."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Estamos a preparar tudo para a sua conta de Ads Manager."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Estamos a preparar tudo para a sua conta de Gestor de Conteúdos."
							}
						]
					}
				},
				"ONBOARDING_COMPLETED": {
					"title": {
						"default": "Parabéns! A sua candidatura foi aprovada.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Está tudo pronto!",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Está tudo pronto!"
					},
					"paragraphs": {
						"default": [
							{
								"text": "Agora vamos integrar a Klarna na sua loja online. Vá ao separador Produtos na sua conta do portal do comerciante para encontrar as suas credenciais de integração e instruções sobre como as utilizar."
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Agora, vamos configurar a sua loja, para que possa começar a receber pagamentos imediatamente."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Vá ao Ads Manager para começar a criar a sua primeira campanha."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Vá ao Gestor de Conteúdos e publique a sua primeira promoção hoje."
							}
						]
					},
					"second_title": {
						"default": "Visite os documentos Klarna para mais informações sobre como integrar a Klarna",
						"UPSELL_WEBSTORE_TO_KPOS": "Precisa de ajuda para configurar a sua loja? Estamos aqui para o/a ajudar",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Precisa de ajuda para utilizar o Ads Manager? Consulte as nossas Perguntas Frequentes ou contacte o nosso apoio a empresas. Ficaremos felizes por ajudar. ",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Precisa de ajuda para utilizar o Gestor de Conteúdos? Consulte as nossas Perguntas Frequentes ou contacte o nosso apoio a empresas. Ficaremos felizes por ajudar. "
					},
					"second_paragraphs": {
						"default": [
							{
								"text": "As nossas diretrizes de melhores práticas podem ajudá-lo a obter o máximo da sua nova parceria connosco."
							},
							{
								"text": "Caixa Klarna",
								"link": "#"
							},
							{
								"text": "Pagamentos Klarna",
								"link": "#"
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Contacte o nosso apoio ao comerciante, teremos muito gosto em ajudar."
							},
							{
								"text": "Contacte o suporte",
								"link": "https://www.klarna.com/se/foretag/butikssupport/"
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Visite as Perguntas Frequentes.",
								"link": "https://portal.klarna.com/?help-page=topic%3Aads-manager"
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Visite as Perguntas Frequentes.",
								"link": "https://portal.klarna.com/?help-page=topic%3Acontent-manager"
							}
						]
					},
					"button_text": {
						"default": "Vamos.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Vamos",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Vamos",
						"UPSELL_WEBSTORE_TO_KPOS": "Começar a vender"
					}
				},
				"MANUAL_UNDERWRITING_INITIATED": {
					"title": "Obrigado! Estamos a analisar a sua candidatura.",
					"badge": "Aprox. 5 a 7 dias",
					"paragraphs": [
						{
							"text": "Receberá um e-mail quando a revisão estiver completa ou se precisarmos de qualquer informação adicional."
						}
					],
					"second_title": "Entretanto, consulte o seu e-mail",
					"second_paragraphs": [
						{
							"text": "Enviamos-lhe um e-mail com o link de assunto “Boas-vindas ao portal do Comerciante Klarna”. Siga os passos para iniciar a sessão e ativar a sua conta."
						}
					]
				},
				"SUSPENDED": {
					"title": "Lamentamos, mas a sua candidatura não foi aprovada.",
					"paragraphs": [
						{
							"text": "Depois de rever os seus dados empresariais, não podemos avançar com a sua candidatura <strong>{businessName}</strong>."
						},
						{
							"text": "Estas são algumas das razões mais comuns:"
						},
						{
							"list": [
								{
									"text": "A sua loja não cumpre as diretrizes éticas da Klarna."
								},
								{
									"text": "Não é possível contactar o seu serviço de apoio ao cliente."
								},
								{
									"text": "Outros fatores administrativos."
								}
							]
						},
						{
							"text": "Obrigado pelo seu interesse pela <strong>Klarna [nas lojas]</strong>; esperamos poder fazer negócios no futuro."
						}
					],
					"second_title": "Se tiver mais alguma questão",
					"second_paragraphs": [
						{
							"text": "Sobre a nossa decisão ou sobre qualuer produto Klarna, contacte-nos e teremos todo o gosto em dar-lhe assistência."
						}
					]
				}
			},
			"stakeholders": {
				"LEGAL_REPRESENTATIVE": {
					"title": {
						"default": "Quem assina os contratos na sua empresa?"
					},
					"subtitle": {
						"default": [
							{
								"text": "A sua empresa está prestes a celebrar um contrato com a Klarna. Precisamos de verificar quem está legalmente autorizado a assinar contratos."
							}
						]
					}
				},
				"OWNER": {
					"title": {
						"default": "Existem pessoas que detenham mais de 25% da empresa?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Como instituição financeira, somos obrigados por lei a recolher estas informações."
							}
						],
						"default": [
							{
								"text": "Precisamos de saber quem são as pessoas que detêm mais de 25% das ações ou direitos de voto da empresa ou exercem um controlo semelhante. Somos obrigados por lei pela diretiva antilavagem de dinheiro da UE ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") a recolher estas informações."
							}
						]
					}
				},
				"ALTERNATIVE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Quem gere a empresa?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Somos obrigados por lei pela diretiva antilavagem de dinheiro da UE ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") a recolher estas informações."
							}
						],
						"US": [
							{
								"text": "Como instituição financeira, somos obrigados por lei a recolher estas informações."
							}
						],
						"CA": [
							{
								"text": "Como instituição financeira, somos obrigados por lei a recolher estas informações."
							}
						],
						"AU": [
							{
								"text": "Como instituição financeira, somos obrigados por lei a recolher estas informações."
							}
						]
					}
				},
				"ULTIMATE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Existem pessoas que detenham mais de 25% da empresa?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Como instituição financeira, somos obrigados por lei a recolher estas informações."
							}
						],
						"default": [
							{
								"text": "Precisamos de saber quem são as pessoas que detêm mais de 25% das ações ou direitos de voto da empresa ou exercem um controlo semelhante. Somos obrigados por lei pela diretiva antilavagem de dinheiro da UE ("
							},
							{
								"text": "UE 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") a recolher estas informações."
							}
						]
					}
				}
			}
		},
		"product-selection-container": {
			"products": {
				"products_block": {
					"title_1": "Soluções",
					"title_2": "Formas de pagamento",
					"note": "Todos os preços são por transação.",
					"per_transaction": "por transação",
					"cross_border_notice": "Podem aplicar-se taxas transfronteiriças adicionais",
					"cross_border_notice_pricing_annex_suffix": {
						"before_link": "consulte",
						"link_text": "anexo de preços"
					},
					"not_available_for_business": "Não disponível para a sua empresa",
					"not_available_for_country": "Apenas pode vender para outros mercados",
					"not_compatible_with_platform": "Não disponível para a sua plataforma",
					"installed": "Instalado"
				},
				"buttons": {
					"next": "Seguinte"
				}
			}
		}
	}
};